/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint react/prop-types: 0 */
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
/* eslint-disable import/no-extraneous-dependencies */
// eslint-disable-next-line import/no-webpack-loader-syntax
/* eslint-disable */
import moment from 'moment';
import { v1 as uuidv1 } from 'uuid';
import cssContent from 'css-loader!./../../helpers/popups/popups.css';
import interact from 'interactjs';
/* eslint-enable */
import boardTypes from '@modules/boards/features/constants';
import axios from 'axios';
import 'brace/mode/c_cpp';
import 'brace/mode/javascript';
import 'brace/theme/chrome';
import 'brace/theme/dracula';
import 'brace/theme/github';
import 'brace/theme/tomorrow_night_blue';
import * as routes from '@educabot/educablocks-cosmos';
import { Steps } from 'intro.js-react';
import AceEditor from 'react-ace';
import ReactDOMServer from 'react-dom/server';
import { connect } from 'react-redux';
import Switch from 'react-switch';
import { bindActionCreators } from 'redux';
import MLPanel from '@modules/blockly/components/MLPanel';
import { setMLActive } from '@modules/blockly/features/blocklySlice';
import { createElementFromHTML, getHtmlByTutorialCodename } from '../../helpers/CoolFunctions';
import { loadExt } from '../../helpers/LoadAndKillerScripts';
import Responsive from '../../helpers/Responsive';
import { getAgentDownloadLink } from '../../helpers/AgentDownloadLink';
import events from '../../helpers/events'; //eslint-disable-line
import '../../helpers/popups/popups.scss';
import * as profiles from '../../helpers/profiles';
import ButtonV2 from '../../resources/components/buttons/buttonV2';
import AssignmentLinkComponent from '../AssignmentSession/AssignmentLinkComponent';
import SaveAssignmentProjectFormComponent from '../AssignmentSession/SaveAssignmentProjectFormComponent';
import StopWatch from '../Chronometer/StopWatch';
import CollaborationLinkComponent from '../CollaborationSession/CollaborationLinkComponent';
import SaveCollaborationProjectFormComponent from '../CollaborationSession/SaveCollaborationProjectFormComponent';
import InputComponent from '../FormElements/InputComponent';
import TextAreaComponent from '../FormElements/textAreaComponent';
import RightPanel from '../RightPanel';
import SelectBoards from '../SelectBoards';
import SelectPorts from '../SelectPorts';
import SerialMonitor from '../SerialMonitor/SerialMonitor';
import Tooltip from '../Tooltip';
import { SimulatorModes } from '../../helpers/simulator/constants';
import './BlocklyPanel.scss';
import './Drone.scss';
// import * as AssignmentSession from '../AssignmentSession';
import {
  actionAssignmentSessionProjectUpdate,
  actionAssignmentSessionProjectsPost,
  actionAssignmentSessionRefresh,
  actionGetAssignmentDeliverableState,
  actionResetAssignmentSessionStatus,
  actionSetAssignmentDeliverableState,
} from '../../actions/assignmentSessionAction';
import {
  actionProjectsDelete,
  actionProjectsPost,
  actionProjectsPut,
  actionProjectsSaveAsCode,
  actionResetStatus,
  actionBoardConnectionInfoPost,
} from '../../actions/projectsAction';
import {
  actionPostRemoteSessionCompilation,
  actionPutBulkRemoteSessionCompilation,
  actionPutRemoteSession,
  actionPutRemoteSessionCompilation,
  actionPutRemoteSessionProjectBulk,
  actionRemoteSessionLoginGet,
  actionRemoteSessionProjectDelete,
  actionRemoteSessionProjectDeleteOne,
  actionRemoteSessionProjectUpdate,
  actionRemoteSessionProjectsPost,
  actionRemoteSessionRefresh,
  actionRemoteSessionStreamGet,
  actionResetRemoteSessionStatus,
} from '../../actions/remoteSessionAction';
import { getRightPanelData } from '../../actions/rightPanelAction';
import { actionProjectTagsPost } from '../../actions/tagsAction';
import Codit from '../../helpers/Codit';
import Drone from '../../helpers/Drone';
import { store } from '../../state/store';
import BottomNavCodit from '../BottomNavCodit';
import BottomNavDrone from '../BottomNavDrone';
import CanvasSVG from '../CanvasSVG';
import ModalLogin from '../ModalLogin';
import Selector from '../Selector';
import BottomNav from './BottomNav';

import './bottomNav.scss';
import './react-upload-image.scss';
import './uploadImageField.scss';
// import { remote } from 'electron';
import * as pjson from '../../../package.json';
import { getLocale } from '../../config/locale';
import WebSocketClient from '../../helpers/WebSocketClient';
import Agent from '../../helpers/agent';
import ArduinoSimulator from './ArduinoSimulator';
import ProjectSidebar from './ProjectSidebar';
import UploadImageField from '../UploadImageField';

let collabSocket = null;
const $ = window.$;

class BlocklyPanel extends Component {
  constructor(props) {
    super(props);
    collabSocket = null;
    this.state = {
      lang: getLocale().locale,
      socket: (props.tabInfo.board.profile !== 'codit' && props.tabInfo.board.profile !== 'drone' && props.tabInfo.board.profile !== 'drone13') ? new Agent(store, props.tabInfo.board) : null,
      boards: props.boards,
      boardType: props.tabInfo.boardType,
      actionStatus: {
        projects: {
          statusPost: '',
        },
      },
      reSaveTags: false,
      toolboxToggle: props.toolboxToggle,
      darkthemeToggle: props.darkthemeToggle,
      tabInfo: props.tabInfo,
      waitForDiagramImage: false,
      id: props.id,
      tagsToSave: [],
      tags: props.tags,
      demoWorkspace: null,
      codeGenerated: '',
      consoleGenerated: '',
      code: props.tabInfo.code || (props.tabInfo.board.compilerBoard !== 'microbit') ? `void setup() {

}

void loop() {

}` : '',
      className: props.className,
      deleteWarning: false,
      connectionModalType: 0, // 0 = regular, 1 = requires user action (microbit)
      microbitModalBuildFinished: false,
      microbitForceDownload: (process.env.IS_ELECTRON),
      microbitTempBuild: {
        compileFromQueueId: null,
        remoteProjectId: null,
        port: '',
      },
      saveButtonDisabled: false,
      doOnReady: props.doOnReady,
      saveForm: {
        id: (props.tabInfo.projectId) ? props.tabInfo.projectId : null,
        name: (props.tabInfo.name) ? props.tabInfo.name : '',
        description: (props.tabInfo.description) ? props.tabInfo.description : '',
        public: (props.auth.userData.data?.userId === props.tabInfo.userId) ? props.tabInfo.isPublic : false,
        library: (props.auth.userData.data?.userId === props.tabInfo.userId) ? props.tabInfo.isLibrary : false,
        videoUrl: props.tabInfo.videoUrl || '',
        diagramImageUrl: props.tabInfo.diagramImageUrl || '',
        challenge1: (props.tabInfo.challenges && props.tabInfo.challenges[0]) ? props.tabInfo.challenges[0] : '',
        challenge2: (props.tabInfo.challenges && props.tabInfo.challenges[1]) ? props.tabInfo.challenges[1] : '',
        challenge3: (props.tabInfo.challenges && props.tabInfo.challenges[2]) ? props.tabInfo.challenges[2] : '',
        extraMaterialUrl: props.tabInfo.extraMaterialUrl || '',
        remoteSession: (props.tabInfo.remoteSession),
        remoteProject: (props.tabInfo.remoteProject),
        remoteProjectPasswordToggle: (typeof props.tabInfo.remoteProjectPasswordToggle !== 'undefined') ? (props.tabInfo.remoteProjectPassword) : false,
        remoteProjectPassword: props.tabInfo.remoteProjectPassword || '',
        remoteUserRole: (props.tabInfo.remoteUserRole) ? props.tabInfo.remoteUserRole : 'STUDENT',
        remoteSessionNeedInit: (props.tabInfo.remoteSessionNeedInit) ? props.tabInfo.remoteSessionNeedInit : false,
        remoteSessionLogged: true,
        remoteSessionPrivate: false,
        password: null,
        collaborationSession: (props.tabInfo.collaborationSession) ? props.tabInfo.collaborationSession : 0,
        collaborationProject: (props.tabInfo.collaborationProject),
        collaborationProjectUserRole: (props.tabInfo.collaborationProjectUserRole) ? props.tabInfo.collaborationProjectUserRole : 'STUDENT',
        assignmentProject: (props.tabInfo.assignmentProject),
        assignmentSession: (props.tabInfo.assignmentSession) ? props.tabInfo.assignmentSession : 0,
        assignmentProjectPassword: (props.tabInfo.assignmentProjectPassword) ? props.tabInfo.assignmentProjectPassword : '',
        assignmentProjectDeliveryDate: (props.tabInfo.assignmentProjectDeliveryDate) ? props.tabInfo.assignmentProjectDeliveryDate : '',
        assignmentProjectPasswordToggle: (typeof props.tabInfo.assignmentProjectPasswordToggle !== 'undefined') ? (props.tabInfo.assignmentProjectPassword) : false,
        assignmentUserRole: (props.tabInfo.assignmentUserRole) ? props.tabInfo.assignmentUserRole : 'STUDENT',
        simulator: (props.tabInfo.simulator) ? props.tabInfo.simulator : null,
      },
      rightPanel: {
        type: '',
        data: {},
        status: 0, // 0 = collapsed,  1 = open
        children: '',
        panelDimensions: 'right-panel-wide', // right-panel-narrow
      },
      activeOptionalFields: {
        videoUrl: false,
        diagramImageUrl: false,
        challenges: false,
        extraMaterialUrl: false,
      },
      responsive: new Responsive(this),
      scriptsToLoad: [],
      drone: new Drone(props.tabInfo.board.profile),
      codit: new Codit(),
      blocklyOptions: {
        media: `${process.env.IS_ELECTRON ? '.' : ''}/images/media/`,
        comments: false,
        toolbox: `toolbox-${props.id}`,
        trashcan: false,
        collapse: true,
        disable: true,
        oneBasedIndex: true,
        blocklyToolboxDiv: `blocklyToolboxDiv blocklyToolboxDiv-${props.id} blocklyToolboxDiv-${(props.toolboxToggle) ? 'icons' : 'text'}`,
        // blocklyToolboxDiv: `blocklyToolboxDiv-jr blocklyToolboxDiv blocklyToolboxDivJr blocklyToolboxDiv-${props.id} blocklyToolboxDiv-${(props.toolboxToggle) ? 'icons' : 'text'}`,
        zoom: {
          controls: false,
          wheel: true,
          startScale: 0.8,
          defaultScale: 0.8,
          maxScale: 3,
          minScale: 0.3,
          scaleSpeed: 1.2,
        },
      },
      codeToggle: false,
      arduinoSimulatorToggle: false,
      droneSimulationToggle: false,
      remoteThumbsToggle: false,
      consoleToggle: false,
      consoleEditor: null,
      consoleMonitorMaxChars: 1000,
      ports: props.bloques.ports,
      agentPorts: props.bloques.agentPorts,
      bottomNav: {
        progressbar: 0,
        ebBuildStatus: '',
        arduinoAgentStatus: '',
      },
      webSerialModalState: {
        step: 0,
        connected: false,
        error: null,
      },
      remoteSessionObj: {
        id: 0,
        password: '',
        users: [],
        projects: [],
        lastCheckForUpdates: 0,
        lastCheckForWriting: 0,
        jitsiApi: null,
        compilationActiveQueueModalTab: 0, // 0: PENDING; 1: COMPILED/REJECTED
        gamificationActiveQueueModalIndex: -1,
        errorMsg: '',
        gaificationBadges: [
          { name: 'Colaboración', class: 'icon-group-users', image: 'grupo.svg' },
          { name: 'Puntualidad', class: 'icon-clock2', image: 'reloj.svg' },
          { name: 'Creatividad', class: 'icon-iconfinder_idea_4177619', image: 'idea.svg' },
          { name: 'Participación', class: 'icon-mic', image: 'mic.svg' },
          { name: 'Esfuerzo', class: 'icon-muscle', image: 'musculo.svg' },
          { name: 'Programación', class: 'icon-code', image: 'codigo.svg' },
          { name: 'Felicitaciones', class: 'icon-thumb_up', image: 'megusta.svg' },
        ],
        youtubeVideoContent: 0,
        youtubeVideoSources: [],
        canvasCSS: '',
        MyRemoteSessionProjectId: 0,
        projectsIdVisibilityList: [],
      },
      assignmentSessionObj: {},
      blocklyInited: false,
      canShowStep: Boolean(props.tabInfo.withToolTip),
      preWorkspace: props.tabInfo.withWorkspace,
      loading: true,
      saving: false,
      building: false,
      isLogged: false,
      actualWidth: window.innerWidth,
      intervalAutoSave: null,
      intervalRemoteSession: null,
      intervalMicrobit: null,
      intervalPorts: null,
      // compilationNoticeModalHex: '',
      // compilationNoticeModalProjectId: 0,
      userAgent: {},
    };

    this.initBlockly = this.initBlockly.bind(this);
    this.buildBlockly = this.buildBlockly.bind(this);
    this.codeToggleAction = this.codeToggleAction.bind(this);
    this.mlPanelToggleAction = this.mlPanelToggleAction.bind(this);
    this.arduinoSimulatorToggleAction = this.arduinoSimulatorToggleAction.bind(this);
    this.droneSimulationToggleAction = this.droneSimulationToggleAction.bind(this);
    this.consoleToggleAction = this.consoleToggleAction.bind(this);
    this.selectPortChange = this.selectPortChange.bind(this);
    this.selectBoardChange = this.selectBoardChange.bind(this);
    this.toggleSerialMonitor = this.toggleSerialMonitor.bind(this);
    this.closeSerialMonitor = this.closeSerialMonitor.bind(this);
    this.toggleDeleteWarning = this.toggleDeleteWarning.bind(this);
    this.endSteps = this.endSteps.bind(this);
    this.startSteps = this.startSteps.bind(this);
    this.setZoom = this.setZoom.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.setUndo = this.setUndo.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.refConsoleEditor = this.refConsoleEditor.bind(this);
    this.afterLoadBlocklyPanel = this.afterLoadBlocklyPanel.bind(this);
    this.closeRightPanel = this.closeRightPanel.bind(this);
    this.checkBottomStatusAgainsProps = this.checkBottomStatusAgainsProps.bind(this);
    this.changeField = this.changeField.bind(this);
    this.saveProjectInDb = this.saveProjectInDb.bind(this);
    this.handleEditCode = this.handleEditCode.bind(this);
    this.selectorUpdate = this.selectorUpdate.bind(this);
    this.toggleFieldShown = this.toggleFieldShown.bind(this);
    this.checkBottomStatusAgainsProps(props);
    this.toastSend = this.toastSend.bind(this);
    this.toastClear = this.toastClear.bind(this);
    this.exportSVG = this.exportSVG.bind(this);
    this.export = this.export.bind(this);
    this.buildBlocklyDrone = this.buildBlocklyDrone.bind(this);
    this.buildBlocklyCodit = this.buildBlocklyCodit.bind(this);
    this.setImageValue = this.setImageValue.bind(this);
    this.shootMsg = this.shootMsg.bind(this);
    this.saveRemoteSession = this.saveRemoteSession.bind(this);
    this.isAnyChangeInProject = this.isAnyChangeInProject.bind(this);
    this.initRemoteSession = this.initRemoteSession.bind(this);
    this.remoteSessionDeleteAllModal = this.remoteSessionDeleteAllModal.bind(this);
    this.remoteSessionDeleteAllModalAccept = this.remoteSessionDeleteAllModalAccept.bind(this);
    this.remoteSessionDeleteOneModalAccept = this.remoteSessionDeleteOneModalAccept.bind(this);
    this.remoteSessionDeleteOneModalCancel = this.remoteSessionDeleteOneModalCancel.bind(this);
    this.remoteThumbsToggleAction = this.remoteThumbsToggleAction.bind(this);
    this.initJitsi = this.initJitsi.bind(this);
    this.remoteToggleChronometerAll = this.remoteToggleChronometerAll.bind(this);
    this.remoteSessionChronometerUpdate = this.remoteSessionChronometerUpdate.bind(this);
    this.remoteThumbToggleJitsiAll = this.remoteThumbToggleJitsiAll.bind(this);
    this.remoteThumbToggleJitsi = this.remoteThumbToggleJitsi.bind(this);
    this.changeRemotePassword = this.changeRemotePassword.bind(this);
    this.executeChangeRemotePassword = this.executeChangeRemotePassword.bind(this);
    this.remoteSessionTogglePrivate = this.remoteSessionTogglePrivate.bind(this);
    this.remoteThumbToggleYouTube = this.remoteThumbToggleYouTube.bind(this);
    this.remoteThumbToggleYouTubeAll = this.remoteThumbToggleYouTubeAll.bind(this);
    this.launchDroneSimulation = this.launchDroneSimulation.bind(this);
    this.fullScreenDroneSimulation = this.fullScreenDroneSimulation.bind(this);
    this.saveCode = this.saveCode.bind(this);
    this.assignmentSessionDeliverActivity = this.assignmentSessionDeliverActivity.bind(this);
    this.handleAgentPortsChange = this.handleAgentPortsChange.bind(this);
    this.updateSimulatorState = this.updateSimulatorState.bind(this);
    this.webSerialModalChangeStep = this.webSerialModalChangeStep.bind(this);
    this.webSerialModalChangeLink = this.webSerialModalChangeLink.bind(this);
    this.webSerialModalDownloadAgent = this.webSerialModalDownloadAgent.bind(this);
    this.webSerialModalMicrobitForceDownload = this.webSerialModalMicrobitForceDownload.bind(this);

    window.oldMessage = null;
    window.exposeProps = this;
    // parent assignation
    const { tabInfo } = props;
    tabInfo.setZoom = this.setZoom;
    tabInfo.setCenter = this.setCenter;
    tabInfo.setUndo = this.setUndo;
    tabInfo.startSteps = this.startSteps;
    tabInfo.closeRightPanel = this.closeRightPanel;
    tabInfo.exportSVG = this.exportSVG;
    tabInfo.export = this.export;
    tabInfo.saveProjectInDb = this.saveProjectInDb;
    tabInfo.initRemoteSession = this.initRemoteSession;
  }

  componentDidMount() {
    const { blocklyState, assignmentSessionRefresh, getAssignmentDeliverableState, auth, intl } = this.props;
    const { remoteSessionObj, saveForm, tabInfo, rightPanel, boardType, intervalMicrobit, intervalPorts, socket } = this.state;

    setMLActive(tabInfo.board.iaModel !== undefined);
    // console.log('===============tabInfo', tabInfo, saveForm);
    if (window.navigator.userAgentData) {
      window.navigator.userAgentData.getHighEntropyValues(
        ['architecture', 'model', 'bitness', 'platformVersion', 'fullVersionList'],
      ).then(ua => {
        // console.log('===============userAgentData', ua);
        if (socket) {
          socket.setPlatform(ua.platform);
        }
        this.setState({ userAgent: ua });
        setTimeout(() => {
          this.setState({ consoleGenerated: this.createConsoleString([`${intl.formatMessage({ id: 'blocks.blockly.platform' })}: ${ua.platform}`]) });
        }, 5000);
      });
    } else if (window.navigator.userAgent) {
      const ua = {
        platform: '',
        bitness: '',
        platformVersion: '',
      };
      if (window.navigator.userAgent.indexOf('CrOS') !== -1) {
        ua.platform = 'ChromeOS';
      } else if (window.navigator.userAgent.indexOf('Windows') !== -1) {
        ua.platform = 'Windows';
      } else if (window.navigator.userAgent.indexOf('Linux') !== -1 || window.navigator.userAgent.indexOf('Ubuntu') !== -1 || window.navigator.userAgent.indexOf('Unix') !== -1) {
        ua.platform = 'Linux';
      }
      if (socket) {
        socket.setPlatform(ua.platform);
      }
      ua.bitness = '32';
      if (window.navigator.userAgent.indexOf('x86_64') !== -1 || window.navigator.userAgent.indexOf('x64') !== -1) {
        ua.bitness = '64';
      }

      this.setState({ userAgent: ua });
      setTimeout(() => {
        this.setState({ consoleGenerated: this.createConsoleString([`Plataforma: ${ua.platform}`]) });
      }, 5000);
      // console.log('===============UA', ua, window.navigator.userAgent);
    }

    if (tabInfo.active && tabInfo.board.compilerBoard !== 'microbit' && tabInfo.board.profile !== 'codit' && tabInfo.board.profile !== 'drone' && tabInfo.board.profile !== 'drone13' && !intervalPorts) {
      const intervalPortsId = setInterval(() => {
        socket.findPorts();
      }, 1000);
      clearInterval(intervalMicrobit);
      this.setState({ intervalPorts: intervalPortsId, intervalMicrobit: null });
    }
    if (!tabInfo.active && tabInfo.board.compilerBoard === 'microbit' && intervalMicrobit) {
      clearInterval(intervalMicrobit);
      this.setState({ intervalMicrobit: null });
    }
    if (!tabInfo.active && tabInfo.board.compilerBoard !== 'microbit' && intervalPorts) {
      clearInterval(intervalPorts);
      this.setState({ intervalPorts: null });
    }

    // console.log('didmount------------------', saveForm, tabInfo);
    if (tabInfo.collaborationProject) {
      collabSocket = new WebSocketClient({ userId: auth.userData.data.userId || 0 });
    }
    this.loadBlocklyPanel();

    if (boardType === 'code') {
      /* eslint-disable */
      window.ace.define("ace/snippets/c_cpp", ["require", "exports", "module"], function (e, t, n) { "use strict"; t.snippetText = "## STL Collections\n# std::array\nsnippet array\n	std::array<${1:T}, ${2:N}> ${3};${4}\n# std::vector\nsnippet vector\n	std::vector<${1:T}> ${2};${3}\n# std::deque\nsnippet deque\n	std::deque<${1:T}> ${2};${3}\n# std::forward_list\nsnippet flist\n	std::forward_list<${1:T}> ${2};${3}\n# std::list\nsnippet list\n	std::list<${1:T}> ${2};${3}\n# std::set\nsnippet set\n	std::set<${1:T}> ${2};${3}\n# std::map\nsnippet map\n	std::map<${1:Key}, ${2:T}> ${3};${4}\n# std::multiset\nsnippet mset\n	std::multiset<${1:T}> ${2};${3}\n# std::multimap\nsnippet mmap\n	std::multimap<${1:Key}, ${2:T}> ${3};${4}\n# std::unordered_set\nsnippet uset\n	std::unordered_set<${1:T}> ${2};${3}\n# std::unordered_map\nsnippet umap\n	std::unordered_map<${1:Key}, ${2:T}> ${3};${4}\n# std::unordered_multiset\nsnippet umset\n	std::unordered_multiset<${1:T}> ${2};${3}\n# std::unordered_multimap\nsnippet ummap\n	std::unordered_multimap<${1:Key}, ${2:T}> ${3};${4}\n# std::stack\nsnippet stack\n	std::stack<${1:T}> ${2};${3}\n# std::queue\nsnippet queue\n	std::queue<${1:T}> ${2};${3}\n# std::priority_queue\nsnippet pqueue\n	std::priority_queue<${1:T}> ${2};${3}\n##\n## Access Modifiers\n# private\nsnippet pri\n	private\n# protected\nsnippet pro\n	protected\n# public\nsnippet pub\n	public\n# friend\nsnippet fr\n	friend\n# mutable\nsnippet mu\n	mutable\n## \n## Class\n# class\nsnippet cl\n	class ${1:`Filename('$1', 'name')`} \n	{\n	public:\n		$1(${2});\n		~$1();\n\n	private:\n		${3:/* data */}\n	};\n# member function implementation\nsnippet mfun\n	${4:void} ${1:`Filename('$1', 'ClassName')`}::${2:memberFunction}(${3}) {\n		${5:/* code */}\n	}\n# namespace\nsnippet ns\n	namespace ${1:`Filename('', 'my')`} {\n		${2}\n	} /* namespace $1 */\n##\n## Input/Output\n# std::cout\nsnippet cout\n	std::cout << ${1} << std::endl;${2}\n# std::cin\nsnippet cin\n	std::cin >> ${1};${2}\n##\n## Iteration\n# for i \nsnippet fori\n	for (int ${2:i} = 0; $2 < ${1:count}; $2${3:++}) {\n		${4:/* code */}\n	}${5}\n\n# foreach\nsnippet fore\n	for (${1:auto} ${2:i} : ${3:container}) {\n		${4:/* code */}\n	}${5}\n# iterator\nsnippet iter\n	for (${1:std::vector}<${2:type}>::${3:const_iterator} ${4:i} = ${5:container}.begin(); $4 != $5.end(); ++$4) {\n		${6}\n	}${7}\n\n# auto iterator\nsnippet itera\n	for (auto ${1:i} = $1.begin(); $1 != $1.end(); ++$1) {\n		${2:std::cout << *$1 << std::endl;}\n	}${3}\n##\n## Lambdas\n# lamda (one line)\nsnippet ld\n	[${1}](${2}){${3:/* code */}}${4}\n# lambda (multi-line)\nsnippet lld\n	[${1}](${2}){\n		${3:/* code */}\n	}${4}\n", t.scope = "c_cpp" })
      /* eslint-enable */
    }

    if (tabInfo.assignmentSession && saveForm.id) {
      saveForm.assignmentSession = tabInfo.assignmentSession;
      assignmentSessionRefresh(tabInfo.assignmentSession, saveForm.id);
    }
    if (tabInfo.remoteSession && tabInfo.remoteSessionStarted) {
      // remoteSessionObj.projects[0] = { id: tabInfo.remoteSession };
      remoteSessionObj.id = tabInfo.remoteSession;
      saveForm.remoteProject = true;
      saveForm.remoteProjectPasswordToggle = false;
      saveForm.remoteProjectPassword = '';
      saveForm.remoteSession = tabInfo.remoteSession;
      saveForm.password = null;
      saveForm.remoteSessionLogged = true;
      saveForm.remoteSessionPrivate = false;
      this.setState({ remoteSessionObj, saveForm });
    }

    // console.log('====DIDMOUNT', saveForm, tabInfo, getAssignmentDeliverableState);
    if (tabInfo.remoteSession && tabInfo.remoteSessionStarted && getAssignmentDeliverableState) {
      const intervalRS = setInterval(() => {
        if (saveForm.id && tabInfo.active && !tabInfo.disabled && !tabInfo.remoteSessionNeedInit && tabInfo.userId && auth.userData.data.userId === tabInfo.userId) {
          this.saveRemoteSession();
        }
      }, 5000);
      this.setState({ intervalRemoteSession: intervalRS });
    }

    const intervalAS = setInterval(() => {
      if (!tabInfo.remoteSession && (saveForm.autoSave || tabInfo.collaborationProject) && saveForm.id && tabInfo.active && !tabInfo.disabled && getAssignmentDeliverableState) {
        if (rightPanel.status === 0 && tabInfo.userId && auth.userData.data.userId === tabInfo.userId) {
          this.saveProjectInDb(null, true);
        }
      }
    }, 60000);
    this.setState({ intervalAutoSave: intervalAS });
  }

  componentWillReceiveProps(newprops) {
    const {
      remoteSessionObj, tabInfo, consoleEditor, toolboxToggle, darkthemeToggle, rightPanel,
      demoWorkspace, isLogged, saveForm, reSaveTags, actionStatus, boardType, code,
      intervalMicrobit, intervalPorts, intervalRemoteSession, intervalAutoSave, socket,
    } = this.state;
    const {
      GRPD, resetRemoteSessionStatus, remoteSessionProjectUpdate, putRemoteSessionCompilation, intl,
      auth, resetAssignmentSessionStatus, setAssignmentDeliverableState, assignmentSessionRefresh,
    } = this.props;
    // console.log('=====================AGENT', 'serial' in navigator, socket.board.name);
    // console.log('newprops-------', newprops);

    if (newprops.tabInfo.code !== code && tabInfo.board.compilerBoard === 'microbit') {
      this.setState({ code: newprops.tabInfo.code });
    }

    if (!tabInfo.active) {
      this.closeSerialMonitor();
      // this.setState({ arduinoSimulatorToggle: false });
    }
    if (tabInfo.active && tabInfo.board.compilerBoard !== 'microbit' && tabInfo.board.profile !== 'codit' && tabInfo.board.profile !== 'drone' && tabInfo.board.profile !== 'drone13' && !intervalPorts) {
      const intervalPortsId = setInterval(() => {
        socket.findPorts();
      }, 1000);
      clearInterval(intervalMicrobit);
      this.setState({ intervalPorts: intervalPortsId, intervalMicrobit: null });
    }
    // if (tabInfo.active && tabInfo.board.compilerBoard === 'microbit' && !intervalMicrobit) {
    //   const intervalMicrobitId = setInterval(() => {
    //     socket.findMicrobitDrive();
    //   }, 4000);
    //   clearInterval(intervalPorts);
    //   this.setState({ intervalPorts: null, intervalMicrobit: intervalMicrobitId });
    // }
    if (!tabInfo.active && tabInfo.board.compilerBoard === 'microbit' && intervalMicrobit) {
      clearInterval(intervalMicrobit);
      this.setState({ intervalMicrobit: null });
    }
    if (!tabInfo.active && tabInfo.board.compilerBoard !== 'microbit' && intervalPorts) {
      clearInterval(intervalPorts);
      this.setState({ intervalPorts: null });
    }

    if (newprops.projects.statusPut === 'fetch_auto') {
      if (remoteSessionObj.id) {
        if (newprops.projects.dataPut.lastCheckForWriting && newprops.projects.dataPut.lastCheckForWriting === remoteSessionObj.lastCheckForWriting) {
          remoteSessionObj.lastCheckForWriting = 0;
        }
        // console.log('RE-SAVED!-------------------', newprops.projects.dataPut);
        this.setState({ remoteSessionObj });
      }
      newprops.resetStatus({ statusPut: '' });
      this.shootMsg(intl.formatMessage({ id: 'blocks.blockly.ready' }));
    }

    if (newprops.projects.statusPut === 'fetch_code') {
      newprops.resetStatus({ statusPut: '' });
      window.location.href = `${routes.bloquesCodeUri}-${tabInfo.projectId}`;
    }

    if (newprops.remoteSession.statusPutRemoteSessionProjectBulk === 'fetch') {
      // console.log('FETCHED BULK UPDATE: ', newprops.remoteSession.dataPutRemoteSessionProjectBulk.status);
      resetRemoteSessionStatus({ statusPutRemoteSessionProjectBulk: '' });
    }

    if (newprops.remoteSession.statusPutRemoteSession === 'fetch') {
      // console.log('FETCHED UPDATE: ', newprops.remoteSession.dataPutRemoteSession);
      resetRemoteSessionStatus({ statusPutRemoteSession: '' });
      $('#remoteSessionInvitationModal').modal('hide');
      this.toastSend(
        <span className="body">
          <span className="icon icon-check-circle" />
          <span className="first-line">
            ¡Contraseña modificada!
            <span className="second-line">{(!saveForm.remoteSessionPrivate) ? 'Esta sesión es pública' : 'Esta sesión está protegida con contraseña'}</span>
          </span>
        </span>,
        'R',
        { className: 'code-uploaded', autoClose: true },
      );
    }

    if (newprops.remoteSession.statusRemoteSessionStreamGet === 'fetch') {
      const receivedProps = newprops.remoteSession.dataRemoteSessionStreamGet.data;
      // console.log('REMOTE SESSION STREAM-------------------', newprops.remoteSession.dataRemoteSessionStreamGet.data);

      remoteSessionObj.youtubeVideoSources = [];
      remoteSessionObj.youtubeVideoSources.push('');
      for (let k = 0; k < receivedProps.length; k += 1) {
        if (receivedProps[k].url !== '') {
          remoteSessionObj.youtubeVideoSources.push({ url: receivedProps[k].url, title: receivedProps[k].title, provider: receivedProps[k].provider });
        }
      }

      if (demoWorkspace) {
        if (boardType !== 'code') {
          const canvas = demoWorkspace.svgBlockCanvas_.cloneNode(true); /* eslint-disable-line */
          remoteSessionObj.canvasCSS = `<defs><style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${window.Blockly.Css.CONTENT.join('')}]]></style></defs>`;
        }
      }

      resetRemoteSessionStatus({ statusRemoteSessionStreamGet: '' });
      this.setState({ remoteSessionObj });
    }

    if (newprops.remoteSession.statusRemoteSessionRefresh === 'fetch error') {
      console.log('ERROR:', newprops.remoteSession.dataRemoteSessionRefresh.message);
    }

    if (newprops.remoteSession.statusRemoteSessionRefresh === 'not logged') {
      console.log('ERROR:', newprops.remoteSession.dataRemoteSessionRefresh.message);
      saveForm.remoteSessionLogged = false;
      this.setState({ saveForm });
    }

    if (newprops.remoteSession.statusRemoteSessionRefresh === 'fetch') {
      // console.log('REMOTE SESSION DATA-------------------', newprops.remoteSession.dataRemoteSessionRefresh.data, auth.userData.data);
      const receivedProps = newprops.remoteSession.dataRemoteSessionRefresh.data;

      remoteSessionObj.password = receivedProps.password;
      if (saveForm.password === null) {
        saveForm.password = receivedProps.password;
        if (receivedProps.password !== '' && receivedProps.password !== null) {
          saveForm.remoteSessionPrivate = true;
        }
      }

      remoteSessionObj.projects = [];
      const tempRemoteSessionsProjects = [];
      let hasOwner = false;
      let ownerRemoteSessionProjectId = 0;
      let hasTeacher = false;
      for (let t = 0; t < receivedProps.RemoteSessionsProjects.length; t += 1) {
        if (receivedProps.RemoteSessionsProjects[t].userRole === 'OWNER') {
          hasOwner = true;
          ownerRemoteSessionProjectId = receivedProps.RemoteSessionsProjects[t].id;
        }
        if (receivedProps.RemoteSessionsProjects[t].userRole === 'TEACHER') {
          hasTeacher = true;
        }
        // if (receivedProps.RemoteSessionsProjects[t].Project.userId === receivedProps.userId) {
        if (receivedProps.RemoteSessionsProjects[t].userRole === 'OWNER' || receivedProps.RemoteSessionsProjects[t].userRole === 'TEACHER') {
          remoteSessionObj.projects.push(receivedProps.RemoteSessionsProjects[t]);
        } else {
          tempRemoteSessionsProjects.push(receivedProps.RemoteSessionsProjects[t]);
        }
      }
      remoteSessionObj.projects = remoteSessionObj.projects.concat(tempRemoteSessionsProjects);

      remoteSessionObj.users = [];
      remoteSessionObj.lastCheckForUpdates = 0;
      remoteSessionObj.teacher = {};
      let oldGamificationNotifications = [];
      let doIHaveAProject = false;

      for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
        let gamificationNotifications = [];
        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          remoteSessionObj.MyRemoteSessionProjectId = remoteSessionObj.projects[k].id;
          if (remoteSessionObj.projects[k].settings) {
            if (typeof remoteSessionObj.projects[k].settings.gamification !== 'undefined') {
              gamificationNotifications = Object.keys(remoteSessionObj.projects[k].settings.gamification);
            }
          }
        }

        // if (remoteSessionObj.projects[k].Project.userId === receivedProps.userId) {
        if (remoteSessionObj.projects[k].userRole === 'TEACHER' || (remoteSessionObj.projects[k].userRole === 'OWNER' && typeof remoteSessionObj.teacher.userId === 'undefined')) {
          const settings = remoteSessionObj.projects[k].settings || {};
          if (typeof settings.screenBlocked === 'undefined') {
            settings.screenBlocked = false;
          }
          if (typeof settings.thumbsVisibility === 'undefined') {
            settings.thumbsVisibility = true;
          }
          if (typeof settings.thumbsVisibilityAll === 'undefined') {
            settings.thumbsVisibilityAll = true;
          }
          if (typeof settings.boardAvailability === 'undefined') {
            settings.boardAvailability = true;
          }
          if (typeof settings.boardAvailabilityState === 'undefined') {
            settings.boardAvailabilityState = 'AVAILABLE';
          }
          if (typeof settings.teacherScreenMaximized === 'undefined') {
            settings.teacherScreenMaximized = false;
          }
          if (typeof settings.jitsiVideoAll === 'undefined') {
            settings.jitsiVideoAll = false;
          }
          remoteSessionObj.projects[k].settings = settings;
          remoteSessionObj.teacher = {
            userId: remoteSessionObj.projects[k].Project.userId,
            settings,
            projectIndex: k,
            userIndex: k,
          };
        } else {
          const settings = remoteSessionObj.projects[k].settings || {};
          if (typeof settings.screenBlocked === 'undefined') {
            settings.screenBlocked = false;
          }
          if (typeof settings.thumbsVisibility === 'undefined') {
            settings.thumbsVisibility = true;
          }
          if (typeof settings.boardAvailability === 'undefined') {
            settings.boardAvailability = true;
          }
          if (typeof settings.boardAvailabilityState === 'undefined') {
            settings.boardAvailabilityState = 'AVAILABLE';
          }
          if (typeof settings.copyTeacherScreen === 'undefined') {
            settings.copyTeacherScreen = false;
          }

          remoteSessionObj.projects[k].settings = settings;
        }

        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          oldGamificationNotifications = (typeof remoteSessionObj.projects[k].settings.gamificationNotifications !== 'undefined') ? remoteSessionObj.projects[k].settings.gamificationNotifications : [];
          if (gamificationNotifications.length > 0) {
            remoteSessionObj.projects[k].settings.gamificationNotifications = gamificationNotifications;
            let notificationCount = 0;
            for (let m = 0; m < gamificationNotifications.length; m += 1) {
              if (!oldGamificationNotifications.includes(gamificationNotifications[m])) {
                this.toastSend(
                  <span className="body">
                    <span className={`icon ${remoteSessionObj.gaificationBadges[gamificationNotifications[m]].class}`} />
                    <span className="first-line">
                      ¡Recibiste un premio!
                      <span className="second-line">El docente te ha dado una medalla</span>
                    </span>
                  </span>,
                  'R',
                  { className: 'code-uploaded' },
                );
                notificationCount += 1;
              }
            }
            if (notificationCount > 0) {
              remoteSessionProjectUpdate(
                remoteSessionObj.id,
                remoteSessionObj.projects[k].projectId,
                {
                  settings: remoteSessionObj.projects[k].settings,
                },
              );
            }
          } else {
            remoteSessionObj.projects[k].settings.gamificationNotifications = oldGamificationNotifications;
          }
        }

        remoteSessionObj.users.push({
          id: remoteSessionObj.projects[k].Project.userId,
          projectId: remoteSessionObj.projects[k].Project.id,
          itIsMaster: (remoteSessionObj.projects[k].Project.userId === receivedProps.userId),
          itIsMe: (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId),
          port: remoteSessionObj.projects[k].Project.jsonBody.port,
          onlineAt: remoteSessionObj.projects[k].Project.updatedAt,
          firstName: remoteSessionObj.projects[k].Project.User.firstName,
          lastName: remoteSessionObj.projects[k].Project.User.lastName,
          email: remoteSessionObj.projects[k].Project.User.email,
          avatarUrl: remoteSessionObj.projects[k].Project.User.avatarUrl,
        });

        if (remoteSessionObj.projects[k].RemoteSessionsCompilations && remoteSessionObj.projects[k].RemoteSessionsCompilations.length > 0) {
          const updatedUploadToBoard = remoteSessionObj.projects[k].RemoteSessionsCompilations;
          for (let j = 0; j < updatedUploadToBoard.length; j += 1) {
            if (hasOwner
              && hasTeacher
              && remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId
              && updatedUploadToBoard[j].remoteSessionsProjectId === ownerRemoteSessionProjectId
              && updatedUploadToBoard[j].state === 'PENDING'
              && (tabInfo.port !== '' || tabInfo.board.compilerBoard === 'microbit')
            ) {
              this.buildBlockly(updatedUploadToBoard[j].id, remoteSessionObj.projects[k].projectId, updatedUploadToBoard[j].userData.port || '');
            }

            if (updatedUploadToBoard[j].userId === auth.userData.data.userId) {
              const userFullName = `${remoteSessionObj.projects[k].Project.User.firstName} ${remoteSessionObj.projects[k].Project.User.lastName}`;
              if (!updatedUploadToBoard[j].notified && !updatedUploadToBoard[j].running) {
                if (updatedUploadToBoard[j].state === 'COMPILED') {
                  this.toastSend(
                    <span className="body">
                      <span className="icon icon-check-circle" />
                      <span className="first-line">
                        ¡Código cargado!
                        <span className="second-line">{`El código fue cargado en la placa de ${userFullName}.`}</span>
                      </span>
                    </span>,
                    'R',
                    { className: 'code-uploaded' },
                  );
                } else if (updatedUploadToBoard[j].state === 'ERROR') {
                  this.toastSend(
                    <span className="body">
                      <span className="icon icon-exclamation-solid" />
                      <span className="first-line">
                        ¡ERROR en tu código!
                        <span className="second-line">{`Tu código no se pudo cargar en la placa de ${userFullName}.`}</span>
                      </span>
                    </span>,
                    'R',
                    { className: 'error' },
                  );
                } else if (updatedUploadToBoard[j].state === 'REJECTED') {
                  this.toastSend(
                    <span className="body">
                      <span className="icon icon-minus-circle" />
                      <span className="first-line">
                        ¡Código eliminado!
                        <span className="second-line">{`Tu código fue eliminado por ${userFullName}.`}</span>
                      </span>
                    </span>,
                    'R',
                    { className: 'error' },
                  );
                }
                if (updatedUploadToBoard[j].state === 'COMPILED' || updatedUploadToBoard[j].state === 'ERROR' || updatedUploadToBoard[j].state === 'REJECTED') {
                  updatedUploadToBoard[j].notified = true;
                  putRemoteSessionCompilation(updatedUploadToBoard[j].id, updatedUploadToBoard[j]);
                }
              } else if (!updatedUploadToBoard[j].notified && updatedUploadToBoard[j].running) {
                this.toastSend(
                  <span className="body">
                    <span className="icon icon-check-circle" />
                    <span className="first-line">
                      ¡Código cargado!
                      <span className="second-line">{`Tu código está cargado y ejecutándose en la placa de ${userFullName}.`}</span>
                    </span>
                  </span>,
                  'R',
                  { className: 'code-uploaded', autoClose: false },
                );
                updatedUploadToBoard[j].notified = true;
                putRemoteSessionCompilation(updatedUploadToBoard[j].id, updatedUploadToBoard[j]);
              }
            }
          }
        }

        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          doIHaveAProject = true;
        }
      }

      if (!doIHaveAProject) {
        window.location = `${routes.bloquesUri}`;
      }

      resetRemoteSessionStatus({ statusRemoteSessionRefresh: '' });
      // console.log('REMOTE SESSION DATA SAVED -------------------', remoteSessionObj);
      this.setState({ remoteSessionObj, saveForm });
    }

    if (newprops.assignmentSession.statusAssignmentSessionProjectUpdate === 'fetch') {
      setAssignmentDeliverableState(Date().toString());
      clearInterval(intervalRemoteSession);
      clearInterval(intervalAutoSave);
      this.toastSend(
        <span className="body">
          <span className="icon icon-check-circle" />
          <span className="first-line">
            ¡Actividad entregada!
            <span className="second-line">El profesor ya recibió la actividad. Recuerda que ya no podrás modificar este proyecto.</span>
          </span>
        </span>,
        'R',
        { className: 'code-uploaded', autoClose: 7000 },
      );
      resetAssignmentSessionStatus({ statusAssignmentSessionProjectUpdate: '' });
    }
    if (newprops.assignmentSession.statusAssignmentSessionProjectUpdate === 'fetch error') {
      // console.log('AULA API ERROR:', newprops.assignmentSession.dataAssignmentSessionProjectUpdate);
      this.toastSend(
        <span className="body">
          <span className="icon icon-exclamation-solid" />
          <span className="first-line">
            ¡Ocurrió un error!
            <span className="second-line">{newprops.assignmentSession.dataAssignmentSessionProjectUpdate}</span>
          </span>
        </span>,
        'R',
        { className: 'error' },
      );
      resetAssignmentSessionStatus({ statusAssignmentSessionProjectUpdate: '' });
    }
    if (newprops.assignmentSession.statusAssignmentSessionProjectPost === 'fetch') {
      saveForm.id = newprops.assignmentSession.dataAssignmentSessionProjectPost.data.projectId;
      tabInfo.projectId = newprops.assignmentSession.dataAssignmentSessionProjectPost.data.projectId;
      tabInfo.remoteSessionNeedInit = false;
      tabInfo.userId = auth.userData.data.userId;
      this.setState({ saveForm, tabInfo }, () => {
        assignmentSessionRefresh(newprops.assignmentSession.dataAssignmentSessionProjectPost.data.assignmentSessionId, saveForm.id);
      });
      resetAssignmentSessionStatus({ statusAssignmentSessionProjectPost: '' });
    }

    if (newprops.assignmentSession.statusAssignmentSessionRefresh === 'fetch') {
      const assignmentSessionObj = newprops.assignmentSession.dataAssignmentSessionRefresh.data;
      let delivered = '';
      let ownerProject = false;
      for (let i = 0; i < assignmentSessionObj.AssignmentSessionsProjects.length; i += 1) {
        if (assignmentSessionObj.AssignmentSessionsProjects[i].projectId === saveForm.id
          && assignmentSessionObj.AssignmentSessionsProjects[i].settings
          && assignmentSessionObj.AssignmentSessionsProjects[i].settings.delivered) {
          delivered = assignmentSessionObj.AssignmentSessionsProjects[i].settings.delivered;
        }
        if (assignmentSessionObj.AssignmentSessionsProjects[i].projectId === saveForm.id
          && assignmentSessionObj.AssignmentSessionsProjects[i].userRole === 'OWNER') {
          ownerProject = true;
        }
      }
      // console.log('================>REFRESH ASSIGNMENT DATA: ', tabInfo);
      if (delivered !== '' && !ownerProject) {
        setAssignmentDeliverableState(delivered);
      } else {
        setAssignmentDeliverableState((ownerProject) ? '' : tabInfo.assignmentProjectDeliveryDate || assignmentSessionObj.deliveryDate);
      }
      this.setState({ assignmentSessionObj });
      resetAssignmentSessionStatus({ statusAssignmentSessionRefresh: '' });
    }

    if (newprops.remoteSession.statusRemoteSessionProjectPost === 'fetch') {
      // console.log('SAVED!--rs-----------------', newprops.remoteSession.dataRemoteSessionProjectPost.data);
      saveForm.id = newprops.remoteSession.dataRemoteSessionProjectPost.data.projectId;
      tabInfo.projectId = newprops.remoteSession.dataRemoteSessionProjectPost.data.projectId;
      tabInfo.remoteSessionNeedInit = false;
      tabInfo.userId = auth.userData.data.userId;
      this.setState({ saveForm, tabInfo });
      resetRemoteSessionStatus({ statusRemoteSessionProjectPost: '' });
    }

    if (newprops.projects.statusPut === 'fetch' || newprops.projects.statusPut === 'fetch error') {
      // console.log('=================Put', newprops.projects.dataPut);
      if (newprops.projects.dataPut.jsonBody.collaborationProject) {
        saveForm.collaborationSession = newprops.projects.dataPost.id;
        saveForm.collaborationProject = true;
      }
      if (newprops.projects.dataPut.jsonBody.remoteSession) {
        saveForm.remoteSession = (newprops.projects.dataPut.jsonBody.remoteSession) ? newprops.projects.dataPut.jsonBody.remoteSession : 0;
        this.setState({ saveForm });
      }
      if (newprops.projects.dataPut.jsonBody.assignmentSession) {
        saveForm.assignmentSession = (newprops.projects.dataPut.jsonBody.assignmentSession) ? newprops.projects.dataPut.jsonBody.assignmentSession : 0;
        assignmentSessionRefresh(saveForm.assignmentSession, saveForm.id);
        this.setState({ saveForm });
      }

      this.closeRightPanel();
      newprops.resetStatus({ statusPut: '' });
      this.toastSend(intl.formatMessage({ id: 'blocks.blockly.projectSaved' }));
      this.shootMsg(intl.formatMessage({ id: 'blocks.blockly.ready' }));
    }
    if (newprops.projects.statusPost === 'fetch' && actionStatus.projects.statusPost === '') {
      const self = this;
      this.closeRightPanel(() => {
        actionStatus.projects.statusPost = newprops.projects.statusPost;
        saveForm.id = newprops.projects.dataPost.id;
        tabInfo.projectId = newprops.projects.dataPost.id;
        tabInfo.userId = auth.userData.data.userId;
        if (newprops.projects.dataPost.jsonBody.collaborationProject) {
          saveForm.collaborationSession = newprops.projects.dataPost.id;
          saveForm.collaborationProject = true;
        }
        // console.log('=================Post', newprops.projects.dataPost);
        if (newprops.projects.dataPost && newprops.projects.dataPost.jsonBody.remoteSession) {
          saveForm.remoteSession = (newprops.projects.dataPost.jsonBody.remoteSession) ? newprops.projects.dataPost.jsonBody.remoteSession : 0;
        }
        if (newprops.projects.dataPost && newprops.projects.dataPost.jsonBody.assignmentSession) {
          saveForm.assignmentSession = (newprops.projects.dataPost.jsonBody.assignmentSession) ? newprops.projects.dataPost.jsonBody.assignmentSession : 0;
          assignmentSessionRefresh(saveForm.assignmentSession, saveForm.id);
        }
        GRPD({ tempData: saveForm });
        if (reSaveTags && newprops.projects.statusPost === 'fetch') {
          self.setState({ actionStatus, saveForm, tabInfo, reSaveTags: false }, () => {
            self.saveProjectInDb();
            self.closeRightPanel();
          });
        } else {
          self.setState({ actionStatus, saveForm }, () => {
            self.toastSend(intl.formatMessage({ id: 'blocks.blockly.projectSaved' }));
          });
        }
        newprops.resetStatus({ statusPost: '' });
      });
    }
    if (newprops.projects.statusDelete === 'fetch') {
      newprops.closeTabHandler();
      newprops.resetStatus({ statusDelete: '' });
    }

    if (
      (newprops.rightPanel.rightPanelData && (rightPanel.data.tutorialCodename !== newprops.rightPanel.rightPanelData.tutorialCodename))
      || (!isLogged && Object.entries(newprops.auth.userData).length > 0)
    ) {
      rightPanel.data = newprops.rightPanel.rightPanelData;
      const self = this;
      this.setState({ rightPanel }, () => {
        if (demoWorkspace && demoWorkspace.id === rightPanel.data.workspaceId) { self.loadRightPanelTutorial(); }
        if (tabInfo.id === rightPanel.data.tabId) { self.loadRightPanelProjectWorkflow(rightPanel.data.tutorialCodename); }
      });
    }
    this.setState({ isLogged: (Object.entries(newprops.auth.userData).length > 0) });

    if (toolboxToggle !== newprops.toolboxToggle) {
      const ele = document.querySelectorAll('.blocklyToolboxDiv');
      if (ele.length > 0) {
        for (let i = 0; i < ele.length; i += 1) {
          if (!newprops.toolboxToggle) {
            ele[i].classList.remove('blocklyToolboxDiv-icons');
            ele[i].classList.add('blocklyToolboxDiv-text');
          } else {
            ele[i].classList.remove('blocklyToolboxDiv-text');
            ele[i].classList.add('blocklyToolboxDiv-icons');
          }
        }
      }
    }
    if (darkthemeToggle !== newprops.darkthemeToggle && tabInfo.board.type === 'junior') {
      const ele = document.querySelectorAll('.blocklyToolboxDiv');
      if (ele.length) {
        for (let i = 0; i < ele.length; i += 1) {
          if (newprops.darkthemeToggle) {
            ele[i].classList.add('darkTheme');
          } else {
            ele[i].classList.remove('darkTheme');
          }
        }
      }
    }

    let selectedPort = tabInfo.port;
    if (newprops.bloques.ports.length <= 0) {
      selectedPort = '';
    } else if (!newprops.bloques.ports.includes(selectedPort)) {
      selectedPort = newprops.bloques.ports[0];
    }

    this.selectPortChange(selectedPort);
    this.checkBottomStatusAgainsProps(newprops);

    // if (tabInfo.active && demoWorkspace) {
    //   demoWorkspace.markFocused();
    // }
    this.checkMessageForFlags(newprops.bloques.state.msgs[newprops.bloques.state.msgs.length - 1], newprops.bloques.state.progress);
    this.setState({
      tags: newprops.tags,
      consoleGenerated: this.createConsoleString(newprops.bloques.msgs),
      toolboxToggle: newprops.toolboxToggle,
      darkthemeToggle: newprops.darkthemeToggle,
      ports: newprops.bloques.ports,
      agentPorts: newprops.bloques.agentPorts,
      className: newprops.className,
      tabInfo: newprops.tabInfo,
      actualWidth: window.innerWidth,
    }, () => {
      if (consoleEditor && consoleEditor.session) {
        consoleEditor.gotoLine(consoleEditor.session.doc.getAllLines().length);
      }
    });
    this.handleAgentPortsChange();
  }


  componentWillUnmount() {
    const { remoteSessionObj, tabInfo } = this.state;
    if (tabInfo.remoteSession) {
      if (remoteSessionObj.jitsiApi) {
        remoteSessionObj.jitsiApi.dispose();
      }
    }
  }


  getHeightOfRow() {
    return (window.innerHeight > 680) ? 46 : 35;
  }

  getProfile(param) {
    return profiles.default[param];
  }

  setCenter() {
    const { demoWorkspace, blocklyOptions } = this.state;
    const { defaultScale } = blocklyOptions.zoom;
    demoWorkspace.setScale(defaultScale);
    setTimeout(() => { demoWorkspace.scrollCenter(); }, 100);
  }

  setZoom(direction) {
    const { demoWorkspace } = this.state;
    const currentScale = demoWorkspace.scale;

    const newScale = (direction === 'up') ? currentScale + 0.1 : currentScale - 0.1;

    demoWorkspace.setScale(newScale);
  }

  setUndo(direction) {
    const { demoWorkspace } = this.state;
    demoWorkspace.undo(direction);
  }

  setImageValue(data) {
    const { tabInfo, saveForm } = this.state;
    tabInfo.diagramImageUrl = (data.picture && data.picture.onlineSrc) ? data.picture.onlineSrc : '';
    saveForm.diagramImageUrl = (data.picture && data.picture.onlineSrc) ? data.picture.onlineSrc : '';
    this.setState({ saveForm, tabInfo, waitForDiagramImage: (data.status === 'uploading') });
  }

  // eslint-disable-next-line react/sort-comp
  changeField(field, e) {
    const { saveForm, rightPanel, tabInfo } = this.state;
    const self = this;

    if (
      field === 'public'
      || field === 'library'
      || field === 'autoSave'
      || field === 'collaborationProject'
      || field === 'assignmentProject'
      || field === 'assignmentProjectPasswordToggle'
      || field === 'remoteProject'
      // || field === 'remoteAutoCompile'
      || field === 'remoteProjectPasswordToggle'
    ) {
      saveForm[field] = !saveForm[field];
      if (field === 'collaborationProject') {
        saveForm.collaborationProjectUserRole = (saveForm.collaborationProject) ? 'OWNER' : 'STUDENT';
      }
      if (field === 'assignmentProject' || field === 'remoteProject') {
        saveForm.assignmentUserRole = (saveForm.assignmentProject || saveForm.remoteProject) ? 'OWNER' : 'STUDENT';
        saveForm.remoteUserRole = (saveForm.assignmentProject || saveForm.remoteProject) ? 'OWNER' : 'STUDENT';
        tabInfo.assignmentUserRole = saveForm.assignmentUserRole;
        tabInfo.remoteUserRole = saveForm.remoteUserRole;
      }
    } else {
      saveForm[field] = e.target.value;
    }
    this.setState({ saveForm, tabInfo }, () => {
      self.loadRightPanelProjectWorkflow(rightPanel.type, true);
    });
  }

  checkBottomStatusAgainsProps(props) {
    const { bloques, boardConnectionInfoPost, auth } = this.props;
    const { bottomNav, tabInfo, userAgent, socket } = this.state;
    if (tabInfo.board.compilerBoard === 'microbit') {
      bottomNav.ebBuildStatus = 'GOOD';
      bottomNav.arduinoAgentStatus = 'GOOD';
    } else {
      const oldAgentPorts = bloques.agentPorts || [];
      const agentPorts = props.bloques?.agentPorts || [];
      const userId = auth.userData?.data?.userId || 0;
      if (oldAgentPorts !== agentPorts) {
        if (agentPorts.length) {
          for (let i = 0; i < agentPorts.length; i += 1) {
            const port = agentPorts[i];
            boardConnectionInfoPost({
              id: uuidv1(),
              timestamp: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
              serial_string: port.SerialNumber,
              action: 'CONNECTED',
              context: auth.userData?.data ? {
                userId: auth.userData?.data.userId,
                name: auth.userData?.data.name,
                lastName: auth.userData?.data.lastName,
                email: auth.userData?.data.email,
              } : {},
            });
          }
        } else {
          // boardConnectionInfoPost({
          //     id: '123',
          //     timestamp: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
          //     serial_string: '',
          //     action: 'DISCONNECTED',
          //     context: auth.userData?.data || {},
          //   });
        }
      }
      if (bottomNav.ebBuildStatus === 'GOOD' && props.bloques.state.ebBuild === 'ERROR') {
        // socket.setPlatform(userAgent.platform || '');
        setTimeout(() => {
          this.setState({ consoleGenerated: this.createConsoleString([`Plataforma: ${userAgent.platform || ''}`]) });
        }, 5000);
      }
      bottomNav.ebBuildStatus = props.bloques.state.ebBuild;
      bottomNav.arduinoAgentStatus = props.bloques.state.agent;
    }
    this.setState({ bottomNav });
  }

  checkMessageForFlags(flagMessage, newProgress = 0) {
    const { bottomNav, id, tabInfo, connectionModalType, webSerialModalState } = this.state;
    let { building } = this.state;
    const self = this;

    let progress = bottomNav.progressbar;
    // console.log('================AGENT MESSAGE:', flagMessage, newProgress);
    switch (flagMessage) {
      case '#### BOARD NOT CONNECTED':
        webSerialModalState.connected = false;
        if (webSerialModalState.step === 3) {
          webSerialModalState.step += 1;
        }
        webSerialModalState.error = 'ERROR';
        this.setState({ webSerialModalState });
        break;
      case '#### BOARD CONNECTED':
        webSerialModalState.connected = true;
        webSerialModalState.step = 4;
        webSerialModalState.error = null;
        this.setState({ webSerialModalState });
        break;
      case '#### UPLOAD TO PORT':
        progress = 0;
        building = true;
        break;
      case '#### UPLOAD TO EB_BUILD':
        progress = 25;
        building = true;
        break;
      case '#### FINISH EB_BUILD':
        progress = 50;
        building = true;
        break;
      case '#### UPLOAD TO AGENT':
        progress = 75;
        building = true;
        break;
      case '#### UPLOAD PROGRESS':
        progress = newProgress;
        building = true;
        break;
      case '#### FINISH SHOW':
        progress = 101;
        building = false;
        if (connectionModalType === 0) {
          setTimeout(() => {
            $(`#connectionModal-${id}`).modal('hide');
          }, 2000);
        } else {
          setTimeout(() => {
            this.toggleMicrobitModal(true);
          }, 2500);
        }
        break;
      case '#### FINISH AGENT':
        progress = 100;
        setTimeout(() => {
          self.checkMessageForFlags('#### FINISH SHOW');
        }, 2000);
        break;
      case '#### ERROR EB_BUILD':
        progress = -2;
        building = false;
        setTimeout(() => { $(`#connectionModal-${id}`).modal('hide'); }, 4000);
        break;

      default:
        break;
    }

    if ((progress <= 0 || progress > bottomNav.progressbar) && tabInfo.active) {
      bottomNav.progressbar = progress;
      this.setState({ bottomNav, building });
    } else this.setState({ building });
  }

  refConsoleEditor(consoleEditor) {
    this.setState({ consoleEditor });
  }

  createConsoleString(array) {
    let string = '';
    let strReplacement = '';
    for (let i = 0; i < array.length; i += 1) {
      strReplacement = array[i];
      strReplacement = strReplacement.replace('The tool is already present on the system', 'Encontramos el plugin necesario para conectarse a la placa');
      strReplacement = strReplacement.replace('Map Updated', '');
      string += `${JSON.stringify(strReplacement)} \n`;
    }
    return string;
  }

  handleAgentPortsChange(fireChangeEvent) {
    const { demoWorkspace, agentPorts } = this.state;
    if (demoWorkspace) {
      demoWorkspace.chageBoardVersion(agentPorts, fireChangeEvent);
    }
  }

  initBlockly() {
    const { blocklyOptions, id, tabInfo, preWorkspace, boardType } = this.state;
    let { demoWorkspace } = this.state;
    const { intl } = this.props;
    const blocklyDiv = document.getElementById(id);
    blocklyDiv.innerHTML = '';

    if (tabInfo.board.type === 'junior' && tabInfo.board.toolboxLayout === 'horizontal') {
      blocklyOptions.horizontalLayout = true;
      blocklyOptions.toolboxPosition = 'end';
      // blocklyOptions.scrollbars = true;
    }
    blocklyOptions.toolbox = document.getElementById(blocklyOptions.toolbox);
    demoWorkspace = window.Blockly.inject(blocklyDiv, blocklyOptions);
    if (tabInfo.board.type === 'senior' && window.Blockly.VariablesJavascriptDynamic) {
      demoWorkspace.registerToolboxCategoryCallback('VARIABLE_JAVASCRIPT_DYNAMIC', window.Blockly.VariablesJavascriptDynamic.flyoutCategory);
      demoWorkspace.registerToolboxCategoryCallback('PROCEDURE_JAVASCRIPT', window.Blockly.ProceduresJavascriptDynamic.flyoutCategory);
    }
    if (tabInfo.board.type === 'junior' && tabInfo.board.toolboxLayout === 'horizontal') {
      demoWorkspace.scrollbar = new window.Blockly.Scrollbar(demoWorkspace, true);
    }

    let xml = createElementFromHTML(ReactDOMServer.renderToString(this.getProfile(tabInfo.board.profile).initXml)); // BASE
    if (preWorkspace) xml = window.Blockly.Xml.textToDom(preWorkspace);

    /* eslint-disable */
    // PIN MAPPING FUNCTIONS
    if (tabInfo.board.type === 'senior') {
      demoWorkspace.pinDB_ = {
        /*
        BLOCK_COMPONENT:
        led
        motor
        servo
        lcd
        matrix
        button
        motordc
        buzzer

        {
          {PIN_NUMBER}: {
            {BLOCK_COMPONENT}_{PIN_NAME}: [{BLOCK_ID}, ...]
          },
        }
        */
        pins: {},
        pinUsed: function (pin, component) {
          // Inverse logic, if the same block component we're trying to add exists, it's ok.
          // Otherwise, we aren't allowed to use the same pin with different block components.
          // if ((this.pins.hasOwnProperty(pin) || component === '') && !component.match(/^I2C/gi)) {
          if ((this.pins.hasOwnProperty(pin) || component === '')) {
            if (this.pins[pin].hasOwnProperty(component)) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        },
        addPin: function (pin, component, blockId) {
          if (!this.pins[pin] || !this.pins[pin][component]) {
            if (!this.pins[pin]) {
              this.pins[pin] = {};
            }
            if (!this.pins[pin][component]) {
              this.pins[pin][component] = [];
            }
            this.pins[pin][component] = [blockId];
          } else if (typeof this.pins[pin][component] !== 'undefined' && this.pins[pin][component].indexOf(blockId) === -1) {
            this.pins[pin][component].push(blockId);
          }
        },
        deletePin: function (blockId) {
          let deleted = false;
          for (var pin in this.pins) {
            if (this.pins.hasOwnProperty(pin)) {
              for (var component in this.pins[pin]) {
                if (this.pins[pin].hasOwnProperty(component)) {
                  if (this.pins[pin][component].length > 1) {
                    for (var i = 0; i < this.pins[pin][component].length; i++) {
                      if (this.pins[pin][component][i] === blockId) {
                        this.pins[pin][component].splice(i, 1);
                        deleted = true;
                      }
                    }
                  } else {
                    if (this.pins[pin][component][0] === blockId) {
                      delete this.pins[pin][component];
                      deleted = true;
                    }
                  }
                }
              }
              if (!Object.keys(this.pins[pin]).length) {
                delete this.pins[pin];
              }
            }
          }
          return deleted;
        }
      };


      demoWorkspace.addPinCheckingUsed = function (blockId) {
        if (typeof demoWorkspace.getBlockById(blockId).getPins === "function" && !demoWorkspace.getBlockById(blockId).disabled) {

          const pinCombos = demoWorkspace.getBlockById(blockId).getPins();
          let pinValue = '';
          let pinType = '';
          let nextOption = [];
          let singlePin = [];
          let occupied = false;
          let j = 0;
          for (let i in pinCombos) {

            // Inter-pin check. If a dropdown pin on the same Block is used, select the next one available.
            pinValue = demoWorkspace.getBlockById(blockId).getFieldValue(pinCombos[i]);
            pinType = demoWorkspace.getBlockById(blockId).component + '_' + pinCombos[i];
            singlePin = pinValue.split(',');
            for (let p in singlePin) {
              if (demoWorkspace.pinDB_.pinUsed(singlePin[p], pinType)) {
                occupied = true;
              }
            }
            j = 0;
            while (occupied) {
              if (typeof demoWorkspace.getBlockById(blockId).getField(pinCombos[i]).getOptions()[j] !== 'undefined') {
                nextOption = demoWorkspace.getBlockById(blockId).getField(pinCombos[i]).getOptions()[j];
                demoWorkspace.getBlockById(blockId).getField(pinCombos[i]).setValue(nextOption[1]);
                pinValue = demoWorkspace.getBlockById(blockId).getFieldValue(pinCombos[i]);
                pinType = demoWorkspace.getBlockById(blockId).component + '_' + pinCombos[i];
                singlePin = pinValue.split(',');

                occupied = false;
                for (let p in singlePin) {
                  if (demoWorkspace.pinDB_.pinUsed(singlePin[p], pinType)) {
                    occupied = true;
                  }
                }
                j += 1;
              } else {
                occupied = false;
              }
            }


            if (singlePin.length > 0) {
              for (let p in singlePin) {
                demoWorkspace.pinDB_.addPin(
                  singlePin[p],
                  demoWorkspace.getBlockById(blockId).component + '_' + pinCombos[i],
                  blockId
                );
              }
            }
          }
        }

      };

      demoWorkspace.listenToPinEvents = function (event) {

        /// CREATE EVENT ////////////////////////////////
        if (event.type === Blockly.Events.BLOCK_CREATE) {

          let blockIds = [];
          blockIds.push(event.blockId);
          if (typeof event.ids !== "undefined") {
            blockIds = event.ids;
          }
          let blockId;
          for (let i in blockIds) {
            blockId = blockIds[i];
            demoWorkspace.addPinCheckingUsed(blockId);
          }
          demoWorkspace.markFocused();
        }

        /// CHANGE EVENT ////////////////////////////////
        if (event.type === Blockly.Events.BLOCK_CHANGE
          && typeof demoWorkspace.getBlockById(event.blockId).getPins === "function") {
          // console.log('==================event.blockId', event.blockId);
          demoWorkspace.pinDB_.deletePin(event.blockId);
          demoWorkspace.addPinCheckingUsed(event.blockId);
          demoWorkspace.markFocused();
        }

        /// DELETE EVENT ////////////////////////////////
        if (event.type === Blockly.Events.BLOCK_DELETE) {
          let deleted = false;
          for (let i = 0; i < event.ids.length; i++) {
            deleted = demoWorkspace.pinDB_.deletePin(event.ids[i]);
          }
          if (deleted) {
            demoWorkspace.markFocused();
          }
        }

      }
      demoWorkspace.addChangeListener(demoWorkspace.listenToPinEvents);

      demoWorkspace.getHardwarePinsCombo = function (pinType, blockComponent = '') {
        let pins = [];
        if (pinType !== '') {
          pins = tabInfo.board.pins[pinType] || [[intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' }), `${intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' })},,`]];
        }

        let newPins = [];
        let singlePin = [];
        let occupied = false;
        for (let i = 0; i < pins.length; i++) {

          singlePin = pins[i][1].split(',');
          occupied = false;
          for (let j in singlePin) {
            if (blockComponent !== '' && demoWorkspace.pinDB_.pinUsed(singlePin[j], blockComponent)) {
              occupied = true;
            }
          }
          if (!occupied) {
            newPins.push(pins[i]);
          }
        }
        // It can't be an empty array
        if (newPins.length <= 0) {
          newPins.push([intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' }), `${intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' })},,`]);
        }
        return newPins;
      }
    }

    if (tabInfo.board.type === 'senior' || tabInfo.board.type === 'junior') {
      demoWorkspace.chageBoardVersion = function (agentPorts, fireChangeEvent = true) {
        const blocks = demoWorkspace.getAllBlocks();
        for (let i = 0; i < blocks.length; i += 1) {
          if (typeof blocks[i].setBoardVersion === "function" && !blocks[i].disabled) {
            let boardVersion = '';
            for (let i = 0; i < agentPorts.length; i += 1) {
              if (agentPorts[i].Name === tabInfo.port) {
                boardVersion = `${agentPorts[i].VendorID}-${agentPorts[i].ProductID}`;
              }
            }
            // console.log('=========CHANGE BOARD VERSION', boardVersion, agentPorts);
            blocks[i].setBoardVersion(boardVersion.toUpperCase());
            if (fireChangeEvent) {
              setTimeout(() => {
                this.fireChangeListener('resize');
                window.Blockly.svgResize(this);
              }, 200);
            }
          }
        }
      }

      demoWorkspace.addChangeListener(() => ((that) => {
        that.handleAgentPortsChange(false);
      })(this));
    }
    /* eslint-enable */

    demoWorkspace.setMLClasses = function (classNames = {}) {
      demoWorkspace.ML = {
        classNames,
      };

      const blocks = demoWorkspace.getAllBlocks();
      for (let i = 0; i < blocks.length; i += 1) {
        if (typeof blocks[i].updateClassNames === 'function') {
          blocks[i].updateClassNames();
        }
      }
      // demoWorkspace.fireChangeListener('resize');
      window.Blockly.svgResize(demoWorkspace);
    };

    demoWorkspace.getMLClasses = function () {
      const classes = [];
      if (demoWorkspace.ML) {
        Object.keys(demoWorkspace.ML.classNames).forEach((key) => {
          classes.push([demoWorkspace.ML.classNames[key], key]);
        });
      }
      return classes;
    };

    window.Blockly.Xml.domToWorkspace(xml, demoWorkspace);

    $(window).resize(function (dw) {
      return function () {
        setTimeout(() => {
          dw.fireChangeListener('resize');
          window.Blockly.svgResize(dw);
        }, 200);
      };
    }(demoWorkspace));

    //  DISABLE OPRHANS
    if (boardType === 'senior') {
      demoWorkspace.addChangeListener(window.Blockly.Events.disableOrphans);
    }

    //  EVENT LISTENER
    demoWorkspace.addChangeListener(events.bind(this));

    if (boardType === 'junior') {
      demoWorkspace.setScale(1.8);
      demoWorkspace.getVariableMap = function () { return false; };
      window.Blockly.Variables.allDeveloperVariables = function () { return false; };
      window.Blockly.utils.wrap = function () { return false; };
      window.Blockly.Variables.allUsedVarModels = function () { return false; };
      window.Blockly.JavaScript.variableDB_ = {}; //  eslint-disable-line
      window.Blockly.JavaScript.variableDB_.setVariableMap = function () { return false; }; //  eslint-disable-line
      window.Blockly.JavaScript.variableDB_.reset = function () { return false; }; //  eslint-disable-line
      window.Blockly.JavaScript.variableDB_.getVariableMap = function () { return false; }; //  eslint-disable-line
    }

    //  CODE SAVE
    demoWorkspace.addChangeListener(() => ((that, demo) => {
      const lang = tabInfo.board.lang || 'Arduino';
      that.setState({ codeGenerated: (window.Blockly[lang]) ? window.Blockly[lang].workspaceToCode(demo) : '' }, () => {
        // const codeStoraged2Save = (sessionStorage.getItem('EduCodeGenerated')) ? JSON.parse(sessionStorage.getItem('EduCodeGenerated')) : null;
        const code2Save = {};
        // if (codeStoraged2Save) code2Save = codeStoraged2Save;
        code2Save[id] = {
          tabInfo,
          workspace: window.Blockly.Xml.domToText(window.Blockly.Xml.workspaceToDom(demoWorkspace)),
        };

        sessionStorage.setItem('EduCodeGenerated', JSON.stringify(code2Save));
        if (!that.state.saving) {
          setTimeout(() => {
            that.setState({ saving: false });
          }, 2500);
          that.setState({ saving: true });
        }
      });
    })(this, demoWorkspace));

    const intervalChecker = setInterval((function (that) {
      return () => {
        if (document.querySelectorAll(`#${id} .blocklyWorkspace`).length > 0) {
          clearInterval(intervalChecker);
          that.afterLoadBlocklyPanel();
        }
      };
    }(this)), 300);

    this.setState({ demoWorkspace });
  }

  closeRightPanel(callback = () => { }) {
    const { rightPanel } = this.state;
    let { saveButtonDisabled } = this.state;
    rightPanel.data.tutorialCodename = '';
    rightPanel.status = 0;
    saveButtonDisabled = false;
    this.setState({ rightPanel, saveButtonDisabled, droneSimulationToggle: false }, callback);
  }

  openRightPanel(newContent, contentType) {
    const { rightPanel } = this.state;
    const self = this;
    // disable close codeBox in rightPanel toggle
    // let { codeToggle } = this.state;
    // codeToggle = false;
    // this.setState({ codeToggle });

    if (contentType === 'close' && rightPanel.status === 0) {
      rightPanel.data.tutorialCodename = '';
      rightPanel.status = 0;
      rightPanel.type = contentType;
      self.setState({ rightPanel });
    } else if (rightPanel.status === 0) {
      rightPanel.type = contentType;
      rightPanel.status = 1;
      rightPanel.children = newContent;
      self.setState({ rightPanel });
    } else if (rightPanel.type === 'loader') {
      rightPanel.data.tutorialCodename = '';
      rightPanel.children = newContent;
      rightPanel.type = contentType;
      self.setState({ rightPanel });
    } else {
      rightPanel.data.tutorialCodename = '';
      rightPanel.status = 0;
      rightPanel.type = contentType;
      self.setState({ rightPanel });
      setTimeout(() => {
        rightPanel.status = 1;
        rightPanel.children = newContent;
        self.setState({ rightPanel });
      }, 300);
    }

    this.setState({ saveButtonDisabled: false });
  }

  loadRightPanelTutorial() {
    const { rightPanel } = this.state;
    const self = this;

    let html = (
      <div className="right-panel-inner tutorial font-roboto">
        <div className="closeModal">
          <div className="close-panel" onClick={() => { this.closeRightPanel(); }} onKeyPress={() => { }}>
            <span className="icon-cross11" />
          </div>
        </div>
        <h4 className="help-header right-panel-header">Ayuda</h4>
        <div className="anibot-container">
          <div className="anibot" />
        </div>
      </div>
    );

    const blockUrl = getHtmlByTutorialCodename(rightPanel.data.tutorialCodename);

    axios.get(blockUrl).then((resolve) => {
      const data = resolve.data;
      html = (
        <div className="right-panel-inner tutorial font-roboto">
          <div className="closeModal">
            <div className="close-panel" onClick={() => { this.closeRightPanel(); }} onKeyPress={() => { }}>
              <span className="icon-cross11" />
            </div>
          </div>
          <h4 className="help-header right-panel-header">Ayuda</h4>
          <div className="content" dangerouslySetInnerHTML={{ __html: data }} />
        </div>
      );
      setTimeout(() => { self.openRightPanel(html, 'tutorial'); }, 500);
    });
    this.openRightPanel(html, 'loader');
  }

  updateSimulatorState(simulator = null) {
    const { saveForm } = this.state;
    if (simulator) {
      saveForm.simulator = {
        ...saveForm.simulator,
        ...simulator,
      };
      // console.log('======================saving', simulator.circuitSettings, saveForm.simulator.circuitSettings);
      this.setState({ saveForm });
    }
  }

  prepareProjectForSaving(noCode = false) {
    const { saveForm, code, tabInfo, demoWorkspace, boardType } = this.state;
    const { intl } = this.props;

    this.shootMsg(intl.formatMessage({ id: 'blocks.blockly.savingProject' }));

    tabInfo.name = saveForm.name;
    tabInfo.code = code;
    if (saveForm.simulator) tabInfo.simulator = saveForm.simulator;
    if (saveForm.diagramImageUrl !== '') tabInfo.diagramImageUrl = saveForm.diagramImageUrl;
    if (saveForm.videoUrl !== '') tabInfo.videoUrl = saveForm.videoUrl;
    if (saveForm.extraMaterialUrl !== '') tabInfo.extraMaterialUrl = saveForm.extraMaterialUrl;

    const challenges = [];

    if (saveForm.challenge1 !== '') challenges.push(saveForm.challenge1);
    if (saveForm.challenge2 !== '') challenges.push(saveForm.challenge2);
    if (saveForm.challenge3 !== '') challenges.push(saveForm.challenge3);

    if (challenges.length > 0) tabInfo.challenges = challenges;

    const language = tabInfo.board.lang;
    let canvasCss = '';
    let blocksCss = '';

    if (boardType !== 'code' && demoWorkspace) {
      tabInfo.withWorkspace = new XMLSerializer().serializeToString(window.Blockly.Xml.workspaceToDom(demoWorkspace));
      let canvas = demoWorkspace.svgBlockCanvas_.cloneNode(true); /* eslint-disable-line */
      canvas.removeAttribute('transform');
      let canvasBBox = document.getElementsByClassName('blocklyBlockCanvas')[0].getBBox();
      // Strange bug: if we can't get canvas size, try again
      if (!canvasBBox.width || canvasBBox.height) {
        canvasBBox = document.getElementsByClassName('blocklyBlockCanvas')[0].getBBox();
      }

      canvas = new XMLSerializer().serializeToString(canvas);
      const cssBlockly = window.Blockly.Css.CONTENT.join('');
      // <style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${cssContent.toString()}]]></style>
      canvasCss = `<defs><style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${cssBlockly}]]></style></defs>`;
      blocksCss = `<defs><style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${cssContent}]]></style></defs>`;

      tabInfo.canvas = canvas;
      tabInfo.canvasBBoxX = canvasBBox.x;
      tabInfo.canvasBBoxY = canvasBBox.y;
      tabInfo.canvasBBoxWidth = canvasBBox.width;
      tabInfo.canvasBBoxHeight = canvasBBox.height;

      if (!noCode) {
        tabInfo.canvasCode = window.Blockly[language].workspaceToCode(demoWorkspace);
      }
    }

    tabInfo.autoSave = saveForm.autoSave;
    tabInfo.remoteSession = saveForm.remoteSession;
    tabInfo.remoteProject = saveForm.remoteProject;
    tabInfo.remoteProjectPasswordToggle = saveForm.remoteProjectPasswordToggle;
    tabInfo.remoteProjectPassword = (saveForm.assignmentProject && saveForm.assignmentProjectPassword) ? saveForm.assignmentProjectPassword : saveForm.remoteProjectPassword;
    // tabInfo.remoteAutoCompile = saveForm.remoteAutoCompile;
    tabInfo.boardType = boardType;

    tabInfo.collaborationSession = saveForm.collaborationSession;
    tabInfo.collaborationProject = saveForm.collaborationProject;

    tabInfo.assignmentSession = saveForm.assignmentSession;
    tabInfo.assignmentProject = saveForm.assignmentProject;
    tabInfo.assignmentProjectPasswordToggle = saveForm.assignmentProjectPasswordToggle;
    tabInfo.assignmentProjectPassword = saveForm.assignmentProjectPassword;
    tabInfo.assignmentProjectDeliveryDate = saveForm.assignmentProjectDeliveryDate;

    tabInfo.saveForm = {};

    return { saveForm, tagsToSave: tabInfo.tagsSelected, tabInfo, canvasCss, blocksCss };
  }

  export() {
    const { saveForm, tabInfo, tagsToSave, demoWorkspace, boardType } = this.state;

    if (boardType !== 'code') {
      tabInfo.withWorkspace = new XMLSerializer().serializeToString(window.Blockly.Xml.workspaceToDom(demoWorkspace));
    } else {
      tabInfo.withWorkspace = null;
    }
    const body = {
      saveForm,
      tabInfo,
      tagsToSave,
    };

    const blob = new Blob([btoa(JSON.stringify(body))], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = `${tabInfo.name.replace(/ /g, '_')}.edu`;
    a.setAttribute('id', 'clickme');
    document.body.appendChild(a);
    a.click();
  }

  exportSVG() {
    const { demoWorkspace, tabInfo } = this.state;

    let canvas = demoWorkspace.svgBlockCanvas_.cloneNode(true); /* eslint-disable-line */
    if (canvas.children[0] !== undefined) {
      canvas.removeAttribute('transform');

      const cssBlockly = window.Blockly.Css.CONTENT.join('');
      const cssModals = cssContent.toString().replace(/\/images\//g, `${routes.bloquesUri}/images/`);
      let css = cssBlockly.toString().replace(/\/images\//g, `${routes.bloquesUri}/images/`);
      css = `<defs>
        <style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${cssModals}]]></style>
        <style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${css}]]></style>
      </defs>`;

      const bbox = document.getElementsByClassName('blocklyBlockCanvas')[0].getBBox();
      const content = new XMLSerializer().serializeToString(canvas);

      let svgContent = (content) ? content.replace(/href="images/g, `href="${routes.bloquesUri}/images`) : '';
      svgContent = svgContent.replace(/fill-opacity="0.8"/g, 'fill-opacity="1"');

      const xml = `<svg id="exportedSVG" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="${bbox.width}" height="${bbox.height}"
                    viewBox="${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}">${css}"><rect fill="red" />${svgContent}</svg>`;

      const blob = new Blob([xml], { type: 'image/svg+xml;base64' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.download = `${tabInfo.name.replace(/ /g, '_')}.svg`;
      a.setAttribute('id', 'clickme');
      document.body.appendChild(a);
      a.click();
    }
  }


  saveProjectInDb(dispatcher, auto = false) {
    const { remoteSessionObj, boardType, ports } = this.state;
    const { projectsPost, projectsPut, projectTagsPost, auth, intl } = this.props;
    const self = this;

    this.shootMsg(intl.formatMessage({ id: 'blocks.blockly.savingProject' }));

    const project = this.prepareProjectForSaving();
    project.tabInfo.ports = ports;
    // console.log('PUT>>>>>>>>>>>>>>>>', project);
    if (project.saveForm.id && project.tabInfo.userId && project.tabInfo.userId === auth.userData.data.userId) {
      if (!auto) {
        this.setState({ saveButtonDisabled: true }, () => self.loadRightPanelProjectWorkflow('save', true));
        if (!project.tagsToSave) {
          project.tagsToSave = [];
        }
        projectTagsPost(project.saveForm.id, project.tagsToSave.map((i) => i.id));
      }
      const projectPost = {
        title: project.saveForm.name,
        description: (project.saveForm.description) ? project.saveForm.description : '',
        boardType,
        jsonBody: project.tabInfo,
        isPublic: project.saveForm.public,
        isLibrary: project.saveForm.library || false,
        imageUrl: '',
        lastCheckForWriting: remoteSessionObj.lastCheckForWriting ? remoteSessionObj.lastCheckForWriting : 0,
      };
      if (!auto) {
        projectPost.canvasCss = project.canvasCss;
        projectPost.blocksCss = project.blocksCss;
      }
      projectsPut(project.saveForm.id, projectPost, auto);
    } else {
      // console.log('POST>>>>>>>>>>>>>>>>', project);
      project.tabInfo.projectId = null;
      this.setState({ reSaveTags: true, saveButtonDisabled: true }, () => {
        self.loadRightPanelProjectWorkflow('save', true);
        const projectPost = {
          title: project.saveForm.name,
          description: (project.saveForm.description) ? project.saveForm.description : '',
          boardType,
          jsonBody: project.tabInfo,
          canvasCss: project.canvasCss,
          blocksCss: project.blocksCss,
          isPublic: project.saveForm.public,
          isLibrary: project.saveForm.library || false,
          imageUrl: '',
        };
        if (boardType === 'code') {
          projectPost.isCodeOnly = 1;
        }
        projectsPost(projectPost);
      });
    }
    sessionStorage.removeItem('EduCodeGenerated');
  }

  deleteProject() {
    const { projectsDelete } = this.props;
    const { saveForm } = this.state;
    projectsDelete(saveForm.id);
  }

  toggleDeleteWarning() {
    let { deleteWarning } = this.state;

    const self = this;

    deleteWarning = !deleteWarning;

    this.setState({ deleteWarning }, () => {
      self.loadRightPanelProjectWorkflow('details', true);
    });
  }

  selectorUpdate(selectorData) {
    const { tabInfo } = this.state;

    tabInfo.tagsSelected = selectorData.selectedItems;
    this.setState({ tabInfo, tagsToSave: selectorData.selectedItems });
  }

  toggleFieldShown(field) {
    const { activeOptionalFields } = this.state;

    const self = this;

    activeOptionalFields[field] = !activeOptionalFields[field];

    this.setState({ activeOptionalFields }, () => {
      self.loadRightPanelProjectWorkflow('save', true);
    });
  }

  onCloseForProps = () => {
    const { onClosePanel } = this.props;
    onClosePanel();
  }

  initRemoteSession() {
    const { saveForm, tabInfo, boardType } = this.state;
    const { remoteSessionProjectsPost, remoteSessionStreamGet, auth, assignmentSessionProjectsPost, match } = this.props;

    if (tabInfo.assignmentSession) {
      this.loadRightPanelProjectWorkflow('details');
    }
    if (!saveForm.id && tabInfo.assignmentSession && match && match.url.indexOf('actividad') !== -1) {
      const project = this.prepareProjectForSaving();
      console.log('INIT ASSIGNMENT SESSION------------------', tabInfo, saveForm, project);

      let settings = null;
      let remoteSessionId = null;
      if (tabInfo.remoteSession) {
        remoteSessionId = project.tabInfo.remoteSession;
        settings = { userRole: auth.userData.data.roles.names[0] };
        if (auth.userData.data.roles.names.includes('Contenidista')
          || auth.userData.data.roles.names.includes('Contenidista Global')
          || auth.userData.data.roles.names.includes('Administrador')
          || auth.userData.data.roles.names.includes('Profesor')) {
          settings.userRole = 'Docente';
        } else {
          settings.userRole = 'Alumno';
        }
      }

      const projectPost = {
        remoteSessionId,
        assignmentSessionId: project.tabInfo.assignmentSession,
        title: project.saveForm.name,
        description: (project.saveForm.description) ? project.saveForm.description : '',
        jsonBody: project.tabInfo,
        canvasCss: project.canvasCss,
        blocksCss: project.blocksCss,
        isPublic: project.saveForm.public,
        isLibrary: project.saveForm.library || false,
        imageUrl: '',
        // userRole: (project.tabInfo.assignmentUserRole) ? project.tabInfo.assignmentUserRole : 'STUDENT',
        settings,
      };
      if (boardType === 'code') {
        projectPost.isCodeOnly = 1;
      }

      if (tabInfo.assignmentUserRole === 'OWNER') {
        this.toastSend(
          <span className="body">
            <span className="icon icon-exclamation-solid" />
            <span className="first-line">
              ¡Prepara tu proyecto!
              <span className="second-line">Redacta los detalles y organiza los bloques necesarios antes que los alumnos ingresen a la actividad.</span>
            </span>
          </span>,
          'R',
          { className: 'code-sending', autoClose: false },
        );
      }

      // console.log('INIT ASSIGNMENT SESSION------------------', saveForm, project, projectPost);
      assignmentSessionProjectsPost(projectPost);
    } else if (!saveForm.id && tabInfo.remoteSession && tabInfo.remoteSessionStarted && tabInfo.remoteSessionNeedInit && match && match.url.indexOf('remote') !== -1) {
      const project = this.prepareProjectForSaving();
      console.log('INIT REMOTE SESSION------------------', tabInfo, saveForm, project);

      const settings = { userRole: auth.userData.data.roles.names[0] };
      if (auth.userData.data.roles.names.includes('Contenidista')
        || auth.userData.data.roles.names.includes('Contenidista Global')
        || auth.userData.data.roles.names.includes('Administrador')
        || auth.userData.data.roles.names.includes('Profesor')) {
        settings.userRole = 'Docente';
      } else {
        settings.userRole = 'Alumno';
      }

      const projectPost = {
        remoteSessionId: project.tabInfo.remoteSession,
        title: project.saveForm.name,
        description: (project.saveForm.description) ? project.saveForm.description : '',
        jsonBody: project.tabInfo,
        canvasCss: project.canvasCss,
        blocksCss: project.blocksCss,
        isPublic: project.saveForm.public,
        isLibrary: project.saveForm.library || false,
        imageUrl: '',
        // userRole: (project.tabInfo.remoteUserRole) ? project.tabInfo.remoteUserRole : 'STUDENT',
        settings,
      };
      if (boardType === 'code') {
        projectPost.isCodeOnly = 1;
      }
      // console.log('INIT REMOTE SESSION------------------', saveForm, project, projectPost);
      remoteSessionProjectsPost(projectPost);
    }
    if (tabInfo.remoteSession) {
      remoteSessionStreamGet(tabInfo.remoteSession);
      this.setState({ remoteThumbsToggle: true });
    }
  }


  isAnyChangeInProject() {
    const { remoteSessionObj, ports } = this.state;
    const { auth } = this.props;

    let key = 0;
    for (let i = 0; i < remoteSessionObj.projects.length; i += 1) {
      if (remoteSessionObj.projects[i].Project.userId === auth.userData.data.userId) {
        key = i;
      }
    }

    let changed = false;
    if (remoteSessionObj.projects[key]) {
      const project = this.prepareProjectForSaving(true);
      const obj1 = remoteSessionObj.projects[key].Project.jsonBody;
      const obj2 = project.tabInfo;
      if (!obj2.ports) {
        obj2.ports = [];
      }
      if (
        obj1.canvas !== obj2.canvas
        || obj1.canvasBBoxX !== obj2.canvasBBoxX
        || obj1.canvasBBoxY !== obj2.canvasBBoxY
        || obj1.canvasBBoxWidth !== obj2.canvasBBoxWidth
        || obj1.canvasBBoxHeight !== obj2.canvasBBoxHeight
        // || obj1.canvasCode !== obj2.canvasCode
        || obj1.code !== obj2.code
        || obj1.description !== obj2.description
        || obj1.id !== obj2.id
        || obj1.name !== obj2.name
        || obj1.port !== obj2.port
        || obj2.port2 !== ports
        || obj1.portOpen !== obj2.portOpen
      ) {
        changed = true;
      }
    }
    return changed;
  }

  saveRemoteSession() {
    const { remoteSessionObj } = this.state;
    const { remoteSessionRefresh } = this.props;

    // console.log('REFRESHING REMOTE SESSION----', remoteSessionObj);
    const elapsedTimeReading = parseInt(new Date().getTime() - remoteSessionObj.lastCheckForUpdates, 10) / 1000;
    if (remoteSessionObj.id && (!remoteSessionObj.lastCheckForUpdates || elapsedTimeReading > 10)) {
      remoteSessionObj.lastCheckForUpdates = new Date().getTime();
      // remoteSessionRefresh(remoteSessionObj.id, remoteSessionObj.projectsIdVisibilityList.join(','));
      remoteSessionRefresh(remoteSessionObj.id, remoteSessionObj.MyRemoteSessionProjectId);
      this.setState({ remoteSessionObj });
    }

    const elapsedTimeWriting = parseInt(new Date().getTime() - remoteSessionObj.lastCheckForWriting, 10) / 1000;
    if (remoteSessionObj.id && (!remoteSessionObj.lastCheckForWriting || elapsedTimeWriting > 10)) {
      if (this.isAnyChangeInProject()) {
        remoteSessionObj.lastCheckForWriting = new Date().getTime();
        console.log('SAVING REMOTE PROJECT----');
        this.saveProjectInDb(null, true);
        this.setState({ remoteSessionObj });
      }
    }
  }

  loadRightPanelProjectWorkflow(type, isUpdate = false) {
    const { remoteSessionObj, waitForDiagramImage, tabInfo, boardType, saveForm, rightPanel, activeOptionalFields, tags, saveButtonDisabled } = this.state;
    const { auth, getAssignmentDeliverableState, match, intl } = this.props;
    const isLogged = (Object.entries(auth.userData).length > 0);
    let html;
    const challenges = [];
    if (saveForm.challenge1 && saveForm.challenge1 !== '') challenges.push(saveForm.challenge1);
    if (saveForm.challenge2 && saveForm.challenge2 !== '') challenges.push(saveForm.challenge2);
    if (saveForm.challenge3 && saveForm.challenge3 !== '') challenges.push(saveForm.challenge3);
    // console.log('================================', saveForm, tabInfo);
    const maxNameLength = 32;
    const minNameLength = 3;
    const maxDescriptionLength = 1000;
    const minDescriptionLength = 10;
    function remainingChars(n, max, min) {
      let txt = '';
      if (n === max) txt = intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.error' });
      else if (min - (max - n) === 1) txt = intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.oneCharShort' });
      else if (max - n < min) txt = `${intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.severalCharShort1' })} ${min - (max - n)} ${intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.severalCharShort2' })}`;
      else if (n === 1) txt = intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.oneCharRemaining' });
      else if (n === 0) txt = intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.noCharRemaining' });
      else if (n === -1) txt = intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.oneCharExtra' });
      else if (n < -1) txt = `${intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.severalCharExtra1' })} ${-n} ${intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.severalCharExtra2' })}`;
      else if (n < max) txt = `${intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.severalCharRemaining1' })} ${n} ${intl.formatMessage({ id: 'blocks.blockly.project.save.charLength.severalCharRemaining2' })}`;
      return txt;
    }

    const isContenidista = (
      auth.userData
      && auth.userData.data
      && (auth.userData.data.roles.names.includes('Contenidista')
        || auth.userData.data.roles.names.includes('Contenidista Global')
        || auth.userData.data.roles.names.includes('Administrador')));

    const isProfesor = (
      auth.userData
      && auth.userData.data
      && (auth.userData.data.roles.names.includes('Profesor')
        || auth.userData.data.roles.names.includes('Contenidista')
        || auth.userData.data.roles.names.includes('Contenidista Global')
        || auth.userData.data.roles.names.includes('Administrador')));

    const tagsSelected = tabInfo.tagsSelected || []; // eslint-disable-line
    tags.data = tags.data.map((i) => {
      const newI = i;
      let selectedClass = '';
      if (newI.Categories.length > 0) {
        newI.Categories.map((ii) => {
          selectedClass += `${ii.name} `;
          return ii;
        });
      }
      newI.selectedClass = selectedClass;
      return newI;
    });

    switch (type) {
      case 'close':
        this.closeRightPanel();
        break;
      case 'save':
        html = (
          <div className="right-panel-inner save-panel font-roboto">
            <div className="closeModal">
              <div className="close-panel" onClick={() => { this.closeRightPanel(); this.onCloseForProps(); }} onKeyPress={() => { }}>
                <span className="icon-cross11" />
              </div>
            </div>
            <div className="save-panel">
              {(!isLogged) && (
                <ModalLogin />
              )}
              {(isLogged) && (
                <>
                  <div className="title-div field-div">
                    <div className="field-shroud">
                      <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.name' })} type="text" keyname="name" />
                    </div>
                    {(saveForm.name.length <= maxNameLength && saveForm.name.length >= minNameLength) ? (
                      <div className={`remainingChars ${saveForm.name.length < maxNameLength - 10 ? 'manyRemainingChars' : 'fewRemainingChars'}`}>
                        {remainingChars(maxNameLength - saveForm.name.length, maxNameLength, minNameLength)}
                      </div>
                    ) : (
                      <div className="remainingChars noRemainingChars">
                        {remainingChars(maxNameLength - saveForm.name.length, maxNameLength, minNameLength)}
                      </div>
                    )}
                  </div>
                  <div className="title-div field-div">
                    <div className="field-shroud">
                      {/* <InputComponent form={saveForm} changeField={this.changeField} name="DESCRIPCIÓN" type="text" keyname="description" /> */}
                      <TextAreaComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.description' })} type="text" keyname="description" />
                    </div>
                    {(saveForm.description && saveForm.description.length <= maxDescriptionLength && saveForm.description.length >= minDescriptionLength) ? (
                      <div className={`remainingChars ${saveForm.description.length < maxDescriptionLength - 10 ? 'manyRemainingChars' : 'fewRemainingChars'}`}>
                        {remainingChars(maxDescriptionLength - saveForm.description.length, maxDescriptionLength, minDescriptionLength)}
                      </div>
                    ) : (
                      <div className="remainingChars noRemainingChars">
                        {remainingChars(maxDescriptionLength - ((saveForm.description) ? saveForm.description.length : 0), maxDescriptionLength, minDescriptionLength)}
                      </div>
                    )}
                  </div>
                  {(isContenidista) && (
                    <>
                      <div className="challenges-div field-div">
                        <div className="shower-hider" onClick={() => this.toggleFieldShown('videoUrl')} onKeyDown={() => { }}>
                          {(!activeOptionalFields.videoUrl) ? (
                            <>
                              <div> {intl.formatMessage({ id: 'blocks.blockly.project.save.addVideo' })} </div>
                              <span className="sign">+</span>
                            </>
                          ) : (
                            <>
                              <div> {intl.formatMessage({ id: 'blocks.blockly.project.save.noAddVideo' })} </div>
                              <span className="sign">-</span>
                            </>
                          )}
                        </div>
                        <div className={`field-shroud ${(!activeOptionalFields.videoUrl) ? 'field-hide' : ''}`}>
                          <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.addVideoLink' })} type="text" keyname="videoUrl" alternativeLabel />
                        </div>
                      </div>
                      <div className="challenges-div field-div">
                        <div className="shower-hider" onClick={() => this.toggleFieldShown('diagramImageUrl')} onKeyDown={() => { }}>
                          {(!activeOptionalFields.diagramImageUrl) ? (
                            <>
                              <div> {intl.formatMessage({ id: 'blocks.blockly.project.save.addDiagram' })} </div>
                              <span className="sign">+</span>
                            </>
                          ) : (
                            <>
                              <div> {intl.formatMessage({ id: 'blocks.blockly.project.save.noAddDiagram' })} </div>
                              <span className="sign">-</span>
                            </>
                          )}
                        </div>
                        <div className={`field-shroud ${(!activeOptionalFields.diagramImageUrl) ? 'field-hide' : ''}`}>
                          <UploadImageField defaultImage={saveForm.diagramImageUrl} sendDataBack={this.setImageValue} />
                        </div>
                      </div>
                      <div className="challenges-div field-div">
                        <div className="shower-hider" onClick={() => this.toggleFieldShown('challenges')} onKeyDown={() => { }}>
                          {(!activeOptionalFields.challenges) ? (
                            <>
                              <div>{intl.formatMessage({ id: 'blocks.blockly.project.save.addChallenges' })} </div>
                              <span className="sign">+</span>
                            </>
                          ) : (
                            <>
                              <div>{intl.formatMessage({ id: 'blocks.blockly.project.save.noAddChallenges' })}</div>
                              <span className="sign">-</span>
                            </>
                          )}
                        </div>
                        <div className={`field-shroud ${(!activeOptionalFields.challenges) ? 'field-hide' : ''}`}>
                          <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.addChallenge1' })} type="text" keyname="challenge1" alternativeLabel />
                          <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.addChallenge2' })} type="text" keyname="challenge2" alternativeLabel />
                          <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.addChallenge3' })} type="text" keyname="challenge3" alternativeLabel />
                        </div>
                      </div>
                      <div className="challenges-div field-div">
                        <div className="shower-hider" onClick={() => this.toggleFieldShown('extraMaterialUrl')} onKeyDown={() => { }}>
                          {(!activeOptionalFields.extraMaterialUrl) ? (
                            <>
                              <div>{intl.formatMessage({ id: 'blocks.blockly.project.save.addExtraMaterial' })}</div>
                              <span className="sign">+</span>
                            </>
                          ) : (
                            <>
                              <div>{intl.formatMessage({ id: 'blocks.blockly.project.save.noAddExtraMaterial' })}</div>
                              <span className="sign">-</span>
                            </>
                          )}
                        </div>
                        <div className={`field-shroud ${(!activeOptionalFields.extraMaterialUrl) ? 'field-hide' : ''}`}>
                          <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.addExtraMaterialLink' })} type="text" keyname="extraMaterialUrl" alternativeLabel />
                        </div>
                      </div>
                      <Selector selectedItems={tagsSelected} withSearch={true} items={tags.data} placeholder={intl.formatMessage({ id: 'blocks.blockly.project.save.addTags' })} fireWhenUpdate={this.selectorUpdate} />
                      {(!tabInfo.remoteSession && !tabInfo.assignmentSession) && (
                        <>
                          <div className="publicOrPrivate">
                            <Switch className="pp-switch" onChange={() => this.changeField('library', true)} checked={saveForm.library} />
                            <div className={`public ${saveForm.library ? 'green' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.library' })}</div>
                          </div>
                          <div className="explainer">
                            <div className={`private-explainer ${saveForm.library ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.libraryNo' })}</div>
                            <div className={`public-explainer ${!saveForm.library ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.libraryYes' })}</div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {(!tabInfo.remoteSession && !tabInfo.assignmentSession) && (
                    <>
                      <div className="publicOrPrivate">
                        <Switch className="pp-switch" onChange={() => this.changeField('public', true)} checked={saveForm.public} />
                        <div className={`public ${saveForm.public ? 'green' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.public' })}</div>
                      </div>
                      <div className="explainer">
                        <div className={`private-explainer ${saveForm.public ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.publicNo' })}</div>
                        <div className={`public-explainer ${!saveForm.public ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.publicYes' })}</div>
                      </div>
                    </>
                  )}
                  {(!remoteSessionObj.id) && (
                    <>
                      {(!tabInfo.remoteSession && !remoteSessionObj.id) && (
                        <>
                          <div className="auto-save">
                            <Switch className="pp-switch" onChange={() => this.changeField('autoSave', true)} checked={saveForm.autoSave} />
                            <div className={`with-auto-save ${saveForm.autoSave ? 'green' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.autoSave' })}</div>
                          </div>
                          <div className="explainer">
                            <div className={`without-auto-save-explainer ${saveForm.autoSave ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.autoSaveNo' })}</div>
                            <div className={`with-auto-save-explainer ${!saveForm.autoSave ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.autoSaveYes' })}</div>
                          </div>
                        </>
                      )}
                      {(!tabInfo.remoteSession && !tabInfo.assignmentSession && isProfesor) && (
                        <>
                          <div className="remote-session">
                            <Switch className="pp-switch" onChange={() => this.changeField('remoteProject', true)} checked={saveForm.remoteProject} />
                            <div className={`with-remote-session ${saveForm.remoteProject ? 'green' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.remoteSession' })}</div>
                          </div>
                          <div className="explainer">
                            <div className={`without-remote-session-explainer ${saveForm.remoteProject ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.remoteSessionNo' })}</div>
                            <div className={`with-remote-session-explainer ${!saveForm.remoteProject ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.remoteSessionYes' })}</div>
                          </div>
                          {(saveForm.remoteProject && !saveForm.assignmentProject) && (
                            <>
                              <div className="remote-session">
                                <Switch className="pp-switch" onChange={() => this.changeField('remoteProjectPasswordToggle', true)} checked={saveForm.remoteProjectPasswordToggle} />
                                <div className={`with-password ${saveForm.remoteProjectPasswordToggle ? 'green' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.private' })}</div>
                              </div>
                              <div className={`explainer ${saveForm.remoteProjectPasswordToggle && 'hidden mb-5 extra-height'}`}>
                                <div className={`with-password-explainer ${!saveForm.remoteProjectPasswordToggle && 'hidden'}`}>
                                  <InputComponent form={saveForm} changeField={this.changeField} name={intl.formatMessage({ id: 'blocks.blockly.project.save.password' })} type="password" keyname="remoteProjectPassword" />
                                </div>
                                <div className={`without-password-explainer ${saveForm.remoteProjectPasswordToggle ? 'hidden' : ''}`}>{intl.formatMessage({ id: 'blocks.blockly.project.save.withoutPassword' })}</div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {(!tabInfo.remoteSession && !tabInfo.assignmentSession && !saveForm.assignmentSession && isProfesor) && (
                    <>
                      <SaveAssignmentProjectFormComponent changeField={this.changeField} form={saveForm} />
                    </>
                  )}
                  {(!tabInfo.collaborationProject && !saveForm.collaborationProject && isProfesor && boardType === boardTypes.SENIOR) && (
                    <>
                      <SaveCollaborationProjectFormComponent changeField={this.changeField} form={saveForm} />
                    </>
                  )}
                  {/* {(tabInfo.remoteSession || remoteSessionObj.id !== 0 || saveForm.remoteSession) && (
                    <React.Fragment>
                      <div className="auto-compile">
                        <div className="without-auto-compile">Sin Auto-carga</div>
                        <Switch className="pp-switch" onChange={() => this.changeField('remoteAutoCompile', true)} checked={saveForm.remoteAutoCompile} />
                        <div className={`with-auto-compile ${saveForm.remoteAutoCompile ? 'green' : ''}`}>Auto-carga</div>
                      </div>
                      <div className="explainer">
                        <div className={`without-auto-compile-explainer ${saveForm.remoteAutoCompile ? 'hidden' : ''}`}>Avisar cuando alguien intente cargar código en mi placa</div>
                        <div className={`with-auto-compile-explainer ${!saveForm.remoteAutoCompile ? 'hidden' : ''}`}>Cualquier participante puede cargar código en mi placa</div>
                      </div>
                    </React.Fragment>
                  )} */}
                  <button
                    type="button"
                    id="save-button"
                    className="btn btn-primary main-btn"
                    disabled={waitForDiagramImage
                      || !saveForm.description
                      || (saveForm.description && saveForm.description.length < minDescriptionLength)
                      || (saveForm.description && saveForm.description.length >= maxDescriptionLength)
                      || saveForm.name.length < minNameLength
                      || saveForm.name.length > maxNameLength
                      || saveButtonDisabled
                      || (saveForm.assignmentProject && saveForm.assignmentProjectPasswordToggle && (!saveForm.assignmentProjectPassword || saveForm.assignmentProjectPassword.trim().length <= 0))
                      || (!saveForm.assignmentProject && saveForm.remoteProject && saveForm.remoteProjectPasswordToggle && saveForm.remoteProjectPassword.trim().length <= 0)}
                    onClick={this.saveProjectInDb}
                  >
                    {intl.formatMessage({ id: 'blocks.blockly.project.save.save' })}
                  </button>
                </>
              )}
            </div>
          </div>
        );
        break;
      case 'details':
        html = (
          <div className="right-panel-inner save-panel font-roboto">
            <div className="closeModal">
              <div className="close-panel" onClick={() => { this.closeRightPanel(); }} onKeyPress={() => { }}>
                <span className="icon-cross11" />
              </div>
            </div>
            <div className="details-panel">
              {(!isLogged) && (
                <ModalLogin />
              )}
              {(isLogged) && (
                <ProjectSidebar
                  name={saveForm.name}
                  description={saveForm.description}
                  diagramImageUrl={saveForm.diagramImageUrl || ''}
                  videoUrl={saveForm.videoUrl || ''}
                  withObjetives={saveForm.isLibrary || false}
                  challenges={challenges}
                  tags={tagsSelected.map((i) => i.name)}
                  extraMaterialUrl={saveForm.extraMaterialUrl || ''}
                />
              )}
              {(!tabInfo.assignmentSession
                && (tabInfo.remoteSession || remoteSessionObj.id !== 0 || saveForm.remoteSession)
                && match
                && match.url.indexOf('remote') === -1
                && match.url.indexOf('actividad') === -1
              ) ? (
                <>
                  <div className="sidebar-content">
                    <div className="project-remote">
                      <h4>{intl.formatMessage({ id: 'blocks.blockly.project.details.remoteSession' })}</h4>
                      <p>
                        <strong>{intl.formatMessage({ id: 'blocks.blockly.project.details.remoteSessionNumber' })}: </strong>
                        {(saveForm.remoteSession) ? saveForm.remoteSession : remoteSessionObj.id}
                        {(tabInfo.remoteProjectPassword) ? (
                          <>
                            <br />
                            <strong>{intl.formatMessage({ id: 'blocks.blockly.project.details.remoteSessionPassword' })}: </strong>
                            {tabInfo.remoteProjectPassword}
                          </>
                        ) : ('')}
                      </p>
                    </div>
                    {(!tabInfo.assignmentSession && (!match.url || match.url.indexOf('remote') === -1)) ? (
                      <a href={`${routes.bloquesUri}/remote-${(saveForm.remoteSession) ? saveForm.remoteSession : remoteSessionObj.id}`} className="btn btn-primary main-btn">
                        {intl.formatMessage({ id: 'blocks.blockly.project.details.remoteSessionAccess' })}
                      </a>
                    ) : ('')}
                  </div>
                </>
                ) : ('')}
              {((tabInfo.assignmentSession && match && match.url.indexOf('actividad') === -1) || tabInfo.assignmentUserRole === 'OWNER') ? (
                <AssignmentLinkComponent
                  url={(match && match.url) ? match.url : ''}
                  id={(tabInfo.assignmentSession) ? tabInfo.assignmentSession : 0}
                  password={(tabInfo.assignmentProjectPassword) ? tabInfo.assignmentProjectPassword : null}
                />
              ) : ('')}
              {((tabInfo.collaborationProject || saveForm.collaborationProject) && match && match.url.indexOf('colaboracion') === -1) ? (
                <CollaborationLinkComponent
                  url={(match && match.url) ? match.url : ''}
                  id={tabInfo.collaborationSession || saveForm.collaborationSession || 0}
                />
              ) : ('')}
              {(
                auth.userData
                && auth.userData.data
                && (auth.userData.data.roles.names.includes('Contenidista')
                  || auth.userData.data.roles.names.includes('Contenidista Global')
                  || auth.userData.data.roles.names.includes('Administrador')
                )
                && (tabInfo.userId && auth.userData.data.userId === tabInfo.userId)
                && (!tabInfo.assignmentSession || tabInfo.assignmentUserRole === 'OWNER' || tabInfo.remoteUserRole === 'OWNER')
                && (!tabInfo.collaborationProjectUserRole || tabInfo.collaborationProjectUserRole === 'OWNER' || tabInfo.collaborationProjectUserRole === 'OWNER')
              ) ? (
                <>
                  <button
                    type="button"
                    id="save-button"
                    className="btn btn-primary main-btn"
                    onClick={() => this.loadRightPanelProjectWorkflow('save')}
                    disabled={!(getAssignmentDeliverableState)}
                  >
                    {intl.formatMessage({ id: 'blocks.blockly.project.details.edit' })}
                  </button>
                </>
                ) : ('')}
              { /*
              {(isLogged && !saveForm.id && saveForm.description === '') && (
                <React.Fragment>
                  <div className="profile value">
                    <span className={`board ${tabInfo.className}`}>{tabInfo.boardName}</span>
                  </div>
                  <div className="name-title value">Para poder ver los detalles del proyecto, primero debes guardarlo</div>
                  <button type="button" className="btn btn-primary main-btn" onClick={() => this.loadRightPanelProjectWorkflow('save')}>Guardar proyecto</button>
                </React.Fragment>
              ) }
              */ }
            </div>
          </div>
        );
        break;
      default:
        html = (
          <div className="right-panel-inner tutorial font-roboto">
            <div className="closeModal">
              <div className="close-panel" onClick={() => { this.closeRightPanel(); }} onKeyPress={() => { }}>
                <span className="icon-cross11" />
              </div>
            </div>
            <h4 className="help-header right-panel-header">{intl.formatMessage({ id: 'projects.export' })}</h4>
            <div className="anibot-container">
              <div className="anibot" />
            </div>
          </div>
        );
    }

    if (!isUpdate) {
      this.openRightPanel(html, type);
    } else {
      rightPanel.children = html;
      this.setState({ rightPanel });
    }
  }

  initJitsi() {
    const { remoteSessionObj } = this.state;
    const { auth } = this.props;

    const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    const toolbarButtons = ['microphone', 'camera', 'desktop', 'fullscreen', 'tileview', 'chat'];
    if (IAmTheTheacher) {
      toolbarButtons.push('mute-everyone');
    }
    const domain = '8x8.vc';
    const token = 'vpaas-magic-cookie-c2650efc844840bfb1076f8e802fe4d7';
    const options = {
      roomName: `${token}/remote-${remoteSessionObj.id}`,
      parentNode: document.querySelector('#remoteJitsiBox'),
      interfaceConfigOverwrite: {
        TOOLBAR_BUTTONS: toolbarButtons,
        SET_FILMSTRIP_ENABLED: false,
        DISABLE_VIDEO_BACKGROUND: true,
        DISABLE_FOCUS_INDICATOR: true,
        DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
        DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
      },
      userInfo: {
        email: auth.userData.data.email,
        displayName: `${auth.userData.data.name} ${auth.userData.data.lastName}`,
      },

      configOverwrite: {
        // startAudioOnly: true,
        // startWithVideoMuted: true,
        disableAudioLevels: true,
        enableNoAudioDetection: false,
        enableNoisyMicDetection: false,

        enableLayerSuspension: true,
        // disableSimulcast: true,
        // resolution: 360,
        // maxFps: 15,
        // constraints: {
        //   video: {
        //     frameRate: {
        //       max: 15,
        //       min: 5,
        //     },
        //     height: {
        //       ideal: 360,
        //       max: 360,
        //       min: 120,
        //     },
        //   },
        // },
        p2p: {
          enabled: false,
        },
        prejoinConfig: {
          enabled: false,
        },
      },
    };

    if (!IAmTheTheacher) {
      options.configOverwrite.startWithVideoMuted = true;
      options.configOverwrite.resolution = 360;
      options.configOverwrite.maxFps = 15;
      options.configOverwrite.constraints = {
        video: {
          frameRate: {
            max: 15,
            min: 5,
          },
          height: {
            ideal: 360,
            max: 360,
            min: 120,
          },
        },
      };
    }

    remoteSessionObj.jitsiApi = new JitsiMeetExternalAPI(domain, options); /* eslint-disable-line */
    this.setState({ remoteSessionObj });
  }


  loadBlocklyPanel() {
    const { scriptsToLoad, tabInfo, boardType, lang } = this.state;
    const timestamp = pjson.version;

    if (boardType === 'senior') {
      scriptsToLoad.push('/js/educablocks/blockly_compressed.js');
      scriptsToLoad.push('/js/educablocks/blocks_compressed.js');
      scriptsToLoad.push('/js/educablocks/arduino_compressed.js');
      scriptsToLoad.push('/js/educablocks/javascript_compressed.js');
      scriptsToLoad.push(`/js/educablocks/msg/js/${lang}.js`);
      scriptsToLoad.push('/js/educablocks/zfunctionsBlocks.js');
      scriptsToLoad.push('/js/educablocks/microbit.js');
      scriptsToLoad.push('/js/educablocks/drone.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsArduino.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsJavaScript.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsDrone.js');
    }
    if (boardType === 'junior') {
      scriptsToLoad.push('/js/educablocks/blockly_compressed_horizontal.js');
      scriptsToLoad.push('/js/educablocks/arduino_compressed.js');
      scriptsToLoad.push('/js/educablocks/javascript_compressed.js');
      scriptsToLoad.push(`/js/educablocks/msg/js/${lang}.js`);
      scriptsToLoad.push('/js/educablocks/zfunctionsBlocksJR.js');
      scriptsToLoad.push('/js/educablocks/codit.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsArduinoJR.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsJavaScriptJR.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsCodit.js');
    }
    if (tabInfo.remoteSession) {
      scriptsToLoad.push('https://meet.jit.si/external_api.js');
    }
    if (tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') {
      scriptsToLoad.push('/js/educablocks/simulator/three.min.js');
      scriptsToLoad.push('/js/educablocks/simulator/Detector.js');
      scriptsToLoad.push('/js/educablocks/simulator/OrbitControls.js');
      scriptsToLoad.push('/js/educablocks/simulator/THREEx.KeyboardState.js');
      scriptsToLoad.push('/js/educablocks/simulator/THREEx.FullScreen.js');
      scriptsToLoad.push('/js/educablocks/simulator/THREEx.WindowResize.js');
      scriptsToLoad.push('/js/educablocks/simulator/objLoader.js');
      scriptsToLoad.push('/js/educablocks/simulator/ImprovedNoise.js');
      scriptsToLoad.push('/js/educablocks/simulator/BufferGeometryUtils.js');
      scriptsToLoad.push('/js/educablocks/simulator/NormalMapShader.js');
      scriptsToLoad.push('/js/educablocks/simulator/ShaderTerrain.js');
      scriptsToLoad.push('/js/educablocks/simulator/stats.min.js');
      scriptsToLoad.push('/js/educablocks/simulator/simulator_api.js');
      scriptsToLoad.push('/js/educablocks/simulator/simulator.js');
    }

    const scriptsToLoadWithTimestamp = scriptsToLoad.map((i) => `${i}?${timestamp}`);

    if (boardType === 'code') {
      loadExt(scriptsToLoadWithTimestamp, this.afterLoadBlocklyPanel);
    } else if ((tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') && document.querySelectorAll('script[src*="simulator/simulator"]').length > 0 && document.querySelectorAll('script[src*="blockly_compressed"]').length > 0) {
      this.initBlockly();
    } else if (tabInfo.board.profile !== 'drone' && tabInfo.board.profile !== 'drone13' && document.querySelectorAll('script[src*="blockly_compressed"]').length > 0) {
      this.initBlockly();
    } else {
      loadExt(scriptsToLoadWithTimestamp, this.initBlockly);
      // NEVER DO THIS IN YOUR HOME
      window.cleanToolBoxSelection = () => {
        $('div[role="treeitem"]').attr('aria-selected', false);
        $('div[role="treeitem"][aria-expanded]').attr('aria-expanded', false);
        $('div[role="treeitem"][aria-expanded]').css('height', `${this.getHeightOfRow()}px`);
      };

      $(document).on('click change', '.blocklyWorkspace', () => {
        if ($('.blocklyFlyout').css('display') === 'none') {
          window.cleanToolBoxSelection();
        }
      });

      const self = this;
      $(document).on('click', 'div[role="treeitem"]', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('div[role="treeitem"]').attr('aria-selected', false);
        $(this).attr('aria-selected', ($(this).attr('aria-selected') === 'false'));
        if ($(this).attr('aria-expanded') === 'true') {
          window.cleanToolBoxSelection();
        } else if (!($(this).parent().parent().attr('role') === 'treeitem')) {
          $('div[role="treeitem"][aria-expanded]').attr('aria-expanded', false);
          $('div[role="treeitem"][aria-expanded]').css('height', `${self.getHeightOfRow()}px`);
          if ($(this).attr('aria-expanded') !== undefined) $(this).attr('aria-expanded', ($(this).attr('aria-expanded') === 'false'));
          if ($(this).attr('aria-expanded') === 'true') {
            $(this).css('height', `${($($(this).children()[1]).children().length + 1) * self.getHeightOfRow()}px`);
          }
        }
      });
    }
  }

  async afterLoadBlocklyPanel() {
    const { auth } = this.props;
    const { id, demoWorkspace, doOnReady, tabInfo, boardType, darkthemeToggle } = this.state;
    this.setState({ blocklyInited: true, loading: false }, () => {
      doOnReady();
    });
    const list = document.querySelectorAll(`#${id} .blocklyFlyout .blocklyWorkspace .blocklyZoom .modal-backdrop`);
    if (list.length > 0) {
      for (let i = 0; i < list.length; i += 1) {
        list[i].remove();
      }
    }
    const modals = document.querySelectorAll('.modal-backdrop');
    for (let i = 0; i < modals.length; i += 1) {
      modals[i].remove();
    }
    // collapse all substr
    if (tabInfo.board.type !== 'code') {
      $('div[role="treeitem"][aria-expanded]').attr('aria-expanded', 'false');
      $('div[role="treeitem"][aria-expanded]').css('height', `${this.getHeightOfRow()}px`);
    }

    if (tabInfo.board.type === 'junior') {
      const ele = document.querySelector('.blocklyToolboxDiv');
      if (ele) {
        if (darkthemeToggle) ele.classList.add('darkTheme');
        ele.classList.add('BlocklyPanelFull');
        ele.classList.add('blocklyToolboxDiv-text');
      }
    }

    // eslint-disable-next-line func-names

    const toolboxTrashcan = `
    <div class="toolboxTrashcan">
      <div class="trash-parent">
        <span class="trash">
            <span></span>
            <i></i>
          </span>
      </div>
    <div>`;

    [].forEach.call(window.document.querySelectorAll('.blocklyTreeRoot'), (item) => {
      // eslint-disable-next-line no-param-reassign
      item.innerHTML += toolboxTrashcan;
    });

    if (boardType === 'senior') {
      const onresize = () => {
        window.Blockly.svgResize(demoWorkspace);
      };
      window.removeEventListener('resize', onresize, false);
      window.addEventListener('resize', onresize, false);
      onresize();
      window.Blockly.svgResize(demoWorkspace);
      demoWorkspace.clearUndo();
    }

    if (tabInfo.remoteSession) {
      interact('#remoteThumbsBox').resizable({
        edges: { left: true, right: false, bottom: false, top: false },
        listeners: {
          move(event) {
            const target = event.target;
            let x = (parseFloat(target.getAttribute('data-x')) || 0);
            // let y = (parseFloat(target.getAttribute('data-y')) || 0);

            // update the element's style
            target.style.width = `${event.rect.width}px`;
            // target.style.height = event.rect.height + 'px'

            // translate when resizing from top or left edges
            x += event.deltaRect.left;
            // y += event.deltaRect.top;

            // target.style.webkitTransform = target.style.transform =
            //   'translate(' + x + 'px,' + y + 'px)';
            target.style.webkitTransform = `translate(${x})`;
            target.style.transform = target.style.webkitTransform;

            target.setAttribute('data-x', x);
            // target.setAttribute('data-y', y);
            // target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height);
          },
        },
        modifiers: [
          // keep the edges inside the parent
          interact.modifiers.restrictEdges({
            outer: 'parent',
          }),

          // minimum size
          interact.modifiers.restrictSize({
            min: { width: 100, height: 50 },
          }),
        ],

        inertia: true,
      });

      interact('.jitsi-box').resizable({
        // resize from all edges and corners
        edges: { left: true, right: true, bottom: true, top: true },

        listeners: {
          move(event) {
            const target = event.target;
            let x = (parseFloat(target.getAttribute('data-x')) || 0);
            let y = (parseFloat(target.getAttribute('data-y')) || 0);

            // update the element's style
            target.style.width = `${event.rect.width}px`;
            target.style.height = `${event.rect.height}px`;

            // translate when resizing from top or left edges
            x += event.deltaRect.left;
            // x += event.deltaRect.right;
            y += event.deltaRect.top;

            target.style.webkitTransform = `translate(${x}px, ${y}px)`;
            target.style.transform = `translate(${x}px, ${y}px)`;

            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
            // target.textContent = `${Math.round(event.rect.width)}\u00D7${Math.round(event.rect.height)}`;
          },
        },
        // modifiers: [
        //   // minimum size
        //   interact.modifiers.restrictSize({
        //     min: { width: 300, height: 200 },
        //     max: { width: 800, height: 600 },
        //   }),
        // ],

        inertia: true,
      }).draggable({
        listeners: {
          move(event) {
            const target = event.target;
            // keep the dragged position in the data-x/data-y attributes
            const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            target.style.webkitTransform = `translate(${x}px, ${y}px)`;
            target.style.transform = `translate(${x}px, ${y}px)`;

            // update the posiion attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
          },
        },
        inertia: true,
        modifiers: [
          interact.modifiers.restrict({
            restriction: 'parent',
            endOnly: true,
          }),
        ],
      });

      interact('.chronometer-box').draggable({
        listeners: {
          move(event) {
            const target = event.target;
            // keep the dragged position in the data-x/data-y attributes
            const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            target.style.webkitTransform = `translate(${x}px, ${y}px)`;
            target.style.transform = `translate(${x}px, ${y}px)`;

            // update the posiion attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
          },
        },
        inertia: true,
        modifiers: [
          interact.modifiers.restrict({
            restriction: 'parent',
            endOnly: true,
          }),
        ],
      });
    }
  }

  codeToggleAction() {
    const { codeToggle, demoWorkspace } = this.state;
    this.setState({ codeToggle: !codeToggle }, () => {
      setTimeout(() => {
        window.Blockly.svgResize(demoWorkspace);
      }, 100);
    });
  }

  mlPanelToggleAction(state) {
    const { demoWorkspace } = this.state;
    setTimeout(() => {
      if (window.Blockly) {
        window.Blockly.svgResize(demoWorkspace);
      }
    }, 10);
  }

  arduinoSimulatorToggleAction(state) {
    const { arduinoSimulatorToggle, demoWorkspace } = this.state;
    const newState = (typeof state !== 'object') ? state : !arduinoSimulatorToggle;
    this.setState({ arduinoSimulatorToggle: newState }, () => {
      setTimeout(() => {
        if (window.Blockly) {
          window.Blockly.svgResize(demoWorkspace);
        }
      }, 10);
    });
  }

  droneSimulationToggleAction() {
    const { droneSimulationToggle, demoWorkspace } = this.state;
    this.setState({ droneSimulationToggle: !droneSimulationToggle }, () => {
      setTimeout(() => {
        window.Blockly.svgResize(demoWorkspace);
        if (!droneSimulationToggle) {
          window.initDroneSimulation();
        }
      }, 100);
    });
  }

  remoteThumbToggleAvailability(projectId, settings) {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector(`.remote-thumb-${projectId}`);
    let available = 'AVAILABLE';
    if (ele.querySelector('.icon-check-square')) {
      const icon = ele.querySelector('.icon-check-square');
      icon.classList.remove('icon-check-square');
      icon.classList.remove('green');
      icon.classList.add('icon-square-o');
      icon.classList.add('yellow');
      available = 'NOTAVAILABLE';
    } else {
      const icon = ele.querySelector('.icon-square-o');
      icon.classList.remove('icon-square-o');
      icon.classList.remove('yellow');
      icon.classList.add('icon-check-square');
      icon.classList.add('green');
      available = 'AVAILABLE';
    }

    const currentSettings = settings;
    currentSettings.boardAvailabilityState = available;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      projectId,
      {
        settings: currentSettings,
      },
    );
  }

  remoteThumbToggleAvailabilityAll() {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector('.teacher-students');
    let available = true;
    if (ele.querySelector('.icon-check-square')) {
      const icon = ele.querySelector('.icon-check-square');
      icon.classList.remove('icon-check-square');
      icon.classList.add('icon-minus-square');
      available = false;
    } else {
      const icon = ele.querySelector('.icon-minus-square');
      icon.classList.remove('icon-minus-square');
      icon.classList.add('icon-check-square');
      available = true;
    }

    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    currentSettings.boardAvailability = available;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );
  }


  remoteThumbToggleScreenBlockAll() {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector('.teacher-students');
    let show = true;
    if (ele.querySelector('.icon-display')) {
      const icon = ele.querySelector('.icon-display');
      icon.classList.remove('icon-display');
      icon.classList.add('icon-desktop_access_disabled');
      // Save settings hide all except teacher's
      show = true;
    } else {
      const icon = ele.querySelector('.icon-desktop_access_disabled');
      icon.classList.remove('icon-desktop_access_disabled');
      icon.classList.add('icon-display');
      // Save settings show all
      show = false;
    }

    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    currentSettings.screenBlocked = show;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );
  }

  remoteThumbToggleSeeOne(projectId, settings, teacher = false) {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    let ele;
    if (teacher) {
      ele = document.querySelector('.teacher');
    } else {
      ele = document.querySelector(`.remote-thumb-${projectId}`);
    }
    let show = true;
    if (ele.querySelector('.icon-view-show')) {
      const icon = ele.querySelector('.icon-view-show');
      icon.classList.remove('icon-view-show');
      icon.classList.add('icon-view-hide');
      // Save settings hide all except teacher's
      show = false;
    } else {
      const icon = ele.querySelector('.icon-view-hide');
      icon.classList.remove('icon-view-hide');
      icon.classList.add('icon-view-show');
      // Save settings show all
      show = true;
    }

    const currentSettings = settings;
    currentSettings.thumbsVisibility = show;
    if (teacher && currentSettings.teacherScreenMaximized) {
      this.remoteThumbToggleMaximizeTeacherScreen(projectId);
    }
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      projectId,
      {
        settings: currentSettings,
      },
    );
  }

  remoteThumbCopyTeacherScreen() {
    const { remoteSessionObj } = this.state;
    const { putRemoteSessionProjectBulk } = this.props;

    const settingsArray = [];
    for (let i = 0; i < remoteSessionObj.projects.length; i += 1) {
      if (remoteSessionObj.teacher.projectIndex !== i) {
        const currentSettings = remoteSessionObj.projects[i].settings;
        currentSettings.copyTeacherScreen = true;
        settingsArray.push({
          remoteSessionsProjectId: remoteSessionObj.projects[i].id,
          settings: currentSettings,
        });
      }
    }
    putRemoteSessionProjectBulk(
      remoteSessionObj.id,
      {
        data: settingsArray,
      },
    );
  }

  remoteThumbToggleMaximizeTeacherScreen(id) {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector(`.remote-thumb-${id}`);
    const icon = ele.querySelector('.icon-export');

    let show = true;
    if (icon.classList.contains('green')) {
      icon.classList.remove('green');
      ele.classList.remove('folded-teacher');
      show = false;
    } else {
      icon.classList.add('green');
      ele.classList.add('folded-teacher');
      show = true;
    }

    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    currentSettings.teacherScreenMaximized = show;
    if (show) {
      currentSettings.thumbsVisibility = true;
    }
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );
  }


  remoteThumbToggleSeeTeacherScreen(id, miximized = false) {
    if (document.querySelector(`.remote-thumb-${id}`)) {
      const ele = document.querySelector(`.remote-thumb-${id}`);
      const icon = ele.querySelector('.icon-maximize');
      const buttonBar = ele.querySelector('.button-bar');

      if (ele.querySelector('.actual-code')) {
        const code = ele.querySelector('.actual-code');
        if (ele.classList.contains('isActive') && !miximized && !icon.classList.contains('icon-shrink')) {
          code.classList.remove('scrolleable-block');
        } else if (miximized) {
          code.classList.add('scrolleable-block');
        }
      }

      if (ele.classList.contains('isActive') && !miximized && !icon.classList.contains('icon-shrink')) {
        ele.classList.remove('isActive');
        icon.classList.add('icon-expand');
        buttonBar.classList.remove('hidden');
      } else if (miximized) {
        ele.classList.add('isActive');
        icon.classList.remove('icon-expand');
        icon.classList.remove('icon-shrink');
        buttonBar.classList.add('hidden');
      }
    }
  }


  remoteSessionCopyTeacherScreen(projectIndex) {
    const { remoteSessionObj, demoWorkspace, boardType } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const teacherProject = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].Project;
    if (boardType === 'code') {
      this.saveCode(teacherProject.jsonBody.code);
    } else {
      const xml = window.Blockly.Xml.textToDom(teacherProject.jsonBody.withWorkspace);
      demoWorkspace.clear();
      window.Blockly.Xml.domToWorkspace(xml, demoWorkspace);
    }

    // remoteSessionObj.projects[projectIndex].Project.jsonBody.canvas = teacherProject.jsonBody.canvas;
    // remoteSessionObj.projects[projectIndex].Project.jsonBody.canvasBBoxX = teacherProject.jsonBody.canvasBBoxX;
    // remoteSessionObj.projects[projectIndex].Project.jsonBody.canvasBBoxY = teacherProject.jsonBody.canvasBBoxY;
    // remoteSessionObj.projects[projectIndex].Project.jsonBody.canvasBBoxWidth = teacherProject.jsonBody.canvasBBoxWidth;
    // remoteSessionObj.projects[projectIndex].Project.jsonBody.canvasBBoxHeight = teacherProject.jsonBody.canvasBBoxHeight;
    // this.setState({ remoteSessionObj });

    const myProject = remoteSessionObj.projects[projectIndex].Project;
    const currentSettings = remoteSessionObj.projects[projectIndex].settings;
    currentSettings.copyTeacherScreen = false;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      myProject.id,
      { settings: currentSettings },
    );
  }


  remoteThumbToggleJitsiMinMax() {
    const ele = document.querySelector('.jitsi-box');
    const ico = ele.querySelector('.icon-max-min');
    const anybot = ele.querySelector('.contain');

    if (ele.classList.contains('maximized')) {
      if (ele.querySelector('iframe')) {
        const iframe = ele.querySelector('iframe');
        iframe.style.display = 'none';
        anybot.classList.remove('anibot-large-white');
      }
      ico.classList.remove('icon-fullscreen_exit');
      ico.classList.add('icon-fullscreen');
      ele.classList.remove('maximized');
      ele.classList.add('minimized');
    } else {
      if (ele.querySelector('iframe')) {
        const iframe = ele.querySelector('iframe');
        iframe.style.display = 'block';
        anybot.classList.add('anibot-large-white');
      }
      ico.classList.remove('icon-fullscreen');
      ico.classList.add('icon-fullscreen_exit');
      ele.classList.remove('minimized');
      ele.classList.add('maximized');
    }
    ele.removeAttribute('style');
    ele.removeAttribute('data-x');
    ele.removeAttribute('data-y');
  }

  remoteThumbToggleJitsi(show) {
    const { remoteSessionObj } = this.state;

    if (document.querySelector('.jitsi-box')) {
      const ele = document.querySelector('.jitsi-box');
      if (!show && ele.classList.contains('isActive')) {
        ele.classList.remove('isActive');
        ele.classList.remove('minimized');
        ele.classList.remove('maximized');
        ele.removeAttribute('style');
        ele.removeAttribute('data-x');
        ele.removeAttribute('data-y');
        if (remoteSessionObj.jitsiApi) {
          remoteSessionObj.jitsiApi.dispose();
        }
      }
      if (show && !ele.classList.contains('isActive')) {
        ele.classList.add('isActive');
        ele.classList.add('maximized');
        const anybot = ele.querySelector('.contain');
        anybot.classList.add('anibot-large-white');
        this.initJitsi();
      }
    }
  }

  remoteThumbToggleJitsiAll() {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector('.jitsi-box');
    let show = true;
    if (ele.classList.contains('isActive')) {
      ele.classList.remove('isActive');
      ele.classList.remove('minimized');
      ele.classList.remove('maximized');
      ele.removeAttribute('style');
      ele.removeAttribute('data-x');
      ele.removeAttribute('data-y');
      show = false;
      if (remoteSessionObj.jitsiApi) {
        remoteSessionObj.jitsiApi.dispose();
      }
    } else {
      ele.classList.add('isActive');
      ele.classList.add('maximized');
      const anybot = ele.querySelector('.contain');
      anybot.classList.add('anibot-large-white');
      show = true;
      this.initJitsi();
    }

    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    currentSettings.jitsiVideoAll = show;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );
  }

  remoteThumbToggleYouTube(youtubeVideoContent) {
    const { remoteSessionObj } = this.state;

    if (document.querySelector('.youtube-box')) {
      const ele = document.querySelector('.youtube-box');
      if (youtubeVideoContent === 0 && ele.classList.contains('isActive')) {
        ele.classList.remove('isActive');
        ele.classList.remove('minimized');
        ele.classList.remove('maximized');
        ele.removeAttribute('style');
        ele.removeAttribute('data-x');
        ele.removeAttribute('data-y');
      }
      if (remoteSessionObj.youtubeVideoSources.length > 1 && youtubeVideoContent !== 0 && !ele.classList.contains('isActive')) {
        ele.classList.add('isActive');
        ele.classList.add('maximized');
        const anybot = ele.querySelector('.contain');
        anybot.classList.add('anibot-large-white');
      }
    }
  }

  remoteThumbToggleYouTubeSource(source = 0) {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    currentSettings.youtubeVideoContent = parseInt(source, 10);
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );
  }

  remoteThumbToggleYouTubeAll() {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector('.youtube-box');
    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    let content = 0;
    if (ele.classList.contains('isActive')) {
      ele.classList.remove('isActive');
      ele.classList.remove('minimized');
      ele.classList.remove('maximized');
      ele.removeAttribute('style');
      ele.removeAttribute('data-x');
      ele.removeAttribute('data-y');
      content = 0;
    } else {
      ele.classList.add('isActive');
      ele.classList.add('maximized');
      const anybot = ele.querySelector('.contain');
      anybot.classList.add('anibot-large-white');
      content = (currentSettings.youtubeVideoContent) ? currentSettings.youtubeVideoContent : 1;
    }

    currentSettings.youtubeVideoContent = content;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );
  }

  remoteThumbToggleSeeAll() {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector('.teacher-students');
    let show = true;
    if (ele.querySelector('.icon-view-show')) {
      const icon = ele.querySelector('.icon-view-show');
      icon.classList.remove('icon-view-show');
      icon.classList.add('icon-view-hide');
      // Save settings hide all except teacher's
      show = false;
    } else {
      const icon = ele.querySelector('.icon-view-hide');
      icon.classList.remove('icon-view-hide');
      icon.classList.add('icon-view-show');
      // Save settings show all
      show = true;
    }

    const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    currentSettings.thumbsVisibilityAll = show;
    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
      {
        settings: currentSettings,
      },
    );

    // this.remoteThumbToggleSeeAllExecute(show);
  }

  remoteThumbToggleSeeAllExecute(show = true) {
    const students = document.querySelectorAll('.remote-thumbnail');
    for (let i = 0; i < students.length; i += 1) {
      const thumb = document.querySelector(`.remote-thumb-${students[i].id}`);
      if (!show) {
        const icon = thumb.querySelector('.icon-minus');
        if (icon) {
          icon.classList.remove('icon-minus');
          icon.classList.add('icon-plus');
          thumb.classList.add('folded');
        }
      } else {
        const icon = thumb.querySelector('.icon-plus');
        if (icon) {
          icon.classList.add('icon-minus');
          icon.classList.remove('icon-plus');
          thumb.classList.remove('folded');
        }
      }
    }
  }

  remoteThumbsToggleAction() {
    const { remoteThumbsToggle, demoWorkspace, boardType } = this.state;
    if (remoteThumbsToggle) {
      const right = $('#remoteThumbsBox');
      right.css('width', '0px');
    }
    this.setState({ remoteThumbsToggle: !remoteThumbsToggle }, () => {
      if (boardType !== 'code') {
        setTimeout(() => {
          window.Blockly.svgResize(demoWorkspace);
        }, 100);
      }
    });
  }

  remoteThumbToggleMaximize(id) {
    if (document.querySelector(`.remote-thumb-${id}`)) {
      const ele = document.querySelector(`.remote-thumb-${id}`);
      const icon = ele.querySelector('.icon-maximize');

      if (ele.querySelector('.actual-code')) {
        const code = ele.querySelector('.actual-code');
        if (ele.classList.contains('isActive')) {
          code.classList.remove('scrolleable-block');
        } else {
          code.classList.add('scrolleable-block');
        }
      }

      if (ele.classList.contains('isActive')) {
        ele.classList.remove('isActive');
        icon.classList.remove('icon-shrink');
        icon.classList.add('icon-expand');
      } else {
        ele.classList.add('isActive');
        icon.classList.remove('icon-expand');
        icon.classList.add('icon-shrink');
      }
    }
  }


  remoteThumbCheckMaximized(id) {
    if (document.querySelector(`.remote-thumb-${id}`)) {
      const ele = document.querySelector(`.remote-thumb-${id}`);
      const icon = ele.querySelector('.icon-maximize');
      if (ele.classList.contains('folded')) {
        if (icon.classList.remove('icon-shrink')) {
          icon.classList.remove('icon-shrink');
        }
      } else if (!icon.classList.remove('icon-expand')) {
        icon.classList.add('icon-expand');
      }
    }
  }

  remoteThumbToggleFold(id) {
    const ele = document.querySelector(`.remote-thumb-${id}`);
    let icon;
    if (ele.querySelector('.icon-minus')) {
      icon = ele.querySelector('.icon-minus');
      icon.classList.remove('icon-minus');
      icon.classList.add('icon-plus');
      ele.classList.add('folded');
    } else {
      icon = ele.querySelector('.icon-plus');
      icon.classList.add('icon-minus');
      icon.classList.remove('icon-plus');
      ele.classList.remove('folded');
    }
  }

  consoleToggleAction() {
    const { consoleToggle, socket } = this.state;
    const { tabInfo } = this.state;
    if (tabInfo.portOpen && consoleToggle) {
      socket.closeMonitor(tabInfo.port);
      tabInfo.portOpen = false;
    }
    this.setState({ tabInfo, consoleToggle: !consoleToggle });
  }

  closeSerialMonitor() {
    const { tabInfo, socket } = this.state;
    if (tabInfo.portOpen) {
      socket.closeMonitor(tabInfo.port);
      tabInfo.portOpen = false;
      this.setState({ tabInfo });
    }
  }

  toggleSerialMonitor() {
    const { tabInfo, socket } = this.state;
    if (!tabInfo.portOpen) {
      // socket.openMonitor(tabInfo.port);
      tabInfo.portOpen = true;
    } else {
      // socket.closeMonitor(tabInfo.port);
      tabInfo.portOpen = false;
    }
    this.setState({ tabInfo });
  }

  buildBlocklyCodit() {
    const { codeGenerated, codit } = this.state;
    if (!codit.missionRunning) {
      this.shootMsg('Ejecución iniciada ...');
      codit.executeCommands(codeGenerated, (missionRunning) => {
        if (!missionRunning) {
          this.shootMsg('Ejecución terminada');
        }
      });
    } else {
      this.shootMsg('Espera a que termine la ejecución actual.');
    }
  }

  buildBlocklyDrone() {
    const { codeGenerated, drone } = this.state;
    if (!drone.missionRunning) {
      // drone.executeCommands(codeGenerated);
      drone.checkBatteryCommands(codeGenerated).then((response) => {
        if (response === false) {
          this.shootMsg('Nivel de batería demasiado bajo para realizar FLIPS. Estos comandos se ignorarán.');
        } else {
          this.shootMsg('Misión iniciada ...');
        }
        drone.executeCommands(codeGenerated);
      }).catch((err) => {
        console.log('Error:', err);
      });
    } else {
      this.shootMsg('Espera a que termine la misión actual.');
    }
  }


  buildBlockly(compileFromQueueId = null, remoteProjectId = null, port = '') {
    const { codeGenerated, tabInfo, ports, id, bottomNav, boardType, remoteSessionObj, code, socket, microbitForceDownload } = this.state;
    let { connectionModalType } = this.state;
    const { postRemoteSessionCompilation, putRemoteSessionCompilation, putBulkRemoteSessionCompilation, auth } = this.props;

    let codeToSend = codeGenerated;
    if (boardType === 'code') {
      codeToSend = (tabInfo.code) ? tabInfo.code : code;
    }
    const selectedPort = (port && port !== '' && ports.includes(port)) ? port : tabInfo.port;
    if (!selectedPort && !microbitForceDownload && !remoteProjectId) {
      this.setState({
        microbitTempBuild: {
          compileFromQueueId,
          remoteProjectId,
          port,
        },
      });
      this.webSerialModalChangeStep(0);
      $(`#webSerialModal-${id}`).modal('show');

      return;
    }
    // Show webSerialModal on every build request
    this.setState({ microbitForceDownload: (process.env.IS_ELECTRON) });

    if (tabInfo.portOpen) {
      socket.closeMonitor(selectedPort);
      tabInfo.portOpen = false;
      this.setState({ tabInfo });
    }
    if (compileFromQueueId !== null && (selectedPort !== '' || tabInfo.board.compilerBoard === 'microbit')) {
      this.toastSend(
        <span className="body">
          <span className="icon icon-send" />
          <span className="first-line">
            ¡Subiendo el código!
            <span className="second-line">El código se está subiendo a la placa.</span>
          </span>
        </span>,
        'R',
        { className: 'code-sending' },
      );
      const oldUploadToBoard = [];
      let remoteCode = '';
      let uploadToBoardIndex = null;
      for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
        if (remoteSessionObj.projects[k].Project.id === remoteProjectId) {
          for (let j = 0; j < remoteSessionObj.projects[k].RemoteSessionsCompilations.length; j += 1) {
            if (remoteSessionObj.projects[k].RemoteSessionsCompilations[j].id === compileFromQueueId) {
              uploadToBoardIndex = j;
              remoteCode = remoteSessionObj.projects[k].RemoteSessionsCompilations[j].jsonBody.canvasCode;
              remoteSessionObj.projects[k].RemoteSessionsCompilations[j].state = 'COMPILED';
              remoteSessionObj.projects[k].RemoteSessionsCompilations[j].notified = false;
              remoteSessionObj.projects[k].RemoteSessionsCompilations[j].running = true;
            } else if (remoteSessionObj.projects[k].RemoteSessionsCompilations[j].running) {
              remoteSessionObj.projects[k].RemoteSessionsCompilations[j].running = false;
            }
            oldUploadToBoard.push(remoteSessionObj.projects[k].RemoteSessionsCompilations[j]);
          }
        }
      }
      socket.compileRemoteSession(remoteCode, tabInfo.board).then((remoteHex) => {
        socket.uploadRemoteSession(remoteHex, tabInfo.board, selectedPort).then((response) => {
          if (response === 'OK') {
            putBulkRemoteSessionCompilation({ data: oldUploadToBoard });
            this.toastSend(
              <span className="body">
                <span className="icon icon-check-circle" />
                <span className="first-line">
                  ¡Código cargado!
                  <span className="second-line">El código fue cargado en la placa.</span>
                </span>
              </span>,
              'R',
              { className: 'code-uploaded' },
            );
          } else {
            // console.log('Uploading from remote error:::::::::');
            oldUploadToBoard[uploadToBoardIndex].state = 'ERROR';
            oldUploadToBoard[uploadToBoardIndex].notified = false;
            oldUploadToBoard[uploadToBoardIndex].running = false;
            putBulkRemoteSessionCompilation({ data: oldUploadToBoard });
            this.toastSend(
              <span className="body">
                <span className="icon icon-exclamation-solid" />
                <span className="first-line">
                  ¡ERROR en el código!
                  <span className="second-line">El código no se pudo cargar en la placa.</span>
                </span>
              </span>,
              'R',
              { className: 'error' },
            );
          }
        }).catch((error) => {
          console.log('Uploading from remote error:::::::::', error);
          oldUploadToBoard[uploadToBoardIndex].state = 'ERROR';
          oldUploadToBoard[uploadToBoardIndex].notified = false;
          oldUploadToBoard[uploadToBoardIndex].running = false;
          putBulkRemoteSessionCompilation({ data: oldUploadToBoard });
          this.toastSend(
            <span className="body">
              <span className="icon icon-exclamation-solid" />
              <span className="first-line">
                ¡ERROR en el código!
                <span className="second-line">El código no se pudo cargar en la placa.</span>
              </span>
            </span>,
            'R',
            { className: 'error' },
          );
        });
      }).catch((error) => {
        console.log('Compiling remotely error:::::::::', error, uploadToBoardIndex, oldUploadToBoard);
        oldUploadToBoard[uploadToBoardIndex].state = 'ERROR';
        oldUploadToBoard[uploadToBoardIndex].notified = false;
        oldUploadToBoard[uploadToBoardIndex].running = false;
        putBulkRemoteSessionCompilation({ data: oldUploadToBoard });
        this.toastSend(
          <span className="body">
            <span className="icon icon-exclamation-solid" />
            <span className="first-line">
              ¡ERROR en el código!
              <span className="second-line">El código no se pudo cargar en la placa.</span>
            </span>
          </span>,
          'R',
          { className: 'error' },
        );
      });
    } else if (remoteProjectId) {
      this.toastSend(
        <span className="body">
          <span className="icon icon-send" />
          <span className="first-line">
            ¡Enviando el código!
            <span className="second-line">Tu código se está compilando para ser enviado.</span>
          </span>
        </span>,
        'R',
        { className: 'code-sending' },
      );

      let oldUploadToBoard = [];
      let projectJsonBody = {};
      let userRole = '';
      let overWritten = false;
      let remoteSessionsProjectId = 0;
      let remoteSessionsCompilationId = 0;
      for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
        if (remoteSessionObj.projects[k].Project.id === remoteProjectId) {
          remoteSessionsProjectId = remoteSessionObj.projects[k].id;
          oldUploadToBoard = remoteSessionObj.projects[k].RemoteSessionsCompilations || [];
          for (let j = 0; j < oldUploadToBoard.length; j += 1) {
            if (oldUploadToBoard[j].userId === auth.userData.data.userId && oldUploadToBoard[j].state === 'PENDING') {
              overWritten = true;
              remoteSessionsCompilationId = oldUploadToBoard[j].id;
            }
          }
        }
        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          // projectJsonBody = remoteSessionObj.projects[k].Project.jsonBody || {};
          projectJsonBody = {
            canvas: remoteSessionObj.projects[k].Project.jsonBody.canvas,
            canvasBBoxWidth: remoteSessionObj.projects[k].Project.jsonBody.canvasBBoxWidth,
            canvasBBoxHeight: remoteSessionObj.projects[k].Project.jsonBody.canvasBBoxHeight,
            canvasBBoxX: remoteSessionObj.projects[k].Project.jsonBody.canvasBBoxX,
            canvasBBoxY: remoteSessionObj.projects[k].Project.jsonBody.canvasBBoxY,
            saveForm: {
              id: remoteSessionObj.projects[k].Project.id,
            },
          };
          projectJsonBody.canvasCode = codeToSend;
          userRole = remoteSessionObj.projects[k].settings.userRole || 'Alumno';
        }
      }
      // this.toastClear();
      if (overWritten) {
        putRemoteSessionCompilation(remoteSessionsCompilationId, {
          date: new Date(),
          state: 'PENDING',
          jsonBody: projectJsonBody,
        });
        this.toastSend(
          <span className="body">
            <span className="icon icon-code" />
            <span className="first-line">
              ¡Código actualizado!
              <span className="second-line">Tu código anterior fue reemplazado.</span>
            </span>
          </span>,
          'R',
          { className: 'code-replaced' },
        );
      } else {
        postRemoteSessionCompilation({
          remoteSessionsProjectId,
          userId: auth.userData.data.userId,
          userData: {
            userAvatarUrl: auth.userData.data.user.avatarUrl,
            userFullName: `${auth.userData.data.user.firstName} ${auth.userData.data.user.lastName}`,
            userRole,
          },
          date: new Date(),
          state: 'PENDING',
          jsonBody: projectJsonBody,
        });
        this.toastSend(
          <span className="body">
            <span className="icon icon-send" />
            <span className="first-line">
              ¡Código enviado!
              <span className="second-line">Tu código está en la lista de espera.</span>
            </span>
          </span>,
          'R',
          { className: 'code-sent' },
        );
      }
      // console.log('Compiling remotely:::::::::', newUploadToBoard);
    } else {
      bottomNav.progressbar = 0;
      this.setState({ bottomNav }, () => {
        if (tabInfo.className === 'microbit' && (!selectedPort || selectedPort === '')) connectionModalType = 1;
        else connectionModalType = 0;
        this.setState({ connectionModalType });
        $(`#connectionModal-${id}`).modal('show');
      });
      socket.uploadToPort(codeToSend, tabInfo.board, selectedPort);
    }
  }

  selectPortChange(portChanged) {
    const { tabInfo } = this.state;
    tabInfo.port = portChanged;
    this.setState({ tabInfo });
  }

  selectBoardChange(boardIndex) {
    const { tabInfo } = this.state;
    tabInfo.board = boardIndex || '';
    this.setState({ tabInfo });
  }

  endSteps() {
    sessionStorage.setItem('showToolTip', false);
    this.setState({ canShowStep: false });
  }

  startSteps() {
    sessionStorage.setItem('showToolTip', true);
    this.setState({ canShowStep: true });
  }

  shootMsg(msg) {
    const { id } = this.state;
    let ele = document.querySelector(`.blocklyPanel-${id} .shootMsg`);
    if (!ele) {
      ele = document.querySelector(`.codePanel-${id} .shootMsg`);
    }
    if (ele) {
      if (window.oldMessage !== msg) {
        ele.classList.remove('show');
        setTimeout(() => {
          window.oldMessage = msg;
          ele.innerHTML = msg;
          ele.classList.add('show');
        }, 200);
      }
    }
  }

  missingAgentStatus() {
    const { userAgent } = this.state;
    const { intl } = this.props;
    // console.log('============missingstatus', userAgent);

    window.electronPlugin = function () { axios.get('http://localhost:3001/agent').then((resp) => resp); };
    let message = intl.formatMessage({ id: 'blocks.blockly.soNotSupported' });

    if (process.env.IS_ELECTRON) {
      message = `${intl.formatMessage({ id: 'blocks.blockly.agentNotFoundElectron' })} <a class="agentDownloadLink" onclick="window.electronPlugin();" href="#">${intl.formatMessage({ id: 'blocks.blockly.agentNotFoundDownloadHere' })}</a>`;
    } else if (userAgent.platform) {
      message = `${intl.formatMessage({ id: 'blocks.blockly.agentNotFound' })} <a class="agentDownloadLink" href="${getAgentDownloadLink(userAgent)}">${intl.formatMessage({ id: 'blocks.blockly.agentNotFoundDownloadHere' })}</a>`;
    }
    // console.log('////////////////////////////////////////////////////////////////////////////////////', message);
    return message;
  }

  bottomNav() {
    const { actualWidth, saving, building, bottomNav, toolboxToggle, tabInfo, consoleGenerated, id, remoteSessionObj, socket } = this.state;
    const { auth, intl } = this.props;

    let statusText = intl.formatMessage({ id: 'blocks.blockly.ready' });
    if (saving) statusText = `${intl.formatMessage({ id: 'blocks.blockly.savingTab' })} ${tabInfo.name}`;
    if (building) statusText = `${intl.formatMessage({ id: 'blocks.blockly.buildingTabCode' })} ${tabInfo.name}`;
    if (bottomNav.arduinoAgentStatus === 'ERROR') statusText = intl.formatMessage({ id: 'blocks.blockly.boardNotConnected' });
    if (bottomNav.ebBuildStatus === 'ERROR') statusText = this.missingAgentStatus();
    this.shootMsg(statusText);

    let IAmTheOwner = false;
    for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
      if (remoteSessionObj.projects[k].userRole === 'OWNER') {
        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          IAmTheOwner = true;
        }
      }
    }

    const { darkthemeToggle } = this.state;

    return (!tabInfo.remoteSession
      || !tabInfo.remoteSessionStarted
      || IAmTheOwner) ? (
        <BottomNav horizontalLayout={(tabInfo.board.toolboxLayout === 'horizontal')} agentType={socket.agentType} buildingFunction={this.buildBlockly} consoleToggle={false} ebBuildStatus={bottomNav.ebBuildStatus} arduinoAgentStatus={bottomNav.arduinoAgentStatus} toolboxToggle={toolboxToggle}>
          <div className="content-consoleBox">
            <AceEditor
              mode="javascript"
              theme={darkthemeToggle ? 'dracula' : 'chrome'}
              value={`${consoleGenerated}

  `}
              name={`aceEditor-console-${id}`}
              width={`${actualWidth * 0.7}px`}
              height="250px"
              fontSize={16}
              readOnly={true}
              wrapEnabled={true}
              showPrintMargin={true}
              showGutter={false}
              highlightActiveLine={true}
              editorProps={{
                $blockScrolling: Infinity,
              }}
              setOptions={{
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                showPrintMargin: false,
                showLineNumbers: true,
              }}
              onLoad={this.refConsoleEditor}
            />
            {this.renderAdvanceSettings()}
          </div>
          <SerialMonitor
            id={id}
            port={tabInfo.port}
            socket={socket}
            onClose={this.closeSerialMonitor}
            portOpen={tabInfo.portOpen}
            board={tabInfo.board}
          />
        </BottomNav>
      ) : (
        ''
        // <div className="bottom-nav">
        //   <div className="visible-bar" />
        // </div>
      );
  }

  createPercentagePoints() {
    const points = [];

    for (let i = 0; i < 101; i += 1) {
      points.push(
        <span>{`${i}%`}</span>,
      );
    }

    return points;
  }

  toggleMicrobitModal(state = false) {
    let { microbitModalBuildFinished } = this.state;

    microbitModalBuildFinished = state;

    this.setState({ microbitModalBuildFinished });
  }

  webSerialModalChangeStep(step = 0) {
    const { webSerialModalState, tabInfo, userAgent, socket, intervalPorts } = this.state;
    const { intl } = this.props;

    webSerialModalState.step = step;
    this.setState({ webSerialModalState });
    if (step === 0) {
      this.setState({ microbitForceDownload: (process.env.IS_ELECTRON) });
    }
    this.setState({ webSerialModalState });
    if (step === 1 && socket.agentType !== 'serial' && socket.agentType !== 'usb' && socket.agentType !== 'esp') {
      // const newSocket = new Agent(store, tabInfo.board);
      // clearInterval(intervalPorts);
      // newSocket.disconnectSocket();
      // newSocket.setPlatform(userAgent.platform, 1);
      // this.setState({ socket: newSocket, intervalPorts: null });
      clearInterval(intervalPorts);
      this.setState({ intervalPorts: null });
      socket.forceAgent((tabInfo.board.compilerBoard === 'microbit') ? 'usb' : 'serial');
      setTimeout(() => {
        this.setState({ consoleGenerated: this.createConsoleString([`${intl.formatMessage({ id: 'blocks.blockly.platform' })}: ${userAgent.platform}`]) });
      }, 5000);
    }
  }

  webSerialModalChangeLink() {
    const { socket, webSerialModalState } = this.state;

    socket.connectNewBoard();
    webSerialModalState.connected = false;
    webSerialModalState.error = null;
    webSerialModalState.step = 3;
    this.setState({ webSerialModalState });
  }

  webSerialModalDownloadAgent() {
    const { socket, id, tabInfo, userAgent, intervalPorts } = this.state;

    if (socket) {
      clearInterval(intervalPorts);
      this.setState({ intervalPorts: null });
      socket.forceAgent('socket');

      // const newSocket = new Agent(store, tabInfo.board);
      // newSocket.disconnectSocket();
      // this.setState({ socket: newSocket });
    }
    const link = getAgentDownloadLink(userAgent);
    window.open(link, '_blank', 'noreferrer');
    $(`#webSerialModal-${id}`).modal('hide');
  }

  webSerialModalMicrobitForceDownload() {
    const { id, microbitTempBuild } = this.state;

    this.setState({ microbitForceDownload: true }, () => {
      this.buildBlockly(
        microbitTempBuild.compileFromQueueId,
        microbitTempBuild.remoteProjectId,
        microbitTempBuild.port,
      );
    });
    $(`#webSerialModal-${id}`).modal('hide');
  }

  webSerialModal() {
    const { id, userAgent, webSerialModalState, tabInfo } = this.state;
    const { intl } = this.props;

    const IS_CHROMEOS = (userAgent.platform?.toLowerCase() === 'chromeos' || userAgent.platform?.toLowerCase() === 'chrome os');

    return (
      <div className="modal fade webSerialModal" data-backdrop="static" data-keyboard="false" id={`webSerialModal-${id}`} tabIndex="-1" role="dialog" aria-labelledby={`webSerialModal-${id}-label`} aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id={`webSerialModal-${id}-label`}>
                {IS_CHROMEOS && webSerialModalState.step === 0 ? (
                  intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.title' })
                ) : ('')}
                {!IS_CHROMEOS && webSerialModalState.step === 0 ? (
                  intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.titleChrome' })
                ) : ('')}
                {webSerialModalState.step === 1 ? (
                  intl.formatMessage({ id: 'blocks.blockly.webserialModal.step1.title' })
                ) : ('')}
                {webSerialModalState.step === 2 ? (
                  intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.title' })
                ) : ('')}
                {webSerialModalState.step === 3 ? (
                  intl.formatMessage({ id: 'blocks.blockly.webserialModal.step3.title' })
                ) : ('')}
                {webSerialModalState.connected && webSerialModalState.step === 4 ? (
                  <>
                    <img src="/images/web_serial/check_circle.svg" width="24" alt="" />
                    {intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.title' })}
                  </>
                ) : ('')}
                {!webSerialModalState.connected && webSerialModalState.error && webSerialModalState.step === 4 ? (
                  <>
                    <img src="/images/web_serial/cancel.svg" width="24" alt="" />
                    {intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.titleError' })}
                  </>
                ) : ('')}
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div className="modal-body">
              {!IS_CHROMEOS && webSerialModalState.step === 0 && tabInfo.board.compilerBoard !== 'microbit' ? (
                <>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine1' })}</div>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine2' })}</div>
                </>
              ) : ('')}
              {!IS_CHROMEOS && webSerialModalState.step === 0 && tabInfo.board.compilerBoard === 'microbit' ? (
                <>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine1Microbit' })}</div>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine2Microbit' })}</div>
                </>
              ) : ('')}
              {IS_CHROMEOS && webSerialModalState.step === 0 ? (
                <>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine1Chrome' })}</div>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine2Chrome' })}</div>
                </>
              ) : ('')}
              {webSerialModalState.step === 1 && tabInfo.board.compilerBoard !== 'microbit' ? (
                <div className="step-one"><img src="/images/web_serial/webserial_1.gif" width="300" alt="" /></div>
              ) : ('')}
              {webSerialModalState.step === 1 && tabInfo.board.compilerBoard === 'microbit' ? (
                <div className="step-one"><img src="/images/web_serial/webserial_1_microbit.gif" width="300" alt="" /></div>
              ) : ('')}
              {webSerialModalState.step === 2 ? (
                <div className="two-columns">
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.messageLine1' }) }} />
                    <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.messageLine2' }) }} />
                    <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.messageLine3' }) }} />
                  </div>
                  <div>
                    <div>
                      {tabInfo.board.compilerBoard !== 'microbit' ? (
                        <img src="/images/web_serial/webserial_2.gif" width="348" alt="" />
                      ) : (
                        <img src="/images/web_serial/webserial_2_microbit.gif" width="348" alt="" />
                      )}
                    </div>
                  </div>
                </div>
              ) : ('')}
              {webSerialModalState.step === 3 ? (
                <div className="loading">
                  <div><img src="/images/web_serial/linking.png" width="80" alt="" /></div>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step3.messageLine1' })}</div>
                </div>
              ) : ('')}
              {!webSerialModalState.connected && webSerialModalState.error && webSerialModalState.step === 4 ? (
                <>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine1Error' })}</div>
                  <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine2Error' }) }} />
                </>
              ) : ('')}
              {webSerialModalState.connected && webSerialModalState.step === 4 ? (
                <div className="two-columns">
                  <div>
                    <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine1' })}</div>
                    <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine2' })}</div>
                  </div>
                  <div>
                    {tabInfo.board.compilerBoard !== 'microbit' ? (
                      <div><img src="/images/web_serial/webserial_3.png" width="348" alt="" /></div>
                    ) : (
                      <div><img src="/images/web_serial/webserial_3_microbit.png" width="348" alt="" /></div>
                    )}
                  </div>
                </div>
              ) : ('')}
            </div>
            <div className="modal-footer">
              {!IS_CHROMEOS && webSerialModalState.step === 0 ? (
                <>
                  {'serial' in navigator || 'usb' in navigator ? (
                    <button type="button" className="btn btn-secondary" onClick={() => this.webSerialModalChangeStep(webSerialModalState.step + 1)}>
                      {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.continueBrowser' })}
                    </button>
                  ) : ('')}
                  {tabInfo.board.compilerBoard === 'microbit' ? (
                    <button type="button" className="btn btn-primary main-btn" onClick={this.webSerialModalMicrobitForceDownload}>
                      {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.downloadFile' })}
                    </button>
                  ) : (
                    <button type="button" className="btn btn-primary main-btn" onClick={this.webSerialModalDownloadAgent}>
                      {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.downloadPlugin' })}
                    </button>
                  )}
                </>
              ) : ('')}
              {IS_CHROMEOS && webSerialModalState.step === 0 ? (
                <button type="button" className="btn btn-secondary" onClick={() => this.webSerialModalChangeStep(webSerialModalState.step + 1)}>
                  {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.continue' })}
                </button>
              ) : ('')}
              {webSerialModalState.step === 1 ? (
                <button type="button" className="btn btn-primary main-btn" onClick={() => this.webSerialModalChangeStep(webSerialModalState.step + 1)}>
                  {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.next' })}
                </button>
              ) : ('')}
              {webSerialModalState.step === 2 ? (
                <button type="button" className="btn btn-primary main-btn" onClick={this.webSerialModalChangeLink}>
                  {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.link' })}
                </button>
              ) : ('')}
              {!webSerialModalState.connected && webSerialModalState.error && webSerialModalState.step === 4 ? (
                <button type="button" className="btn btn-primary main-btn" onClick={this.webSerialModalChangeLink}>
                  {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.retry' })}
                </button>
              ) : ('')}
              {webSerialModalState.connected && webSerialModalState.step === 4 ? (
                <button type="button" className="btn btn-primary main-btn" data-dismiss="modal" aria-label="Close">
                  {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.ok' })}
                </button>
              ) : ('')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  connectionModal() {
    const { id, bottomNav, connectionModalType, microbitModalBuildFinished } = this.state;
    const { auth, intl } = this.props;
    const isLogged = (Object.entries(auth.userData).length > 0);

    /* eslint-disable */
    return (
      <div className="modal fade connectionModal short-modal" data-backdrop="static" data-keyboard="false" id={`connectionModal-${id}`} tabIndex="-1" role="dialog" aria-labelledby={`connectionModal-${id}-label`} aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id={`connectionmodal-${id}-label`}>
                {intl.formatMessage({ id: 'blocks.blockly.connectionModal.title' })}
              </h5>
            </div>
            <div className="modal-body">
              {(bottomNav.progressbar >= 0 && bottomNav.progressbar <= 100) && (
                <div className="radial-progress" data-progress={bottomNav.progressbar}>
                  <div className="circle">
                    <div className="mask full">
                      <div className="fill" />
                    </div>
                    <div className="mask half">
                      <div className="fill" />
                      <div className="fill fix" />
                    </div>
                    <div className="shadow" />
                  </div>
                  <div className="inset">
                    <div className="percentage">
                      <div className="numbers">
                        <span>-</span>
                        {this.createPercentagePoints()}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {(bottomNav.progressbar < 0) && (
                <div className="success no-background">
                  <svg id="crossAnimation" className="cross__svg" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 55 50">
                    <circle className="cross__circle" cx="26" cy="26" r="25" fill="none" />
                    <path className="cross__path cross__path--right" fill="none" d="M16,16 l20,20" />
                    <path className="cross__path cross__path--right" fill="none" d="M16,36 l20,-20" />
                  </svg>
                  <h4>{intl.formatMessage({ id: 'blocks.blockly.connectionModal.error' })}</h4>
                </div>
              )}
              {(bottomNav.progressbar > 100) && (
                <React.Fragment>
                  {connectionModalType === 0 ? (
                    <div className="success no-background">
                      <svg id="successAnimation" className="animated" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
                        <path id="successAnimationResult" fill="#212c4c" d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z" />
                        <circle id="successAnimationCircle" cx="35" cy="35" r="24" stroke="#979797" strokeWidth="2" strokeLinecap="round" fill="transparent" />
                        <polyline id="successAnimationCheck" stroke="#979797" strokeWidth="2" points="23 34 34 43 47 27" fill="transparent" />
                      </svg>
                      <h4 className="great-job">
                        {isLogged ? intl.formatMessage({ id: 'blocks.blockly.connectionModal.successUser' }, { user: auth.userData.data.name }) : intl.formatMessage({ id: 'blocks.blockly.connectionModal.success' })}
                      </h4>
                      <h4 className="correctly-loaded">{intl.formatMessage({ id: 'blocks.blockly.connectionModal.successMessage' })}</h4>
                    </div>
                  ) : (
                    <React.Fragment>
                      {!microbitModalBuildFinished ? (
                        <div className="success no-background">
                          <svg id="successAnimation" className="animated" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
                            <path id="successAnimationResult" fill="#212c4c" d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z" />
                            <circle id="successAnimationCircle" cx="35" cy="35" r="24" stroke="#979797" strokeWidth="2" strokeLinecap="round" fill="transparent" />
                            <polyline id="successAnimationCheck" stroke="#979797" strokeWidth="2" points="23 34 34 43 47 27" fill="transparent" />
                          </svg>
                          <h4 className="great-job">
                            {isLogged ? intl.formatMessage({ id: 'blocks.blockly.connectionModal.successUser' }, { user: auth.userData.data.name }) : intl.formatMessage({ id: 'blocks.blockly.connectionModal.success' })}
                          </h4>
                          <h4 className="correctly-loaded">{intl.formatMessage({ id: 'blocks.blockly.connectionModal.successMessage' })}</h4>
                        </div>
                      ) : (
                        <div className="transfer-animation">
                          <h4>{intl.formatMessage({ id: 'blocks.blockly.connectionModal.copyCode' })}</h4>
                          <div className="instructions-animation">
                            <div className="browser"></div>
                            <div className="file"></div>
                            <div className="explorer"></div>
                          </div>
                          <ButtonV2 onClick={() => { $(`#connectionModal-${id}`).modal('hide'); setTimeout(() => this.toggleMicrobitModal(false), 2000); }}>
                            {intl.formatMessage({ id: 'blocks.blockly.connectionModal.ok' })}
                          </ButtonV2>
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </div>
            <div className="modal-footer" />
          </div>
        </div>
      </div>
    );
    /* eslint-enable */
  }

  loaderOverAll() {
    const { loading } = this.state;
    return (
      <div className={`${(loading) ? 'show' : 'fade'} loaderOverAll `}>
        <div className="anibot-large-white" />
      </div>
    );
  }

  toastClear() {
    if (typeof window.toast === 'function') window.toast.dismiss();
  }

  toastSend(message, containerId = 'B', options = {}) {
    if (typeof window.toast === 'function') {
      if (containerId === 'R') {
        const toastOptions = {};
        toastOptions.position = 'bottom-center';
        toastOptions.className = `toast-remote ${(options.className) ? options.className : ''}`;
        toastOptions.autoClose = (typeof options.autoClose !== 'undefined') ? options.autoClose : 5000;
        // toastOptions.autoClose = false;
        toastOptions.hideProgressBar = true;
        toastOptions.containerId = 'B';
        window.toast(message, toastOptions);
      } else {
        window.toast(message, { containerId });
      }
    }
  }

  renderAdvanceSettings() {
    const { ports, id, tabInfo, boards, socket } = this.state;
    const { intl } = this.props;
    return (
      <div className="advanced-settings">
        <div className="row mt-2 ml-0 mr-0 text-center">
          <div className="col-12">
            <h5>{intl.formatMessage({ id: 'blocks.blockly.settings' })}</h5>
            <SelectBoards disabled={true} boards={boards} parentPanel="bloques" parentFunctionListener={this.selectBoardChange} id={`boards-${id}`} defaultBoard={tabInfo.board.id} />
            <SelectPorts parentFunctionListener={this.selectPortChange} id={`ports-${id}`} ports={ports} />
            {!process.env.IS_ELECTRON && (socket.agentType === 'serial' || socket.agentType === 'usb' || socket.agentType === 'esp') ? (
              <button type="button" className="btn btn-primary main-btn newBoard" onClick={socket.connectNewBoard}>
                {intl.formatMessage({ id: 'blocks.blockly.newBoard' })}
              </button>
            ) : ('')}
            <br />
          </div>
          <div className="col-12">
            <div>
              <span className="serialMonitorText">
                {intl.formatMessage({ id: 'blocks.blockly.showSerialMonitor' })}
              </span>
              <Switch onChange={this.toggleSerialMonitor} checked={tabInfo.portOpen} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  toggleCompilationQueueActiveModalTab() {
    const { remoteSessionObj } = this.state;
    remoteSessionObj.compilationActiveQueueModalTab = (remoteSessionObj.compilationActiveQueueModalTab === 0) ? 1 : 0;
    this.setState({ remoteSessionObj });
  }

  remoteSessionCompilationQueueReject(uploadToBoardIndex = null, remoteProjectId = null) {
    const { remoteSessionObj } = this.state;
    const { putRemoteSessionCompilation } = this.props;

    if (uploadToBoardIndex !== null) {
      let oldUploadToBoard = [];
      for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
        if (remoteSessionObj.projects[k].Project.id === remoteProjectId) {
          oldUploadToBoard = remoteSessionObj.projects[k].RemoteSessionsCompilations || [];
          for (let i = 0; i < oldUploadToBoard.length; i += 1) {
            if (oldUploadToBoard[i].id === uploadToBoardIndex) {
              oldUploadToBoard[i].state = 'REJECTED';
              oldUploadToBoard[i].notified = false;
              putRemoteSessionCompilation(oldUploadToBoard[i].id, oldUploadToBoard[i]);
            }
          }
        }
      }
    }
  }

  remoteSessionCompilationQueueShowCodeModal() {
    const { remoteSessionObj, boardType } = this.state;

    const jsonBody = remoteSessionObj.showCodeJsonBody;
    return (
      (typeof jsonBody !== 'undefined') ? (
        <div className="modal fade remoteSessionCompilationQueueCodeModal short-modal" id="remoteSessionCompilationQueueCodeModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="remoteSessionCompilationQueueCodeModal-label" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="remoteSessionCompilationQueueCodeModal-label">
                  {`Proyecto de ${jsonBody.userFullName}`}
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body">
                {(boardType === 'code') ? (
                  <div className="canvas-svg canvas-code">
                    <div className="actual-code scrolleable-block">
                      {jsonBody.code && jsonBody.code.split(/(?:\r\n|\r|\n)/g).map((item) => (
                        <div className="code-line">{(item === '') ? '\xa0' : item.replace(/\s/g, '\xa0')}</div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <CanvasSVG
                    content={`${remoteSessionObj.canvasCSS}${jsonBody.canvas}`}
                    svgX={jsonBody.canvasBBoxX || 10}
                    svgY={jsonBody.canvasBBoxY || 10}
                    svgWidth={jsonBody.canvasBBoxWidth || 800}
                    svgHeight={jsonBody.canvasBBoxHeight || 500}
                    width="90%"
                    height="90%"
                    backgroundColor="#0D1824"
                  />
                )}
              </div>
              {/* <div className="modal-footer" /> */}
            </div>
          </div>
        </div>
      ) : ('')
    );
  }

  remoteSessionCompilationQueueShowCode(uploadToBoardIndex = null, MyProjectIndex = null) {
    const { remoteSessionObj } = this.state;

    if (uploadToBoardIndex !== null && MyProjectIndex !== null) {
      const compilations = remoteSessionObj.projects[MyProjectIndex].RemoteSessionsCompilations;
      for (let i = 0; i < compilations.length; i += 1) {
        if (compilations[i].id === uploadToBoardIndex) {
          const jsonBody = compilations[i].jsonBody;
          jsonBody.userFullName = compilations[i].userData.userFullName;

          remoteSessionObj.showCodeJsonBody = jsonBody;
          this.setState({ remoteSessionObj }, () => {
            $('#remoteSessionCompilationQueueCodeModal').modal('show');
          });
        }
      }
    }
  }

  remoteSessionCompilationQueue() {
    const { remoteSessionObj, tabInfo } = this.state;
    const { auth } = this.props;

    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    let IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    let MyProjectId = 0;
    // let MyProjectIndex = 0;
    let OwnerProjectId = 0;
    let OwnerRemoteSessionProjectId = 0;
    let MyBoardAvailable = false;
    let OwnerBoardAvailable = false;
    let OwnerBoardList = [];
    const minBoardLength = 2;
    const uploadToBoardPending = [];
    const uploadToBoardCompiled = [];
    for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
      if (remoteSessionObj.projects[k].userRole === 'OWNER') {
        OwnerProjectId = remoteSessionObj.projects[k].projectId;
        OwnerRemoteSessionProjectId = remoteSessionObj.projects[k].id;
        if (remoteSessionObj.projects[k].settings.boardAvailabilityState === 'AVAILABLE'
          && remoteSessionObj.projects[k].Project.jsonBody.port !== '') {
          OwnerBoardAvailable = true;
          OwnerBoardList = remoteSessionObj.projects[k].Project.jsonBody.ports || [];
          if (OwnerBoardList.length > 1 && (!tabInfo.ownerPort || tabInfo.ownerPort === '' || !OwnerBoardList.includes(tabInfo.ownerPort))) {
            tabInfo.ownerPort = OwnerBoardList[0];
            // this.setState({ tabInfo });
          } else if (OwnerBoardList.length <= 1) {
            tabInfo.ownerPort = '';
            // this.setState({ tabInfo });
          }
        }
      }

      if (remoteSessionObj.projects[k].userRole === 'OWNER' || remoteSessionObj.projects[k].userRole === 'TEACHER' || remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
        if (remoteSessionObj.projects[k].RemoteSessionsCompilations && remoteSessionObj.projects[k].RemoteSessionsCompilations.length > 0) {
          const uploadToBoard = remoteSessionObj.projects[k].RemoteSessionsCompilations;
          for (let j = 0; j < uploadToBoard.length; j += 1) {
            if (!uploadToBoard[j].userData) {
              uploadToBoard[j].userData = {};
            }
            uploadToBoard[j].projectIndex = k;
            uploadToBoard[j].projectId = remoteSessionObj.projects[k].projectId;
            uploadToBoard[j].projectOwner = false;
            if (remoteSessionObj.projects[k].userRole === 'OWNER') {
              uploadToBoard[j].projectOwner = true;
            }

            if (uploadToBoard[j].state === 'PENDING') {
              uploadToBoardPending.push(uploadToBoard[j]);
            } else {
              uploadToBoardCompiled.push(uploadToBoard[j]);
            }
          }
        }
      }

      if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
        if (remoteSessionObj.projects[k].userRole === 'OWNER') {
          IAmTheTheacher = true;
        }
        MyProjectId = remoteSessionObj.projects[k].projectId;
        // MyProjectIndex = k;

        if (remoteSessionObj.projects[k].settings.boardAvailabilityState === 'AVAILABLE'
          && (remoteSessionObj.projects[k].Project.jsonBody.port !== '' || tabInfo.board.compilerBoard === 'microbit')) {
          MyBoardAvailable = true;
        }

        // if (remoteSessionObj.projects[k].RemoteSessionsCompilations && remoteSessionObj.projects[k].RemoteSessionsCompilations.length > 0) {
        //   const uploadToBoard = remoteSessionObj.projects[k].RemoteSessionsCompilations;
        //   for (let j = 0; j < uploadToBoard.length; j += 1) {
        //     if (!uploadToBoard[j].userData) {
        //       uploadToBoard[j].userData = {};
        //     }
        //     if (uploadToBoard[j].state === 'PENDING') {
        //       uploadToBoardPending.push(uploadToBoard[j]);
        //     } else {
        //       uploadToBoardCompiled.push(uploadToBoard[j]);
        //     }
        //   }
        // }
        // break;
      }
    }

    const compilationState = (state) => {
      let newState = 'Compilada';
      if (state === 'REJECTED') {
        newState = 'Rechazada';
      } else if (state === 'ERROR') {
        newState = 'Error';
      }
      return newState;
    };

    const selectOwnerPortChange = (portChanged) => {
      tabInfo.ownerPort = portChanged;
      this.setState({ tabInfo });
    };

    const compileToOwner = (remoteSessionsCompilationId, remoteSessionsProjectId, userData = null) => {
      const { putRemoteSessionCompilation } = this.props;

      const newBody = {
        remoteSessionsProjectId,
        state: 'PENDING',
        date: new Date(),
      };
      if (userData) {
        newBody.userData = userData;
        newBody.userData.port = tabInfo.ownerPort || '';
      }
      putRemoteSessionCompilation(remoteSessionsCompilationId, newBody);

      this.toastSend(
        <span className="body">
          <span className="icon icon-send" />
          <span className="first-line">
            ¡Código enviado!
            <span className="second-line">Tu código está en la lista de espera.</span>
          </span>
        </span>,
        'R',
        { className: 'code-sent' },
      );
    };

    const { darkthemeToggle } = this.state;

    return (
      (IAmTheTheacher && remoteSessionObj.teacher) ? (
        <div className="modal fade remoteSessionCompilationQueue short-modal" id="remoteSessionCompilationQueue" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="remoteSessionCompilationQueue-label" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="remoteSessionCompilationQueue-label">Habilitar la compilación remota</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-tabs">
                <div className={`create-tab ${(remoteSessionObj.compilationActiveQueueModalTab === 0) ? 'modal-tab-active' : ''}`} onClick={() => { this.toggleCompilationQueueActiveModalTab(); }} onKeyPress={() => { }}>
                  Pendientes
                </div>
                <div className={`create-tab ${(remoteSessionObj.compilationActiveQueueModalTab === 1) ? 'modal-tab-active' : ''}`} onClick={() => { this.toggleCompilationQueueActiveModalTab(); }} onKeyPress={() => { }}>
                  Finalizadas
                </div>
              </div>
              <div className="modal-body">
                <div className="scrolleable scroll-remote-session">
                  {(remoteSessionObj.compilationActiveQueueModalTab === 0) ? (
                    <>
                      {(uploadToBoardPending.length > 0) ? (
                        <div className="compilation-list">
                          {(OwnerBoardList.length > minBoardLength - 1) ? (
                            <div className="compilation-port">
                              <label htmlFor="ports-owner">
                                <span>Seleccionar puerto:</span>
                                <SelectPorts parentFunctionListener={selectOwnerPortChange} id="ports-owner" selected={tabInfo.ownerPort} ports={OwnerBoardList} />
                              </label>
                            </div>
                          ) : ('')}
                          {uploadToBoardPending.map((item) => (
                            <li key={`li-${item.date}`}>
                              <div className="avatar-img"><img alt="Avatar" className="avatar" src={item.userData.avatarUrl !== 'NULL' ? item.userData.avatarUrl : '/images/avatar_square_purple.png'} /></div>
                              <div className="name">
                                <div className="first-line">
                                  {item.userData.userFullName}
                                  <span className="second-line">{`Enviado: ${new Date(item.date).getDate()} de ${months[new Date(item.date).getMonth()]} ${new Date(item.date).getHours()}:${new Date(item.date).getMinutes()} Hs.`}</span>
                                </div>
                              </div>
                              <div className={`profile  ${(item.userRole === 'Docente') ? 'docente' : 'alumno'}`}>{item.userData.userRole}</div>
                              <div className="board">
                                <span className={tabInfo.board.class} />
                                {`Perfil ${tabInfo.board.name}`}
                              </div>
                              <div className="action-buttons">
                                {/* <span className="icon-code" onKeyPress={() => {}} onClick={() => this.remoteSessionCompilationQueueShowCode(item.id, MyProjectIndex)} /> */}
                                {/* <span className="icon-minus-circle" onKeyPress={() => {}} onClick={() => this.remoteSessionCompilationQueueReject(item.id, MyProjectId)} /> */}
                                {/* <span className={`icon-media-play ${(MyBoardAvailable) ? 'green' : ''}`} onKeyPress={() => {}} onClick={() => { if (MyBoardAvailable) { this.buildBlockly(item.id, MyProjectId); } }} /> */}
                                <span key="icon-code" className="icon-code" onKeyPress={() => { }} onClick={() => this.remoteSessionCompilationQueueShowCode(item.id, item.projectIndex)} />
                                <span key="icon-minus-circle" className="icon-minus-circle" onKeyPress={() => { }} onClick={() => this.remoteSessionCompilationQueueReject(item.id, item.projectId)} />
                                <span key="icon-media-play" className={`icon-media-play ${(MyBoardAvailable) ? 'green' : ''}`} onKeyPress={() => { }} onClick={() => { if (MyBoardAvailable) { this.buildBlockly(item.id, item.projectId); } }} />
                                {(MyProjectId !== OwnerProjectId) ? (
                                  <span className={`icon-media-play ${(OwnerBoardAvailable) ? 'lilac' : ''}`} onKeyPress={() => { }} onClick={() => { if (OwnerBoardAvailable) { compileToOwner(item.id, OwnerRemoteSessionProjectId, item.userData); } }} />
                                ) : ('')}
                              </div>
                            </li>
                          ))}
                        </div>
                      ) : (
                        <div className="no-projects">
                          <div className={darkthemeToggle ? 'no-projects-anibot-white' : 'no-projects-anibot'} />
                          <div className="no-projects-text">No hay solicitudes de compilación.</div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {(uploadToBoardCompiled.length > 0) ? (
                        <div className="compilation-list">
                          {(OwnerBoardList.length > minBoardLength - 1) ? (
                            <div className="compilation-port">
                              <label htmlFor="ports-owner">
                                <span>Seleccionar puerto:</span>
                                <SelectPorts parentFunctionListener={selectOwnerPortChange} id="ports-owner" selected={tabInfo.ownerPort} ports={OwnerBoardList} />
                              </label>
                            </div>
                          ) : ('')}
                          {uploadToBoardCompiled.map((item) => (
                            <li>
                              <div className="avatar-img"><img alt="Avatar" className="avatar" src={item.userData.avatarUrl !== 'NULL' ? item.userData.avatarUrl : '/images/avatar_square_purple.png'} /></div>
                              <div className="name">
                                <div className="first-line">
                                  {item.userData.userFullName}
                                  <span className="second-line">{`Enviado: ${new Date(item.date).getDate()} de ${months[new Date(item.date).getMonth()]} ${new Date(item.date).getHours()}:${new Date(item.date).getMinutes()} Hs.`}</span>
                                </div>
                              </div>
                              <div className={`profile  ${(item.userRole === 'Docente') ? 'docente' : 'alumno'}`}>{item.userData.userRole}</div>
                              <div className="board">
                                <span className={tabInfo.board.class} />
                                {`Perfil ${tabInfo.board.name}`}
                              </div>
                              <div className="profile">{compilationState(item.state)}</div>
                              <div className="action-buttons">
                                {/* <span className="icon-code" onKeyPress={() => {}} onClick={() => this.remoteSessionCompilationQueueShowCode(item.id, MyProjectIndex)} /> */}
                                {/* <span className={`icon-repeat ${(MyBoardAvailable) ? 'green' : ''}`} onKeyPress={() => {}} onClick={() => { if (MyBoardAvailable) { this.buildBlockly(item.id, MyProjectId); } }} /> */}
                                <span className="icon-code" onKeyPress={() => { }} onClick={() => this.remoteSessionCompilationQueueShowCode(item.id, item.projectIndex)} />
                                <span className={`icon-repeat ${(MyBoardAvailable) ? 'green' : ''}`} onKeyPress={() => { }} onClick={() => { if (MyBoardAvailable) { this.buildBlockly(item.id, item.projectId); } }} />
                                {(MyProjectId !== OwnerProjectId) ? (
                                  <span className={`icon-repeat ${(OwnerBoardAvailable) ? 'lilac' : ''}`} onKeyPress={() => { }} onClick={() => { if (OwnerBoardAvailable) { compileToOwner(item.id, OwnerRemoteSessionProjectId, item.userData); } }} />
                                ) : ('')}
                              </div>
                            </li>
                          ))}
                        </div>
                      ) : (
                        <div className="no-projects">
                          <div className={darkthemeToggle ? 'no-projects-anibot-white' : 'no-projects-anibot'} />
                          <div className="no-projects-text">No hay compilaciones.</div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="modal-footer" />
            </div>
          </div>
        </div>
      ) : ('')
    );
  }


  remoteSessionSetUserAsTeacher(remoteSession) {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate } = this.props;

    remoteSessionProjectUpdate(
      remoteSessionObj.id,
      remoteSession.Project.id,
      {
        userRole: (remoteSession.userRole === 'STUDENT') ? 'TEACHER' : 'STUDENT',
      },
    );
    this.toastSend(
      <span className="body">
        <span className="icon icon-bolt" />
        <span className="first-line">
          ¡Docente creado!
          <span className="second-line">{`${remoteSession.Project.User.firstName} ${remoteSession.Project.User.lastName} fue promovido a ${(remoteSession.userRole === 'STUDENT') ? 'Docente' : 'Alumno'}.`}</span>
        </span>
      </span>,
      'R',
      { className: 'code-uploaded', autoClose: true },
    );
  }

  remoteSessionSeeGamificationBadges(index) {
    const { remoteSessionObj } = this.state;

    remoteSessionObj.gamificationActiveQueueModalIndex = index;
    this.setState({ remoteSessionObj }, () => {
      $('#remoteSessionGamificationBadges').modal('show');
    });
  }

  remoteSessionGamificationBadges() {
    const { remoteSessionObj } = this.state;

    const gamification = [];
    if (remoteSessionObj.gamificationActiveQueueModalIndex > 0) {
      const keys = Object.keys(remoteSessionObj.projects[remoteSessionObj.gamificationActiveQueueModalIndex].settings.gamification);
      for (let i = 0; i < keys.length; i += 1) {
        gamification.push({
          name: keys[i],
          count: remoteSessionObj.projects[remoteSessionObj.gamificationActiveQueueModalIndex].settings.gamification[keys[i]].length,
        });
      }
    }

    return (
      (gamification) ? (
        <div className="modal fade remoteSessionGamificationBadges short-modal" id="remoteSessionGamificationBadges" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="remoteSessionGamificationBadges-label" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="remoteSessionGamificationBadges-label">Premios</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body">
                <div className="scrolleable scroll-remote-session">
                  {(gamification.length > 0) ? (
                    <div className="user-list">
                      {gamification.map((gadge) => (
                        <div className="avatar-div">
                          <img
                            alt="Avatar"
                            className="avatar"
                            src={`/images/badges/${remoteSessionObj.gaificationBadges[gadge.name].image}`}
                          />
                          <div className="first-line">
                            {remoteSessionObj.gaificationBadges[gadge.name].name}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : ('')}
                </div>
              </div>
              <div className="modal-footer" />
            </div>
          </div>
        </div>
      ) : ('')
    );
  }

  remoteSessionGamification() {
    const { remoteSessionObj } = this.state;
    const { auth, remoteSessionProjectUpdate } = this.props;

    const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);

    const usersList = [];
    for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
      if (remoteSessionObj.projects[k].Project.userId !== auth.userData.data.userId) {
        const userToAdd = {
          userData: {
            index: k,
            userId: remoteSessionObj.projects[k].Project.User.id,
            firstName: remoteSessionObj.projects[k].Project.User.firstName,
            lastName: remoteSessionObj.projects[k].Project.User.lastName,
            avatarUrl: (remoteSessionObj.projects[k].Project.User.avatarUrl) ? remoteSessionObj.projects[k].Project.User.avatarUrl : '/images/avatar_square_purple.png',
            userRole: (typeof remoteSessionObj.projects[k].settings.userRole !== 'undefined') ? remoteSessionObj.projects[k].settings.userRole : 'Alumno',
          },
        };
        if (remoteSessionObj.projects[k].settings.gamification) {
          userToAdd.gamification = remoteSessionObj.projects[k].settings.gamification;
        } else {
          userToAdd.gamification = {};
        }
        usersList.push(userToAdd);
      }
    }

    if (!remoteSessionObj.selectedBadge) {
      remoteSessionObj.selectedBadge = '6';
    }

    const mouseOverBadge = (e) => {
      e.target.src = `/images/badges/${remoteSessionObj.gaificationBadges[remoteSessionObj.selectedBadge].image}`;
      e.target.classList.add('hover');
    };
    const mouseOutBadge = (e, src) => {
      e.target.src = src;
      e.target.classList.remove('hover');
    };
    const giveBadge = (e, projectIndex) => {
      const theProject = remoteSessionObj.projects[projectIndex].Project;
      const currentSettings = remoteSessionObj.projects[projectIndex].settings;
      if (!currentSettings.gamification) {
        currentSettings.gamification = {};
      }
      if (!currentSettings.gamification[remoteSessionObj.selectedBadge]) {
        currentSettings.gamification[remoteSessionObj.selectedBadge] = [];
      }
      if (!currentSettings.gamification[remoteSessionObj.selectedBadge].includes(auth.userData.data.userId)) {
        currentSettings.gamification[remoteSessionObj.selectedBadge].push(auth.userData.data.userId);
        // console.log(currentSettings);
        remoteSessionProjectUpdate(
          remoteSessionObj.id,
          theProject.id,
          { settings: currentSettings },
        );
      }
    };

    const selectBadge = (badge) => {
      remoteSessionObj.selectedBadge = badge.toString();
      this.setState({ remoteSessionObj });
    };

    return (
      (IAmTheTheacher && remoteSessionObj.teacher) ? (
        <div className="modal fade remoteSessionGamification short-modal" id="remoteSessionGamification" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="remoteSessionGamification-label" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="remoteSessionGamification-label">Destacar a un alumno</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-tabs">
                <div className="button-bar">
                  {remoteSessionObj.gaificationBadges.map((badge, id) => (
                    <Tooltip title={badge.name} zIndex={200020}>
                      <span id={id} onClick={() => selectBadge(id)} className={`${badge.class} ${(remoteSessionObj.selectedBadge === id.toString()) ? 'selected' : ''}`} onKeyPress={() => { }} />
                    </Tooltip>
                  ))}
                </div>
              </div>
              <div className="modal-body">
                <div className="scrolleable scroll-remote-session">
                  {(usersList.length > 0) ? (
                    <div className="user-list">
                      {usersList.map((user) => (
                        <div className="avatar-div">
                          {(user.gamification[remoteSessionObj.selectedBadge]) ? (
                            <div className="badge">{user.gamification[remoteSessionObj.selectedBadge].length}</div>
                          ) : ('')}
                          <img
                            alt="Avatar"
                            className="avatar"
                            onMouseOut={(e) => mouseOutBadge(e, user.userData.avatarUrl !== 'NULL' ? user.userData.avatarUrl : '/images/avatar_square_purple.png')}
                            onMouseOver={mouseOverBadge}
                            onClick={(e) => {
                              if (!user.gamification[remoteSessionObj.selectedBadge] || (user.gamification[remoteSessionObj.selectedBadge] && !user.gamification[remoteSessionObj.selectedBadge].includes(auth.userData.data.userId))) {
                                giveBadge(e, user.userData.index);
                              }
                            }}
                            onKeyPress={() => { }}
                            onFocus={() => { }}
                            onBlur={() => { }}
                            src={user.userData.avatarUrl !== 'NULL' ? user.userData.avatarUrl : '/images/avatar_square_purple.png'}
                          />
                          <div className="first-line">
                            {`${user.userData.firstName} ${user.userData.lastName}`}
                            <span className="second-line">{`${user.userData.userRole}`}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="no-projects">
                      <div className="no-projects-anibot-white" />
                      <div className="no-projects-text">No hay alumnos.</div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer" />
            </div>
          </div>
        </div>
      ) : ('')
    );
  }


  changeRemotePassword(field, e) {
    const { saveForm } = this.state;
    saveForm[field] = e.target.value;
    this.setState({ saveForm });
  }

  executeChangeRemotePassword() {
    const { remoteSessionObj, saveForm } = this.state;
    const { putRemoteSession } = this.props;

    putRemoteSession(remoteSessionObj.id, { password: saveForm.password });
    this.saveProjectInDb(null, true);
  }

  remoteSessionTogglePrivate() {
    const { saveForm, remoteSessionObj } = this.state;

    if (saveForm.remoteSessionPrivate) {
      saveForm.remoteSessionPrivate = false;
      saveForm.password = '';
    } else {
      saveForm.remoteSessionPrivate = true;
      saveForm.password = remoteSessionObj.password;
    }
    this.setState({ saveForm });
  }

  remoteSessionInvitationModal(id) {
    const { saveForm } = this.state;

    return (
      <div className="modal fade remoteSessionInvitationModal short-modal" id="remoteSessionInvitationModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="remoteSessionInvitationModal-label" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="remoteSessionInvitationModal-label">Dirección de la sesión remota</h5>
            </div>
            <div className="modal-body">
              {/* <div>{`${routes.bloquesUri}/remote-${id}`}</div> */}
              <div className="form remote-session-modal">
                <div className="form-group bmd-form-group">
                  <input disabled={true} type="text" className="form-control is-dirty" id="url" value={id} />
                  <label htmlFor="url" className="bmd-label-floating">Dirección</label>
                </div>
                <div className={(!saveForm.remoteSessionPrivate) ? 'fade' : 'show'}>
                  <InputComponent form={saveForm} onEnterPress={() => { if (saveForm.password !== '') { this.executeChangeRemotePassword(); } }} changeField={this.changeRemotePassword} name="Contraseña" type="text" keyname="password" />
                </div>
                <div className="switchContainer">
                  <span className="privateSessionToggleLabel">Sesión privada</span>
                  <Switch onChange={this.remoteSessionTogglePrivate} onColor="#303f9f" checked={saveForm.remoteSessionPrivate} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="actionButtons">
                <ButtonV2 data-dismiss="modal">Cerrar</ButtonV2>
                <ButtonV2 idisabled={(saveForm.password === '' && saveForm.remoteSessionPrivate).toString()} onClick={() => this.executeChangeRemotePassword()}>Cambiar</ButtonV2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  handleEditCode() {
    const { projectsSaveAsCode } = this.props;

    const project = this.prepareProjectForSaving();
    project.tabInfo.boardType = boardTypes.CODE;
    project.tabInfo.code = project.tabInfo.canvasCode;
    const projectPost = {
      jsonBody: project.tabInfo,
      boardType: project.tabInfo.boardType,
      isCodeOnly: 1,
    };
    projectsSaveAsCode(project.saveForm.id, projectPost);
    $('#editCodeModal').modal('hide');
  }

  editCodeModal() {
    return (
      <div className="modal fade editCodeModal short-modal" id="editCodeModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="editCodeModal-label" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editCodeModal-label">¡Vas a pasar a edición de código!</h5>
            </div>
            <div className="modal-body">
              <p>Si continuas, no podrás volver a la vista de bloques del proyecto.</p>
              <p>¿Estás seguro que deseas continuar?</p>
            </div>
            <div className="modal-footer">
              <div className="actionButtons">
                <ButtonV2 className="cancelButton" data-dismiss="modal">Cancelar</ButtonV2>
                <ButtonV2 className="acceptButton" onClick={this.handleEditCode}>Aceptar</ButtonV2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  remoteToggleChronometer(show) {
    if (document.querySelector('.chronometer-box')) {
      const ele = document.querySelector('.chronometer-box');
      if (!show && ele.classList.contains('isActive')) {
        ele.classList.remove('isActive');
        ele.removeAttribute('style');
        ele.removeAttribute('data-x');
        ele.removeAttribute('data-y');
      }
      if (show && !ele.classList.contains('isActive')) {
        ele.classList.add('isActive');
      }
    }
  }

  remoteToggleChronometerAll() {
    // const { remoteSessionObj } = this.state;
    // const { remoteSessionProjectUpdate } = this.props;

    const ele = document.querySelector('.chronometer-box');
    let show = true;
    if (ele.classList.contains('isActive')) {
      ele.classList.remove('isActive');
      ele.removeAttribute('style');
      ele.removeAttribute('data-x');
      ele.removeAttribute('data-y');
      show = false;
    } else {
      ele.classList.add('isActive');
      show = true;
    }

    this.remoteSessionChronometerUpdate({ show });
    // const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
    // if (!currentSettings.chronometer) {
    //   currentSettings.chronometer = {};
    // }
    // currentSettings.chronometer.display = show;
    // remoteSessionProjectUpdate(
    //   remoteSessionObj.id,
    //   remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
    //   {
    //     settings: currentSettings,
    //   },
    // );
  }


  remoteSessionChronometerUpdate(data) {
    const { remoteSessionObj } = this.state;
    const { remoteSessionProjectUpdate, auth } = this.props;

    // const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    let currentSettings = {};
    let IAmTheOwner = false;
    let OwnerProjectId = 0;
    for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
      if (remoteSessionObj.projects[k].userRole === 'OWNER') {
        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          IAmTheOwner = true;
        }
        OwnerProjectId = remoteSessionObj.projects[k].Project.id;
        currentSettings = remoteSessionObj.projects[k].settings;
      }
    }
    if (IAmTheOwner && OwnerProjectId) {
      // if (remoteSessionObj.teacher && IAmTheTheacher) {
      // const currentSettings = remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings;
      if (!currentSettings.chronometer) {
        currentSettings.chronometer = {};
      }

      if (typeof data.show !== 'undefined') {
        currentSettings.chronometer.display = data.show;
      }
      if (typeof data.startTime !== 'undefined') {
        currentSettings.chronometer.startTime = data.startTime;
      }
      if (typeof data.stopTime !== 'undefined') {
        currentSettings.chronometer.stopTime = data.stopTime;
      }
      if (typeof data.laps !== 'undefined') {
        currentSettings.chronometer.laps = data.laps;
      }
      if (typeof data.running !== 'undefined') {
        currentSettings.chronometer.running = data.running;
      }

      remoteSessionProjectUpdate(
        remoteSessionObj.id,
        OwnerProjectId,
        // remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId,
        {
          settings: currentSettings,
        },
      );
    }
  }

  remoteSessionChronometer() {
    const { remoteSessionObj } = this.state;
    const { auth } = this.props;

    let currentSettings = {};
    let IAmTheOwner = false;
    // const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
      if (remoteSessionObj.projects[k].userRole === 'OWNER') {
        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          IAmTheOwner = true;
        }
        currentSettings = remoteSessionObj.projects[k].settings;
      }
    }
    // const currentSettings = (remoteSessionObj.teacher) ? remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].settings : {};

    const onStart = (now) => {
      this.remoteSessionChronometerUpdate({ startTime: now, stopTime: 0, running: true });
    };
    const onStop = (now) => {
      this.remoteSessionChronometerUpdate({ stopTime: now, running: false });
    };
    const onLap = (laps) => {
      this.remoteSessionChronometerUpdate({ laps });
    };
    const onReset = () => {
      this.remoteSessionChronometerUpdate({ laps: [], startTime: 0, stopTime: 0, running: false });
    };

    let running = false;
    let startTime = null;
    let stopTime = 0;
    let laps = null;
    if (currentSettings && currentSettings.chronometer) {
      stopTime = (typeof currentSettings.chronometer.stopTime !== 'undefined') ? currentSettings.chronometer.stopTime : null;
      startTime = (currentSettings.chronometer.startTime !== null) ? currentSettings.chronometer.startTime : null;
      laps = (currentSettings.chronometer.laps) ? currentSettings.chronometer.laps : null;
      running = (currentSettings.chronometer.running) ? currentSettings.chronometer.running : false;
    }


    return (
      <div id="remoteChronometerBox" className="chronometer-box">
        <div className="button-bar">
          <div className="title-bar">Cronómetro</div>
          {IAmTheOwner ? (
            <span className="icon-cancel" onKeyPress={() => { }} onClick={() => this.remoteToggleChronometerAll()} />
          ) : ('')}
        </div>
        <div className="stopwatch">
          <StopWatch
            startTime={startTime}
            stopTime={stopTime}
            laps={laps}
            stopRunning={(!IAmTheOwner) ? !running : null}
            showButtonBar={(IAmTheOwner)}
            onStart={(IAmTheOwner) ? onStart : null}
            onStop={(IAmTheOwner) ? onStop : null}
            onLap={(IAmTheOwner) ? onLap : null}
            onReset={(IAmTheOwner) ? onReset : null}
          // stopRunning={(!IAmTheTheacher && !IAmTheOwner) ? !running : null}
          // showButtonBar={(IAmTheTheacher || IAmTheOwner)}
          // onStart={(IAmTheTheacher || IAmTheOwner) ? onStart : null}
          // onStop={(IAmTheTheacher || IAmTheOwner) ? onStop : null}
          // onLap={(IAmTheTheacher || IAmTheOwner) ? onLap : null}
          // onReset={(IAmTheTheacher || IAmTheOwner) ? onReset : null}
          />
        </div>
      </div>
    );
  }

  remoteSessionLogin() {
    const { saveForm, remoteSessionObj, tabInfo } = this.state;
    const { remoteSessionLoginGet } = this.props;

    return (typeof saveForm.remoteSessionLogged !== 'undefined') ? (
      <div className={`${(!saveForm.remoteSessionLogged) ? 'show' : 'fade'} loaderOverAll`}>
        <div className="screen-bloqued-login">
          <span className="icon-desktop_access_disabled" />
          <span className="first-line">
            Esta sesión es privada.
            <span className="second-line">Escribe la contraseña en el campo de abajo y presiona ENTER.</span>
            <span className="second-line error">{tabInfo.errorMsg}</span>
            <span className="second-line">
              <InputComponent onEnterPress={() => remoteSessionLoginGet(remoteSessionObj.id, saveForm.password)} changeField={this.changeField} form={saveForm} name="Contraseña" type="password" keyname="password" />
            </span>
          </span>
        </div>
      </div>
    ) : ('');
  }

  remoteSessionScreenBlocked(state) {
    return (
      <div className={`${(state) ? 'show' : 'fade'} loaderOverAll`}>
        <div className="screen-bloqued-msg">
          <span className="icon-desktop_access_disabled" />
          <span className="first-line">
            El docente activó el bloqueo de pantalla.
            <span className="second-line">Debes esperar a que el docente vuelva a activarla.</span>
          </span>
        </div>
      </div>
    );
  }

  remoteSessionDeleteAllModal() {
    const { remoteSessionObj } = this.state;

    return (
      <div className="modal fade remoteSessionDeleteAllModal short-modal" id="remoteSessionDeleteAllModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="remoteSessionDeleteAllModal-label" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              {(remoteSessionObj.deleteProjectId) ? (
                <h5 className="modal-title" id="remoteSessionDeleteAllModal-label">
                  {`Eliminar el proyecto de ${remoteSessionObj.deleteProjectUserName}`}
                </h5>
              ) : (
                <h5 className="modal-title" id="remoteSessionDeleteAllModal-label">Eliminar a todos los usuarios remotos</h5>
              )}
            </div>
            <div className="modal-body">
              <div>Esta acción borrará sus avances individuales en el proyecto.</div>
              {(remoteSessionObj.deleteProjectId) ? (
                <div className="actionButtons">
                  <button type="button" onKeyPress={() => { }} onClick={this.remoteSessionDeleteOneModalAccept} className="btn btn-primary main-btn" data-dismiss="modal"><span className="text">Aceptar</span></button>
                  <button type="button" onKeyPress={() => { }} onClick={this.remoteSessionDeleteOneModalCancel} className="btn btn-secondary" data-dismiss="modal"><span className="text">Cancelar</span></button>
                </div>
              ) : (
                <div className="actionButtons">
                  <button type="button" onKeyPress={() => { }} onClick={this.remoteSessionDeleteAllModalAccept} className="btn btn-primary main-btn" data-dismiss="modal"><span className="text">Aceptar</span></button>
                  <button type="button" className="btn btn-secondary" data-dismiss="modal"><span className="text">Cancelar</span></button>
                </div>
              )}
            </div>
            <div className="modal-footer" />
          </div>
        </div>
      </div>
    );
  }

  remoteSessionDeleteAllModalAccept() {
    const { remoteSessionObj } = this.state;
    const { auth, remoteSessionProjectDelete } = this.props;

    const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    if (IAmTheTheacher) {
      remoteSessionProjectDelete(remoteSessionObj.id);
    }
  }

  remoteSessionDeleteOneModalAccept() {
    const { remoteSessionObj } = this.state;
    const { auth, remoteSessionProjectDeleteOne } = this.props;

    const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    if (IAmTheTheacher) {
      // console.log('deleting: ', remoteSessionObj.deleteProjectId);
      remoteSessionProjectDeleteOne(remoteSessionObj.id, remoteSessionObj.deleteProjectId);
    }

    remoteSessionObj.deleteProjectId = 0;
    remoteSessionObj.deleteProjectUserName = '';
    this.setState({ remoteSessionObj });
  }

  remoteSessionDeleteOneModalCancel() {
    const { remoteSessionObj } = this.state;

    remoteSessionObj.deleteProjectId = 0;
    remoteSessionObj.deleteProjectUserName = '';
    this.setState({ remoteSessionObj });
  }

  remoteSessionDeleteOneModal(id, name) {
    const { remoteSessionObj } = this.state;
    const { auth } = this.props;

    const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    if (IAmTheTheacher) {
      remoteSessionObj.deleteProjectId = id;
      remoteSessionObj.deleteProjectUserName = name;
      this.setState({ remoteSessionObj }, () => {
        $('#remoteSessionDeleteAllModal').modal('show');
      });
    }
  }


  launchDroneSimulation() {
    const { codeGenerated } = this.state;

    const mission = eval(codeGenerated); /* eslint-disable-line */
    const commands = mission.split('|');
    let land = false;
    for (let i = 0; i < commands.length; i += 1) {
      commands[i] = commands[i].replace(/!/, '?');
      if (commands[i] === 'land') {
        land = true;
      }
    }
    if (!land) {
      commands.push('land');
    }

    window.commands = commands;
    console.log('CODE:', commands, codeGenerated);
  }

  resetDroneSimulation() {
    window.commands = ['reset'];
  }

  fullScreenDroneSimulation() {
    const { id } = this.state;

    const elem = document.getElementById(`droneArea-${id}`);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  toggleGridDroneSimulation() {
    const ele = document.querySelector('#toggleGrid-icon');
    if (window.toggle === undefined || window.toggle === true) {
      window.toggle = false;
      ele.classList.remove('icon-view-show');
      ele.classList.add('icon-view-hide');
    } else {
      window.toggle = true;
      ele.classList.remove('icon-view-hide');
      ele.classList.add('icon-view-show');
    }
  }

  saveCode(newCode) {
    let { code } = this.state;
    const { id, tabInfo } = this.state;

    code = newCode;
    tabInfo.code = newCode;

    const code2Save = {};
    code2Save[id] = {
      tabInfo,
    };
    sessionStorage.setItem('EduCodeGenerated', JSON.stringify(code2Save));

    this.setState({ code });
  }


  assignmentSessionDeliverActivity() {
    const { saveForm, tabInfo, assignmentSessionObj } = this.state;
    const { assignmentSessionProjectUpdate } = this.props;
    let settings = {};
    for (let i = 0; i < assignmentSessionObj.AssignmentSessionsProjects.length; i += 1) {
      if (assignmentSessionObj.AssignmentSessionsProjects[i].projectId === saveForm.id) {
        settings = assignmentSessionObj.AssignmentSessionsProjects[i].settings || {};
      }
    }
    settings.delivered = new Date();
    this.saveProjectInDb(null, true);
    assignmentSessionProjectUpdate(tabInfo.assignmentSession, saveForm.id, { settings });
    $('#assignmentSessionDeliver').modal('hide');
  }

  assignmentSessionDeliver() {
    return (
      <div className="modal fade assignmentSessionDeliver short-modal" id="assignmentSessionDeliver" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="assignmentSessionDeliver-label" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="assignmentSessionDeliver-label">¡Estás por entregar tu tarea!</h5>
            </div>
            <div className="modal-body">
              <div>
                Recordá que una vez entregada, no podrás modificarla ni guardar cambios futuros en este proyecto.
              </div>
              <div className="actionButtons">
                <button type="button" className="btn btn-secondary" data-dismiss="modal"><span className="text">Volver</span></button>
                <ButtonV2 onClick={() => this.assignmentSessionDeliverActivity()}>Entregar</ButtonV2>
              </div>
            </div>
            <div className="modal-footer" />
          </div>
        </div>
      </div>
    );
  }


  render() {
    const {
      code, assignmentSessionObj, remoteSessionObj, remoteThumbsToggle, drone, isLogged, actualWidth,
      darkthemeToggle, blocklyInited, canShowStep, id, className, codeToggle, droneSimulationToggle,
      codeGenerated, tabInfo, rightPanel, toolboxToggle, boardType, codit, demoWorkspace,
      arduinoSimulatorToggle, saveForm,
    } = this.state;
    const { bloques, auth, getAssignmentDeliverableState, intl } = this.props;
    let steps;
    if (boardType === 'junior' && tabInfo.board.toolboxLayout === 'horizontal') {
      steps = [
        {
          element: '.bottom-nav-horizontal button',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.juniorHorizontal.step0' }),
          position: 'top',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
          hintAnimation: true,
        },
        {
          element: '.curly-braces',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.juniorHorizontal.step1' }),
          position: 'left',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
      ];
    } else if (boardType === 'junior') {
      steps = [
        {
          element: '.blocklyToolboxDiv',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.junior.step0' }),
          position: 'right',
          tooltipClass: 'myTooltipClass firstToolTip',
          highlightClass: 'myHighlightClass',
          hintAnimation: true,
        },
        {
          element: `.blocklyPanel-${id} .bottom-nav`,
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.junior.step1' }),
          position: 'top',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
        {
          element: '.curly-braces',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.junior.step2' }),
          position: 'left',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
      ];
    } else if (boardType === 'code') {
      steps = [
        {
          element: `.codePanel-${id} .bottom-nav`,
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.code.step0' }),
          position: 'top',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
        {
          element: '.addTabBtn',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.code.step1' }),
          position: 'bottom',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
      ];
    } else {
      steps = [
        {
          element: `.blocklyPanel-${id} .blocklyToolboxDiv`,
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.senior.step0' }),
          position: 'right',
          tooltipClass: 'myTooltipClass firstToolTip',
          highlightClass: 'myHighlightClass',
          hintAnimation: true,
        },
        {
          element: `.blocklyPanel-${id} .bottom-nav`,
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.senior.step1' }),
          position: 'top',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
        {
          element: '.addTabBtn',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.senior.step2' }),
          position: 'bottom',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
        {
          element: '.curly-braces',
          intro: intl.formatMessage({ id: 'blocks.blockly.tutorial.senior.step3' }),
          position: 'left',
          tooltipClass: 'myTooltipClass',
          highlightClass: 'myHighlightClass',
        },
      ];
    }

    const options = {
      nextLabel: intl.formatMessage({ id: 'blocks.blockly.tutorial.next' }),
      prevLabel: intl.formatMessage({ id: 'blocks.blockly.tutorial.previous' }),
      skipLabel: intl.formatMessage({ id: 'blocks.blockly.tutorial.skip' }),
      doneLabel: intl.formatMessage({ id: 'blocks.blockly.tutorial.finish' }),
      hideNext: true,
      hidePrev: true,
    };

    let IAmTheOwner = false;
    let OwnerProjectId = 0;
    let OwnerProjectIndex = null;
    const IAmTheTheacher = (remoteSessionObj.teacher && remoteSessionObj.teacher.userId === auth.userData.data.userId);
    const TheacherProjectId = (remoteSessionObj.teacher) ? remoteSessionObj.projects[remoteSessionObj.teacher.projectIndex].projectId : 0;
    const MyBoardConnected = (tabInfo.port !== '' || tabInfo.board.compilerBoard === 'microbit');
    const ScreenBlocked = (remoteSessionObj.teacher && !IAmTheTheacher && remoteSessionObj.teacher.settings.screenBlocked);
    const TeacherScreenMaximized = (remoteSessionObj.teacher && !IAmTheTheacher && remoteSessionObj.teacher.settings.teacherScreenMaximized);

    let MyProjectId = 0;
    let MyBoardAvailable = false;
    let OwnerBoardAvailable = false;
    let TeacherBoardAvailable = false;
    const compilationRequests = [];
    let uploadToBoard;
    for (let k = 0; k < remoteSessionObj.projects.length; k += 1) {
      if (remoteSessionObj.projects[k].userRole === 'OWNER') {
        if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
          IAmTheOwner = true;
        }
        OwnerProjectId = remoteSessionObj.projects[k].Project.id;
        OwnerProjectIndex = k;
        if (remoteSessionObj.projects[k].settings.boardAvailabilityState === 'AVAILABLE'
          && (remoteSessionObj.projects[k].Project.jsonBody.port !== '' || tabInfo.board.compilerBoard === 'microbit')
        ) {
          OwnerBoardAvailable = true;
        }
      } else if (remoteSessionObj.projects[k].userRole === 'TEACHER') {
        if (remoteSessionObj.projects[k].settings.boardAvailabilityState === 'AVAILABLE'
          && (remoteSessionObj.projects[k].Project.jsonBody.port !== '' || tabInfo.board.compilerBoard === 'microbit')
        ) {
          TeacherBoardAvailable = true;
        }
      }

      if (remoteSessionObj.projects[k].Project.userId === auth.userData.data.userId) {
        MyProjectId = remoteSessionObj.projects[k].projectId;

        if ((remoteSessionObj.teacher.settings.boardAvailability || IAmTheTheacher)
          && remoteSessionObj.projects[k].settings.boardAvailabilityState === 'AVAILABLE'
          && (remoteSessionObj.projects[k].Project.jsonBody.port !== '' || tabInfo.board.compilerBoard === 'microbit')
        ) {
          MyBoardAvailable = true;
        }

        if (remoteSessionObj.projects[k].RemoteSessionsCompilations && remoteSessionObj.projects[k].RemoteSessionsCompilations.length > 0) {
          uploadToBoard = remoteSessionObj.projects[k].RemoteSessionsCompilations;
          for (let j = 0; j < uploadToBoard.length; j += 1) {
            if (uploadToBoard[j].state === 'PENDING') {
              compilationRequests.push({ projectId: uploadToBoard[j].jsonBody.saveForm.id, id: uploadToBoard[j].id });
            }
          }
        }
      }
    }

    let IAmTheActivityOwner = false;
    if (assignmentSessionObj.AssignmentSessionsProjects) {
      for (let k = 0; k < assignmentSessionObj.AssignmentSessionsProjects.length; k += 1) {
        if (assignmentSessionObj.AssignmentSessionsProjects[k].userRole === 'OWNER' || !(auth.userData.data.roles.names.includes('Alumno') || auth.userData.data.roles.names.includes('Invitado'))) {
          if (assignmentSessionObj.AssignmentSessionsProjects[k].Project && assignmentSessionObj.AssignmentSessionsProjects[k].Project.userId === auth.userData.data.userId) {
            IAmTheActivityOwner = true;
          }
        }
      }
    }

    // console.log('<<<<<<<<<<<<<<', TheacherProjectId, OwnerBoardAvailable, tabInfo.board.compilerBoard, '>>>>>>>>>>>>>>>>>>');

    const youTubeIframe = function (youtubeVideoContent = {}) {
      const getProviderIframe = (rawUrl) => {
        let providerIframe = '';
        if (typeof rawUrl.url !== 'undefined') {
          if (rawUrl.provider && rawUrl.provider === 'vimeo_events') {
            providerIframe = `<iframe src="https://vimeo.com/event/${rawUrl.url}?autoplay=1&controls=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
          } else if (rawUrl.provider && rawUrl.provider === 'vimeo') {
            providerIframe = `<iframe src="https://player.vimeo.com/video/${rawUrl.url}?autoplay=1&controls=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
          } else {
            providerIframe = `<iframe src="https://www.youtube.com/embed/${rawUrl.url}?controls=1&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
          }
        }
        return providerIframe;
      };

      return {
        __html: getProviderIframe(youtubeVideoContent),
      };
    };

    return (
      <div className={`${(darkthemeToggle) ? 'darkTheme' : ''} BlocklyPanelFull ${(!isLogged) ? 'needLogIn' : ''}`}>
        {(tabInfo.active && tabInfo.assignmentSession && getAssignmentDeliverableState && !IAmTheActivityOwner && tabInfo.userId === auth.userData.data.userId) ? (
          <>
            {this.assignmentSessionDeliver()}
            <button
              type="button"
              id="submit-assignment"
              className="btn btn-primary main-btn"
              onClick={() => $('#assignmentSessionDeliver').modal('show')}
            >
              Entregar
            </button>
          </>
        ) : ('')}
        {(tabInfo.active && tabInfo.remoteSession && remoteSessionObj.id) ? (
          <div id="remoteJitsiBox" className="jitsi-box">
            <div className="anibot-large-white contain" />
            <div className="button-bar">
              <div className="title-bar">Conectados</div>
              <span className="icon-max-min icon-fullscreen_exit" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleJitsiMinMax()} />
              {IAmTheTheacher ? (
                <span className="icon-cancel" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleJitsiAll()} />
              ) : ('')}
            </div>
          </div>
        ) : ('')}
        {(tabInfo.active && !tabInfo.disabled) ? (
          <RightPanel panelDimensions={rightPanel.panelDimensions} status={rightPanel.status}>
            {rightPanel.children}
          </RightPanel>
        ) : ('')}
        <div id="BlocklyPanel-Container" className={`BlocklyPanel ${(boardType === 'junior') ? 'BlocklyJRPanel' : ''} ${className}${tabInfo.board.class}-panel`}>
          <div className="container-fluid">
            {this.remoteSessionChronometer()}
            {this.remoteSessionLogin()}
            {this.remoteSessionScreenBlocked(ScreenBlocked)}
            {this.remoteSessionDeleteAllModal()}
            {this.remoteSessionInvitationModal(remoteSessionObj.id)}
            {this.editCodeModal()}
            {this.remoteSessionCompilationQueue()}
            {this.remoteSessionCompilationQueueShowCodeModal()}
            {this.remoteSessionGamification()}
            {this.remoteSessionGamificationBadges()}
            <div className={`p-relative row overflow-hidden ${(boardType === 'code') ? 'codePanel' : 'blocklyPanel'}-${id}`}>
              {(boardType === 'code') ? (
                <div className="content-codeBox-blockly">
                  <AceEditor
                    mode="c_cpp"
                    theme={darkthemeToggle ? 'dracula' : 'chrome'}
                    value={code}
                    name={`aceEditor-blockly-instance-${id}`}
                    onChange={this.saveCode}
                    width={`${window.innerWidth}px`}
                    height={`${window.innerHeight - 128}px`}
                    fontSize={16}
                    readOnly={false}
                    showPrintMargin={true}
                    showGutter={true}
                    highlightActiveLine={true}
                    editorProps={{
                      $blockScrolling: Infinity,
                    }}
                    setOptions={{
                      enableBasicAutocompletion: true,
                      enableLiveAutocompletion: true,
                      enableSnippets: true,
                      showPrintMargin: false,
                      showLineNumbers: true,
                    }}
                  />
                </div>
              ) : (
                <div id="blocklyPanel-Right" className="col-12 p-0 blocklyPanel">
                  <div className="blocklyDiv" id={id} />
                  <xml id={`toolbox-${id}`}>
                    {this.getProfile(tabInfo.board.profile).categoryXml}
                  </xml>
                  <div className="blocklyWidgetDiv" />
                  <div className="blocklyDropDownDiv">
                    <div className="blocklyDropDownContent" />
                    <div className="blocklyDropDownArrow" />
                  </div>
                  <div className="blocklyToolxmltipDiv" />
                </div>
              )}
              {tabInfo.active ? (
                <>
                  {/* {(boardType !== 'code' && boardType !== 'junior') ? ( */}
                  {(boardType !== 'code') ? (
                    <div className={`col-12 p-0 codeBox ${(codeToggle) ? 'codeBox-active' : ''}`}>
                      <div className="content-codeBox">
                        <AceEditor
                          mode="c_cpp"
                          theme={darkthemeToggle ? 'dracula' : 'chrome'}
                          value={codeGenerated}
                          name={`aceEditor-${id}`}
                          width={`${(actualWidth / 10) * 2.5}px`}
                          height={`${window.innerHeight - 100}px`}
                          fontSize={14}
                          readOnly={true}
                          wrapEnabled={true}
                          showGutter={false}
                          showPrintMargin={true}
                          highlightActiveLine={true}
                          editorProps={{
                            $blockScrolling: Infinity,
                          }}
                          setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showPrintMargin: false,
                            showLineNumbers: true,
                          }}
                        />
                      </div>
                      <div className="toggle-codeBox" onKeyPress={() => { }} role="button" tabIndex="0" onClick={this.codeToggleAction}>
                        <span className="curly-braces">{'{ }'}</span>
                        <span className={`icon-chevron-left ${(codeToggle) ? 'rotate-arrow' : ''}`} />
                      </div>
                      {(codeToggle && boardType !== 'junior' && tabInfo.projectId && tabInfo.board.enabledForCode && !tabInfo.remoteProject) ? (
                        <div className="toggle-codeEditing" onKeyPress={() => { }} role="button" tabIndex="0" onClick={() => $('#editCodeModal').modal('show')}>
                          <span className="codeEditing-icon" />
                        </div>
                      ) : ('')}
                    </div>
                  ) : ('')}

                  {boardType !== 'code' || saveForm.simulator?.mode !== SimulatorModes.AUTO ? (
                    <ArduinoSimulator workspace={demoWorkspace} board={tabInfo.board} code={codeGenerated} simulator={saveForm.simulator} changeState={this.updateSimulatorState} arduinoSimulatorToggle={arduinoSimulatorToggle} toggleSimulator={this.arduinoSimulatorToggleAction} />
                  ) : (null)}

                  {tabInfo.board.iaModel && (
                    <MLPanel
                      onChange={this.mlPanelToggleAction}
                      workspace={demoWorkspace}
                      iaModel={tabInfo.board?.iaModel || null}
                      iaDataSet={null}
                      className="codeBox blockly-mlPanel"
                      board={tabInfo.board || {}}
                      isCreabots={false}
                    />
                  )}

                  {(tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') ? (
                    <div className={`col-12 p-0 droneSimulationBox ${(droneSimulationToggle) ? 'droneSimulationBox-active' : ''}`}>
                      <div className="content-droneSimulationBox">
                        {/* <!-- Map preview modal --> */}
                        <div className="modal" id="mapPreviewModal" style={{ width: '100% !important', height: '100% !important' }} />
                        <div className={`droneArea ${(droneSimulationToggle) ? 'visible' : 'hidden'}`} id={`droneArea-${id}`}>
                          {/* <div className={`droneArea ${(droneSimulationToggle) ? 'visible' : 'hidden'}`} id="droneArea"> */}
                          <div id="toast-container" />
                          <div className="button-container">
                            <Tooltip disableFocusListener title="Comenzar simulación">
                              <button type="button" onClick={this.launchDroneSimulation} className="btn green" data-position="top" id="previewMission">
                                <span className="icon-media-play" />
                              </button>
                            </Tooltip>
                            <Tooltip disableFocusListener title="Resetear simulación">
                              <button type="button" onClick={this.resetDroneSimulation} className="btn green" data-position="top" id="resetSimulator">
                                <span className="icon-cancel" />
                              </button>
                            </Tooltip>
                            <Tooltip disableFocusListener title="Pantalla completa">
                              <button type="button" onClick={this.fullScreenDroneSimulation} className="btn green" data-position="top" id="fullScreen">
                                <span className="icon-fullscreen" />
                              </button>
                            </Tooltip>
                            <Tooltip disableFocusListener title="Mostrar/Ocultar grilla">
                              <button type="button" onClick={this.toggleGridDroneSimulation} className="btn green" data-position="top" id="toggleGrid">
                                <span className="icon-view-hide" id="toggleGrid-icon" />
                              </button>
                            </Tooltip>
                            {/* <button type="button" className="btn green" data-position="top" id="ringGen">
                              <i className="material-icons">panorama_fish_eye</i>
                            </button> */}
                            <Tooltip disableFocusListener title="Activar/Desactivar sonido">
                              <button type="button" className="btn green" data-position="top" id={`toogleSound-droneArea-${id}`}>
                                <span className="icon-mic" id={`toogleSound-icon-droneArea-${id}`} />
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="toggle-droneSimulationBox" style={(tabInfo.remoteSession && remoteSessionObj.id) ? { top: '135px' } : { top: '75px' }} onKeyPress={() => { }} role="button" tabIndex="0" onClick={this.droneSimulationToggleAction}>
                        <span className="droneSimulation-icon" />
                        <span className={`icon-chevron-left ${(droneSimulationToggle) ? 'rotate-arrow' : ''}`} />
                      </div>
                    </div>
                  ) : ('')}

                  {(tabInfo.active && tabInfo.remoteSession && remoteSessionObj.id) ? (
                    <div id="remoteThumbsBox" className={`col-12 p-0 remoteThumbsBox ${(remoteThumbsToggle) ? 'remoteThumbsBox-active' : ''}`}>
                      <div className="content-remoteThumbsBox scrolleable scroll-remote-session">
                        {((IAmTheOwner || IAmTheTheacher) && remoteSessionObj.projects.length > 0) ? (
                          <div className="teacher-bar">
                            <div className="teacher-students button-bar">
                              {(remoteSessionObj.teacher.settings.thumbsVisibilityAll === false) ? (
                                <Tooltip disableFocusListener title="Mostrar el código de los alumnos">
                                  <span className="icon-view-hide" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleSeeAll()} />
                                </Tooltip>
                              ) : (
                                <Tooltip disableFocusListener title="Ocultar el código de los alumnos">
                                  <span className="icon-view-show" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleSeeAll()} />
                                </Tooltip>
                              )}
                              {IAmTheOwner && (
                                <Tooltip disableFocusListener title="Cronómetro">
                                  <span className="icon-clock2" onKeyPress={() => { }} onClick={() => this.remoteToggleChronometerAll()} />
                                </Tooltip>
                              )}
                              <Tooltip disableFocusListener title="Iniciar videollamada">
                                <span className="icon-videocam" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleJitsiAll()} />
                              </Tooltip>
                              <Tooltip disableFocusListener title={(remoteSessionObj.teacher.settings.screenBlocked) ? 'Desbloquear las pantallas de los alumnos' : 'Bloquar las pantallas de los alumnos'}>
                                <span className={(remoteSessionObj.teacher.settings.screenBlocked) ? 'icon-desktop_access_disabled' : 'icon-display'} onKeyPress={() => { }} onClick={() => this.remoteThumbToggleScreenBlockAll()} />
                              </Tooltip>
                              <Tooltip disableFocusListener title="Destacar alumnos">
                                <span className="icon-thumb_up" onKeyPress={() => { }} onClick={() => $('#remoteSessionGamification').modal('show')} />
                              </Tooltip>
                              <Tooltip disableFocusListener title="Abrir menú de carga">
                                <span className="icon-media-play" onKeyPress={() => { }} onClick={() => $('#remoteSessionCompilationQueue').modal('show')} />
                              </Tooltip>
                              <Tooltip disableFocusListener title="Obtener enlace para compartir">
                                <span className="icon-feed-rss" onKeyPress={() => { }} onClick={() => $('#remoteSessionInvitationModal').modal('show')} />
                              </Tooltip>
                              <Tooltip disableFocusListener title={(remoteSessionObj.teacher.settings.boardAvailability) ? 'Habilitar carga de código' : 'Deshabilitar carga de código'}>
                                <span className={(remoteSessionObj.teacher.settings.boardAvailability) ? 'icon-check-square' : 'icon-minus-square'} onKeyPress={() => { }} onClick={() => this.remoteThumbToggleAvailabilityAll()} />
                              </Tooltip>
                              <Tooltip disableFocusListener title="Limpiar usuarios">
                                <span className="icon-bin" onKeyPress={() => { }} onClick={() => $('#remoteSessionDeleteAllModal').modal('show')} />
                              </Tooltip>
                            </div>
                            <div className="teacher button-bar">
                              {(remoteSessionObj.youtubeVideoSources.length > 1) ? (
                                <Tooltip disableFocusListener title="Mostrar cámaras">
                                  <span className="icon-videocam" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleYouTubeAll()} />
                                </Tooltip>
                              ) : ('')}
                              <Tooltip disableFocusListener title="Maximizar bloques del docente">
                                <span className="icon-expand" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleMaximize(MyProjectId)} />
                              </Tooltip>
                              <Tooltip disableFocusListener title={(!remoteSessionObj.teacher.settings.thumbsVisibility) ? 'Mostrar bloques del docente' : 'Ocultar bloques del docente'}>
                                <span
                                  className={(!remoteSessionObj.teacher.settings.thumbsVisibility) ? 'icon-view-hide' : 'icon-view-show'}
                                  onKeyPress={() => { }}
                                  onClick={() => this.remoteThumbToggleSeeOne(TheacherProjectId, remoteSessionObj.teacher.settings, true)}
                                />
                              </Tooltip>
                            </div>
                          </div>
                        ) : ('')}
                        {(tabInfo.active && tabInfo.remoteSession && remoteSessionObj.id) ? (
                          <div id="remoteYouTubeBox" className="youtube-box">
                            <div className="anibot-large-white contain" />
                            <div className="button-bar">
                              <div className="title-bar">Vivo</div>
                              {(IAmTheOwner || IAmTheTheacher) ? (
                                remoteSessionObj.youtubeVideoSources.map((source, index) => (
                                  (source.url !== '' && index > 0) ? (
                                    <span key={`span-${source.url}`} className={`icon-video-thumb ${(remoteSessionObj.teacher && remoteSessionObj.teacher.settings.youtubeVideoContent === index) ? 'active' : ''}`} onKeyPress={() => { }} onClick={() => this.remoteThumbToggleYouTubeSource(index)}>{index}</span>
                                  ) : ('')
                                ))
                              ) : ('')}
                              {(IAmTheOwner || IAmTheTheacher) ? (
                                <>
                                  <span className="icon-media-play" onKeyPress={() => { }} onClick={() => $('#remoteSessionCompilationQueue').modal('show')} />
                                  <span className="icon-expand" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleMaximize(MyProjectId)} />
                                  <span> | </span>
                                  <span className="icon-cancel" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleYouTubeAll()} />
                                </>
                              ) : ('')}
                            </div>
                            <div className="youtube-video" dangerouslySetInnerHTML={youTubeIframe((remoteSessionObj.teacher && remoteSessionObj.teacher.settings) ? remoteSessionObj.youtubeVideoSources[remoteSessionObj.teacher.settings.youtubeVideoContent] : {})} />
                          </div>
                        ) : ('')}
                        {(remoteSessionObj.projects.length <= 0) ? (
                          <div className="anibot-large-white contain" />
                        ) : (
                          remoteSessionObj.projects.map((p, index) => (
                            // <VizSensor
                            //   onChange={(isVisible) => {
                            //     if (!isVisible && remoteSessionObj.projectsIdVisibilityList.indexOf(p.Project.id) !== -1) {
                            //       remoteSessionObj.projectsIdVisibilityList.splice(remoteSessionObj.projectsIdVisibilityList.indexOf(p.Project.id), 1);
                            //     } else if (isVisible) {
                            //       remoteSessionObj.projectsIdVisibilityList.push(p.Project.id);
                            //     }
                            //     console.log('visible:', isVisible, p.Project.id, remoteSessionObj.projectsIdVisibilityList);
                            //   }}
                            // >
                            ((TheacherProjectId === OwnerProjectId
                              && IAmTheTheacher
                              && TheacherProjectId === p.Project.id)
                              || (TheacherProjectId !== OwnerProjectId
                                && ((IAmTheTheacher && TheacherProjectId === p.Project.id)
                                  || (OwnerProjectId === p.Project.id))
                              )) ? (
                                <div id={p.Project.id} className={`remote-thumbnail remote-thumb-${p.Project.id} hidden-teacher`}>
                                  <div className="icon-maximize icon-expand" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleMaximize(p.Project.id)} />
                                  <div className="top-bar">
                                    <div className="avatar-div">
                                      <img
                                        alt="Avatar"
                                        className="avatar"
                                        src={p.Project.User.avatarUrl || '/images/avatar_square_purple.png'}
                                        style={{ width: 36, borderRadius: '50%' }}
                                      />
                                      <div className="first-line">
                                        {`${p.Project.User.firstName} ${p.Project.User.lastName}`}
                                        {(p.settings && typeof p.settings.userRole !== 'undefined') ? (
                                          <span key={`second-line-${p.Project.id}`} className="second-line">{`${p.settings.userRole}`}</span>
                                        ) : (
                                          <span key={`second-line-${p.Project.id}`} className="second-line">Docente</span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="button-bar">
                                      {(MyBoardAvailable) ? (
                                        <Tooltip disableFocusListener title="Cargar bloques en la placa">
                                          <span className="icon-media-play green" onKeyPress={() => { }} onClick={() => this.buildBlockly()} />
                                        </Tooltip>
                                      ) : (
                                        <Tooltip disableFocusListener title="Carga deshabilitada">
                                          <span className="icon-media-play" />
                                        </Tooltip>
                                      )}
                                      {(OwnerProjectId !== TheacherProjectId) ? (
                                        <Tooltip disableFocusListener title="Cargar bloques en la placa remota">
                                          <span className={`icon-media-play ${(OwnerBoardAvailable) ? 'lilac' : ''}`} onKeyPress={() => { }} onClick={() => { if (OwnerBoardAvailable) { this.buildBlockly(null, OwnerProjectId); } }} />
                                        </Tooltip>
                                      ) : ('')}
                                      <Tooltip disableFocusListener title="Compartir">
                                        <span className={`icon-export ${(p.settings.teacherScreenMaximized) ? 'green' : ''}`} onKeyPress={() => { }} onClick={() => this.remoteThumbToggleMaximizeTeacherScreen(p.Project.id)} />
                                      </Tooltip>
                                      <Tooltip disableFocusListener title="Actualizar bloques de alumnos">
                                        <span className="icon-cycle" onKeyPress={() => { }} onClick={() => this.remoteThumbCopyTeacherScreen()} />
                                      </Tooltip>
                                    </div>
                                    <div className="button-open-close" />
                                  </div>
                                  {(boardType === 'code') ? (
                                    <div className="canvas-svg canvas-code">
                                      <div className="actual-code">
                                        {p.Project.jsonBody.code && p.Project.jsonBody.code.split(/(?:\r\n|\r|\n)/g).map((item) => (
                                          <div className="code-line">{(item === '') ? '\xa0' : item.replace(/\s/g, '\xa0')}</div>
                                        ))}
                                      </div>
                                    </div>
                                  ) : (
                                    <CanvasSVG
                                      content={`${remoteSessionObj.canvasCSS}${p.Project.jsonBody.canvas}`}
                                      svgX={p.Project.jsonBody.canvasBBoxX || 10}
                                      svgY={p.Project.jsonBody.canvasBBoxY || 10}
                                      svgWidth={p.Project.jsonBody.canvasBBoxWidth || 800}
                                      svgHeight={p.Project.jsonBody.canvasBBoxHeight || 500}
                                      width="90%"
                                      height="90%"
                                      backgroundColor="#0D1824"
                                    />
                                  )}
                                </div>
                              ) : (
                                <div id={p.Project.id} className={`remote-thumbnail remote-thumb-${p.Project.id} ${(!IAmTheTheacher && ((p.Project.id !== TheacherProjectId && !remoteSessionObj.teacher.settings.thumbsVisibilityAll) || !p.settings.thumbsVisibility)) ? 'folded' : ''}`}>
                                  <div className="icon-maximize icon-expand" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleMaximize(p.Project.id)} />
                                  {(MyBoardAvailable && compilationRequests.length > 0 && compilationRequests.find((item) => item.projectId === p.Project.id)) ? (
                                    <div className="compilation-request icon-media-play" onKeyPress={() => { }} onClick={() => this.buildBlockly(compilationRequests.find((item) => item.projectId === p.Project.id).id, MyProjectId)} />
                                  ) : ('')}
                                  <div className="top-bar">
                                    <div className="avatar-div">
                                      {(p.settings.gamification && Object.keys(p.settings.gamification).length > 0) ? (
                                        <div className="badge">{Object.keys(p.settings.gamification).length}</div>
                                      ) : ('')}
                                      <img
                                        alt="Avatar"
                                        className="avatar"
                                        onClick={() => {
                                          if (p.settings.gamification && Object.keys(p.settings.gamification).length > 0) {
                                            this.remoteSessionSeeGamificationBadges(index);
                                          }
                                        }}
                                        onKeyPress={() => { }}
                                        src={p.Project.User.avatarUrl && p.Project.User.avatarUrl !== 'NULL' ? p.Project.User.avatarUrl : '/images/avatar_square_purple.png'}
                                      />
                                      <div className="first-line">
                                        {`${p.Project.User.firstName} ${p.Project.User.lastName}`}
                                        {(p.settings && typeof p.settings.userRole !== 'undefined') ? (
                                          <span className="second-line">{`${p.settings.userRole}`}</span>
                                        ) : (
                                          <span className="second-line">{(p.Project.id === TheacherProjectId) ? 'Docente' : 'Alumno'}</span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="button-bar">
                                      {(IAmTheTheacher) ? (
                                        <Tooltip disableFocusListener title={(!remoteSessionObj.teacher.settings.thumbsVisibilityAll || !p.settings.thumbsVisibility) ? 'Mostrar bloques del alumno' : 'Ocultar bloques del alumno'}>
                                          <span
                                            className={(!remoteSessionObj.teacher.settings.thumbsVisibilityAll || !p.settings.thumbsVisibility) ? 'icon-view-hide' : 'icon-view-show'}
                                            onKeyPress={() => { }}
                                            onClick={() => { if (remoteSessionObj.teacher.settings.thumbsVisibilityAll) { this.remoteThumbToggleSeeOne(p.Project.id, p.settings); } }}
                                          />
                                        </Tooltip>
                                      ) : ('')}
                                      {(
                                        (p.Project.id === OwnerProjectId && OwnerBoardAvailable)
                                        || (p.Project.id === TheacherProjectId && (TeacherBoardAvailable || OwnerBoardAvailable))
                                        || (p.Project.id !== TheacherProjectId
                                          && remoteSessionObj.teacher.settings.boardAvailability
                                          && p.settings.boardAvailabilityState === 'AVAILABLE'
                                          && (p.Project.jsonBody.port !== '' || tabInfo.board.compilerBoard === 'microbit')
                                        )
                                      ) ? (
                                        <Tooltip disableFocusListener title={`Cargar bloques en la placa del ${(p.Project.id === TheacherProjectId) ? 'docente' : 'alumno'}`}>
                                          <span className="icon-media-play green" onKeyPress={() => { }} onClick={() => { if (MyProjectId === p.Project.id) { this.buildBlockly(); } else { this.buildBlockly(null, p.Project.id); } }} />
                                        </Tooltip>
                                        ) : ('')}

                                      {(IAmTheTheacher && (p.settings.boardAvailabilityState !== 'AVAILABLE' || !OwnerBoardAvailable)) ? (
                                        <Tooltip disableFocusListener title="Carga deshabilitada">
                                          <span className="icon-media-play disabled" />
                                        </Tooltip>
                                      ) : ('')}

                                      {(IAmTheTheacher && ((p.Project.id === MyProjectId && !MyBoardConnected) || (p.Project.id !== MyProjectId && (p.Project.jsonBody.port === '' && tabInfo.board.compilerBoard !== 'microbit')))) ? (
                                        <Tooltip
                                          disableFocusListener
                                          title={(
                                            (p.Project.id === MyProjectId && !MyBoardConnected)
                                            || (p.Project.id !== MyProjectId && (p.Project.jsonBody.port === '' && tabInfo.board.compilerBoard !== 'microbit'))
                                          ) ? 'Deshabilitar carga en la placa del alumno' : 'Habilitar carga en la placa del alumno'}
                                        >
                                          <span className={((p.Project.id === MyProjectId && !MyBoardConnected) || (p.Project.id !== MyProjectId && (p.Project.jsonBody.port === '' && tabInfo.board.compilerBoard !== 'microbit'))) ? 'icon-minus-square red' : 'icon-square-o yellow'} />
                                        </Tooltip>
                                      ) : ('')}
                                      {((IAmTheTheacher || (remoteSessionObj.teacher.settings.boardAvailability && p.settings.boardAvailabilityState === 'AVAILABLE')
                                      ) && ((p.Project.id === MyProjectId && MyBoardConnected) || (p.Project.id !== TheacherProjectId && p.Project.id !== MyProjectId && (p.Project.jsonBody.port !== '' || tabInfo.board.compilerBoard === 'microbit')))
                                      ) ? (
                                        <span
                                          className={((p.Project.id !== TheacherProjectId) && (p.settings.boardAvailabilityState === 'NOTAVAILABLE' || !remoteSessionObj.teacher.settings.boardAvailability)) ? 'icon-square-o yellow' : 'icon-check-square green'}
                                          onKeyPress={() => { }}
                                          onClick={() => { if (IAmTheTheacher && remoteSessionObj.teacher.settings.boardAvailability) { this.remoteThumbToggleAvailability(p.Project.id, p.settings); } }}
                                        />
                                        ) : ('')}

                                      {(IAmTheTheacher) ? (
                                        <Tooltip disableFocusListener title="Eliminar alumno">
                                          <span className="icon-times-circle" onKeyPress={() => { }} onClick={() => this.remoteSessionDeleteOneModal(p.Project.id, `${p.Project.User.firstName} ${p.Project.User.lastName}`)} />
                                        </Tooltip>
                                      ) : ('')}

                                      {(IAmTheOwner && p.settings && typeof p.userRole !== 'undefined') ? (
                                        <Tooltip disableFocusListener title="Convertir en profesor">
                                          <span className={`icon-bolt ${(p.userRole === 'TEACHER') ? 'green' : ''}`} onKeyPress={() => { }} onClick={() => this.remoteSessionSetUserAsTeacher(p)} />
                                        </Tooltip>
                                      ) : ('')}
                                    </div>
                                    <div className="button-open-close">
                                      {(IAmTheTheacher || (remoteSessionObj.teacher.settings.thumbsVisibilityAll && p.Project.id !== TheacherProjectId && p.settings.thumbsVisibility)) ? (
                                        <Tooltip disableFocusListener title="Minimizar bloques del alumno">
                                          <span className="icon-minus" onKeyPress={() => { }} onClick={() => this.remoteThumbToggleFold(p.Project.id)} />
                                        </Tooltip>
                                      ) : ('')}
                                    </div>
                                  </div>
                                  {(boardType === 'code') ? (
                                    <div className="canvas-svg canvas-code">
                                      <div className="actual-code">
                                        {p.Project.jsonBody.code && p.Project.jsonBody.code.split(/(?:\r\n|\r|\n)/g).map((item) => (
                                          <div className="code-line">{(item === '') ? '\xa0' : item.replace(/\s/g, '\xa0')}</div>
                                        ))}
                                      </div>
                                    </div>
                                  ) : (
                                    <CanvasSVG
                                      content={`${remoteSessionObj.canvasCSS}${p.Project.jsonBody.canvas}`}
                                      svgX={p.Project.jsonBody.canvasBBoxX || 10}
                                      svgY={p.Project.jsonBody.canvasBBoxY || 10}
                                      svgWidth={p.Project.jsonBody.canvasBBoxWidth || 800}
                                      svgHeight={p.Project.jsonBody.canvasBBoxHeight || 500}
                                      width="90%"
                                      height="90%"
                                      backgroundColor="#0D1824"
                                    />
                                  )}
                                  {(!IAmTheTheacher
                                    && ((p.Project.id !== TheacherProjectId
                                      && !remoteSessionObj.teacher.settings.thumbsVisibilityAll) || !p.settings.thumbsVisibility))
                                    ? this.remoteThumbCheckMaximized(p.Project.id) : ''}
                                  {(!IAmTheTheacher
                                    && p.Project.id === TheacherProjectId)
                                    ? this.remoteThumbToggleSeeTeacherScreen(p.Project.id, TeacherScreenMaximized) : ''}
                                  {(!IAmTheTheacher
                                    && p.settings.copyTeacherScreen)
                                    && p.Project.id === MyProjectId
                                    ? this.remoteSessionCopyTeacherScreen(index) : ''}
                                </div>
                              )
                            // </VizSensor>
                          ))
                        )}
                      </div>
                      <div id="remoteThumbsBox-drag" className="toggle-remoteThumbsBox-drag" onKeyPress={() => { }} role="button" tabIndex="0" onClick={this.remoteThumbsStartDragging} />
                      <div className="toggle-remoteThumbsBox" onKeyPress={() => { }} role="button" tabIndex="0" onClick={this.remoteThumbsToggleAction}>
                        <span className="remote-panel-icon" />
                        <span className={`icon-chevron-left ${(remoteThumbsToggle) ? 'rotate-arrow' : ''}`} />
                      </div>
                      {(!IAmTheOwner && OwnerProjectIndex !== null && remoteSessionObj.projects[OwnerProjectIndex].settings.chronometer) ? this.remoteToggleChronometer(remoteSessionObj.projects[OwnerProjectIndex].settings.chronometer.display) : ''}
                      {(!IAmTheTheacher && remoteSessionObj.teacher) ? this.remoteThumbToggleJitsi(remoteSessionObj.teacher.settings.jitsiVideoAll) : ''}
                      {(!IAmTheTheacher && remoteSessionObj.teacher) ? this.remoteThumbToggleYouTube(remoteSessionObj.teacher.settings.youtubeVideoContent) : 0}
                    </div>
                  ) : ('')}
                </>
              ) : ('')}
              {this.webSerialModal()}
              {this.connectionModal()}
              {/* {this.compilationNoticeModal()} */}
              {tabInfo.active && tabInfo.board.profile === 'codit' ? (
                <BottomNavCodit
                  shootMsg={this.shootMsg}
                  codit={codit}
                  bloquesReducer={bloques}
                  id={id}
                  actualWidth={actualWidth}
                  buildingFunction={this.buildBlocklyCodit}
                  toolboxToggle={toolboxToggle}
                />
              ) : null}
              {tabInfo.active && (tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') ? (
                <BottomNavDrone
                  shootMsg={this.shootMsg}
                  drone={drone}
                  bloquesReducer={bloques}
                  id={id}
                  actualWidth={actualWidth}
                  buildingFunction={this.buildBlocklyDrone}
                  toolboxToggle={toolboxToggle}
                />
              ) : null}
              {tabInfo.board.profile !== 'drone' && tabInfo.board.profile !== 'drone13' && tabInfo.board.profile !== 'codit' ? (
                this.bottomNav()
              ) : null}
            </div>
          </div>
          {(blocklyInited && canShowStep) ? (
            <Steps
              enabled={true}
              initialStep={0}
              steps={steps}
              onExit={this.endSteps}
              options={options}
            />
          ) : ('')}
          {this.loaderOverAll()}
        </div>
      </div>
    );
  }
}

BlocklyPanel.defaultProps = {
  onClosePanel: () => { },
};

const mapStateToProps = (state) => ({
  bloques: state.bloquesReducer,
  rightPanel: state.rightPanelReducer,
  auth: state.authReducer,
  projects: state.projectsReducer,
  remoteSession: state.remoteSessionReducer,
  assignmentSession: state.assignmentSessionReducer,
  getAssignmentDeliverableState: actionGetAssignmentDeliverableState(state),
  blocklyState: state.blockly,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setMLActive,
    projectsPost: actionProjectsPost,
    projectsPut: actionProjectsPut,
    boardConnectionInfoPost: actionBoardConnectionInfoPost,
    projectsSaveAsCode: actionProjectsSaveAsCode,
    projectsDelete: actionProjectsDelete,
    resetStatus: actionResetStatus,
    GRPD: getRightPanelData,
    projectTagsPost: actionProjectTagsPost,
    remoteSessionStreamGet: actionRemoteSessionStreamGet,
    remoteSessionRefresh: actionRemoteSessionRefresh,
    remoteSessionProjectsPost: actionRemoteSessionProjectsPost,
    resetRemoteSessionStatus: actionResetRemoteSessionStatus,
    remoteSessionProjectUpdate: actionRemoteSessionProjectUpdate,
    remoteSessionProjectDelete: actionRemoteSessionProjectDelete,
    remoteSessionProjectDeleteOne: actionRemoteSessionProjectDeleteOne,
    putRemoteSessionProjectBulk: actionPutRemoteSessionProjectBulk,
    putRemoteSessionCompilation: actionPutRemoteSessionCompilation,
    postRemoteSessionCompilation: actionPostRemoteSessionCompilation,
    putBulkRemoteSessionCompilation: actionPutBulkRemoteSessionCompilation,
    putRemoteSession: actionPutRemoteSession,
    remoteSessionLoginGet: actionRemoteSessionLoginGet,
    assignmentSessionProjectsPost: actionAssignmentSessionProjectsPost,
    assignmentSessionProjectUpdate: actionAssignmentSessionProjectUpdate,
    assignmentSessionRefresh: actionAssignmentSessionRefresh,
    resetAssignmentSessionStatus: actionResetAssignmentSessionStatus,
    setAssignmentDeliverableState: actionSetAssignmentDeliverableState,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BlocklyPanel));
